const FormPageData = [
  {
    id: 991,
    form: `MLC`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-1.png",
    description: `<p>This contract outlines the professional relationship between the 
    Seller and the REALTOR®'s Brokerage, as well as the terms of the contract as agreed 
    to by all parties. This contract is used when the property is to be listed on the 
    MLS® system. If the property is not being listed on the MLS® system, use the 
    Exclusive Listing Contract form instead.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Seller Information: </strong>Insert the full legal names 
        of all Sellers as noted on the Title Document. Double check your clients IDs 
        to ensure accuracy. Insert the address where they currently live. Ensure you 
        verify the sellers current address as it may differ from the address that is 
        on Title.<br/><br/>
        <strong>Brokerage Information: </strong>Insert the full Brokerage 
        name as well as the other information requested in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Effective Date: </strong>Insert the date that this contract 
        starts. Typically it is the same date as when it is signed/delivered. If all 
        parties agree that the date is to be a future date, insert that date. It cannot 
        be a date that is before the contract is signed/delivered.<br/><br/>
        <strong>Expiry Date: </strong>Insert the date that this contract expires. It's 
        important to note that while this date is negotiable, some real estate boards 
        MLS rules have minimum listing periods.  
        </p>`,
      },
      {
        x: `1%`,
        y: `50%`,
        data: `<p><strong>Seller Authorizations: </strong>The Seller authorizes the 
        Listing Brokerage to (i) obtain property information from authorities and share 
        it with others, (ii) advertise and show the property to buyers, (iii) control all 
        advertising unless permission is given to other boards, (iv) place “For Sale” and 
        “Sold” signs on the property, and (v) allow cooperating Brokerages, and with 
        written consent, sub-agents, to show the property to buyers.</p>`,
      },
      {
        x: `1%`,
        y: `69%`,
        data: `<p><strong>Property: </strong> Insert the full civic address, PID 
        (parcel identifier), and legal description as shown in the title 
        search. It is important to cross reference this information with other sources
        such as BC Assessment to ensure accuracy. 
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 992,
    form: `MLC`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>List Price and Terms: </strong>This section specifies the 
        price at which the broker will list and advertise the property. The Seller 
        may still accept offers above or below the list price. Add any extra terms 
        the Seller wants to include here. 
        </p>`,
      },
      {
        x: `1%`,
        y: `82%`,
        data: `<p><strong>Total Commission: </strong> Insert the amount 
        of commission the listing Brokerage will receive under this contract. As per 
        the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 993,
    form: `MLC`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },

      {
        x: `1%`,
        y: `17%`,
        data: `<p><strong>Cooperating Brokerage Commission: </strong> Insert the amount 
        of commission that will be offered to a cooperating Brokerage, if one exists. 
        As per the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `28%`,
        data: `<p><strong>Listing Brokerage Commission Remaining: </strong> If a 
        Cooperating Brokerage is involved, insert the amount of commission that will 
        be retained by the listing Brokerage. <br/><br/>
        <strong> The amount inserted here = Total Commission - Cooperating Brokerage 
        Commission.</strong>
        </p>`,
      },
      {
        x: `1%`,
        y: `41%`,
        data: `<p><strong>Listing Brokerage Commission (if no Cooperating Brokerage): 
        </strong> If there is no Cooperating Brokerage, insert the amount of 
        commission that the listing Brokerage will receive.<br/><br/>

        <strong>This amount should be the same as the Total Commission located in 5D (i).</strong>
        </p>`,
      },
      {
        x: `1%`,
        y: `78%`,
        data: `<p><strong>Designated Agent: </strong>Insert the name(s) of the 
        designated agent(s) for the property. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 994,
    form: `MLC`,
    page: `4`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 995,
    form: `MLC`,
    page: `5`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 996,
    form: `MLC`,
    page: `6`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 997,
    form: `MLC`,
    page: `7`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 998,
    form: `MLC`,
    page: `8`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `34%`,
        data: `<p><strong>Contract Signed, Sealed, and Delivered Date: </strong>Insert 
         the date that the contract was signed, sealed, and delivered.  The date must 
         not be inserted until the last party signs. This date must be on or before 
         the effective (start) date of the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Seller Declaration: </strong>The Seller must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Seller is unsure of their residency status, 
        they should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Seller Signature/Printed Name: </strong>Complete this 
        section by having all Sellers sign the contract.  You may only act as a 
        witness for the Sellers signature if you are present and watch them sign. In 
        the case of a Power of Attorney (POA), the individual signing would be their 
        name followed by "as POA for (full legal name of the individual)".
        </p>`,
      },
      {
        x: `1%`,
        y: `63%`,
        data: `<p><strong>Managing Broker/Designated Agent Signatures: </strong> 
        Complete this section by having the Managing Broker/Designated Agent sign the 
        contract. Additionally, insert the full Brokerage name and the printed name of 
        the designated agent in their respective locations.
        </p>`,
      },
    ],
  },
  {
    id: 999,
    form: `MLC`,
    page: `9`,
    imageURL: "../../images/BritishColumbia/forms/Listing/MLC/MLC-9.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>List of Services Provided to the Seller: </strong>This 
        Schedule is where 
        you  must outline the services you will provide to the Client. It should be 
        treated as a living document, evolving as you expand your list of 
        services.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1001,
    form: `CPS-res`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-1.png",
    description: `<p>The Contract of Purchase and Sale (CPS) stands as 
    the primary document employed in acquiring residential resale properties. As you 
    complete this contract, it is imperative to cross-reference all property 
    details with secondary sources like the Land Title Document. While the listing 
    agent bears the responsibility of ensuring listing accuracy, it remains crucial 
    to undertake thorough due diligence for your client, refraining from solely 
    depending on the listing information.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Contract: </strong>Once signed by both Buyer and Seller, the contract becomes 
        legally binding; however, the Buyer has the right to cancel (rescind) within 
        the set period under the Property Law Act, and if this right is exercised, 
        the contract ends and deposits are returned according to the rules.</p>`,
      },
      {
        x: `1%`,
        y: `25.5%`,
        data: `<p><strong>Deposits: </strong>Deposits are placed with a Brokerage as a neutral stakeholder, 
        not for either party's immediate use; they can only be released with 
        written agreement from both parties or by court order, and if the Buyer 
        cancels under their legal rescission rights, the deposit must be returned.</p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Completion: </strong>The transaction is finalized by exchanging money and legal 
        documents through lawyers or notaries at the Land Title Office, with the 
        Buyer's lawyer releasing funds only once the title is properly registered in 
        the Buyer's name; to avoid delays, funds should be deposited a couple of 
        days before the completion date, and Saturday completions are discouraged 
        because many offices and lenders do not operate then.</p>`,
      },
      {
        x: `1%`,
        y: `72.5%`,
        data: `<p><strong>Possession: </strong>The Buyer is entitled to take possession of the property only 
        after the Seller has received the sale proceeds, and if the property is 
        tenanted, possession is subject to the rules and timelines set out in the 
        Residential Tenancy Act.</p>`,
      },
      {
        x: `1%`,
        y: `77.5%`,
        data: `<p><strong>Title: </strong>It is the Buyer's responsibility to ensure 
        the property's zoning, building use restrictions, environmental hazards, and 
        encumbrances are acceptable, since the Seller is only bound to clear issues 
        specifically listed in the contract; if the Buyer's lender is not satisfied 
        with the title or restrictions, the lender may refuse financing, leaving the 
        Buyer still responsible for the mortgage unless arrangements are made.</p>`,
      },
    ],
  },
  {
    id: 1002,
    form: `CPS-res`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-2.png",

    hotspots: [
      {
        x: `1%`,
        y: `8.5%`,
        data: `<p><strong>Customary Costs: </strong>Both Buyer and Seller will 
        typically have to cover specific legal and transaction-related costs: the 
        Seller usually pays for things like discharge fees, title investigations, 
        prepayment penalties, and real estate commissions, while the Buyer usually 
        pays for title registration, mortgage-related fees, surveys, insurance, 
        property transfer tax, and applicable GST or sales taxes.</p>`,
      },
      {
        x: `1%`,
        y: `46.5%`,
        data: `<p><strong>Closing Matters: </strong>Certain legal documents must be 
        reviewed and approved by the Buyer's lawyer/notary and provided to the 
        Seller's lawyer/notary before closing; lawyers/notaries will then coordinate 
        final execution and ensure that all outstanding matters are addressed 
        before the sale completes.</p>`,
      },
      {
        x: `1%`,
        y: `56.5%`,
        data: `<p><strong>Risk: </strong>The Buyer assumes risk for the property 
        once completion occurs, and insurance should be in place starting at 
        12:01 a.m. on the completion date to protect against potential loss.</p>`,
      },
      {
        x: `1%`,
        y: `59.5%`,
        data: `<p><strong>Form of Contract: </strong>This contract is primarily 
        intended for standard residential freehold properties, but if the 
        transaction involves unique circumstances (e.g., new builds, businesses, 
        land under special agreements, or special zoning), additional clauses or 
        professional advice may be required.</p>`,
      },
      {
        x: `1%`,
        y: `71%`,
        data: `<p><strong>REALTOR® Code: </strong>A REALTOR® cannot buy, sell, or 
        otherwise benefit from a property transaction for themselves, family, or 
        related entities without fully disclosing their interest in writing to 
        all parties, in compliance with the Real Estate Services Rules.</p>`,
      },
      {
        x: `1%`,
        y: `82.5%`,
        data: `<p><strong>Residency: </strong>Both Buyer and Seller must confirm 
        their residency and citizenship status, since this affects tax obligations; 
        professional advice from a lawyer or accountant is recommended for accurate 
        handling.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Agency Disclosure: </strong>All agents involved in 
        representing the Buyer or Seller must be identified in writing, and if 
        additional agents are designated, their names must be added to the 
        contract.</p>`,
      },
    ],
  },
  {
    id: 1003,
    form: `CPS-res`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-3.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Brokerage Information: </strong>Include the Brokerage's information 
        as displayed in this section. If applicable, include the MLS number of the 
        listing that the Buyer is making an offer on. In the "Prepared By" line, 
        include the name of the agent that is preparing the offer.</p>`,
      },

      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>Buyer/Seller Information: </strong>Input the full 
        legal names of both Buyers and Sellers. For Sellers, verify and insert their 
        names as they appear on title, along with the current addresses where they 
        reside. Check with the Seller's REALTOR® to obtain the Seller's current 
        address if it is not available in the Title Document.
        Take the extra step of cross-referencing your clients' IDs to guarantee 
        accuracy. If the client is a corporation, be sure to obtain documents, 
        such as the Articles of Incorporation, to confirm signing authority. 
        </p>`,
      },
      {
        x: `1%`,
        y: `36%`,
        data: `<p><strong>Property Information: </strong>Insert the full details 
        of the property as they are shown in the Title Document. Insert all PID(s) 
        (Parcel Identifier) associated with the property. In the box below, insert 
        the full legal description of the property as it appears in the title document.
        Do not copy this information from the listing as discrepancies may exist.
        </p>`,
      },
      {
        x: `1%`,
        y: `55.5%`,
        data: `<p><strong>Purchase Price: </strong>This is the price the Buyer is 
        offering for the property. It's important to confirm that the price is 
        consistent in both numerical and textual formats (example: $500,000 / Five 
        Hundred Thousand). This price includes all applicable GST, unless otherwise 
        agreed to in writing. If a counter offer occurs, ensure number/text formats 
        remain consistent.</p>`,
      },
      {
        x: `1%`,
        y: `71.5%`,
        data: `<p><strong>Rescission Amount: </strong>If the property qualifies as 
        “residential real property” and the Buyer cancels the deal under their legal 
        rescission right, the Buyer must pay the Seller a rescission fee 
        (the “Rescission Amount”) as outlined in this section. This amount is set by 
        law, and if there's any conflict between the contract and the regulation, 
        the regulation is what counts. The Buyer must pay this fee within 14 days 
        of canceling the contract.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1004,
    form: `CPS-res`,
    page: `4`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-4.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `7.5%`,
        data: `<p><strong>Deposit: </strong>Insert the amount of the deposit to be 
        paid by the Buyer as part of the contract. The deposit is part of the 
        purchase price and must be paid in the way and to the person specified in 
        the contract. Unless stated otherwise, it's due within 24 hours of the 
        offer being accepted. Paying the deposit is an essential requirement—if the 
        Buyer doesn't pay on time, the Seller may choose to cancel the contract. 
        Any Deposit payments that are late require the REALTOR® to notify their 
        Managing Broker.
        </p>`,
      },
      {
        x: `1%`,
        y: `17.5%`,
        data: `<p><strong>Deposit Holder: </strong>Insert where the deposit will be held. 
        This is typically the Buyer's Brokerage in most circumstances. Ensure you enter 
        the full name of the Brokerage. The deposit is held by a neutral 
        stakeholder and can't be released until the money clears and both Buyer 
        and Seller agree, unless the Buyer cancels using their legal rescission 
        right. If the Buyer cancels, part of the deposit equal to the rescission 
        fee goes to the Seller, and any leftover deposit is returned to the Buyer. 
        If the deposit isn't enough to cover the fee, the Buyer must pay the 
        difference directly to the Seller.
        </p>`,
      },
      {
        x: `1%`,
        y: `47.5%`,
        data: `<p><strong>Terms & Conditions: </strong>Add all applicable terms and 
        conditions pertaining to the Contract in this section. It is strongly advised 
        to utilize the BCREA/BCFSA approved terms/conditions which are available 
        to all BC REALTORS®. For any customized clauses, it's essential to seek legal 
        advice/Managing Broker to ensure they are drafted correctly and protect your 
        clients' best interests.
        Only terms/conditions pertaining to the Buyers/Sellers should be 
        included in this section. Any conditions must be either fulfilled/waived in 
        a timely manner, using proper procedures, otherwise the contract may not be 
        enforceable.<br/>
        Any statements or acknowledgements made by a party to someone who is not part 
        of the contract (for example, their REALTOR®) should be recorded separately 
        and not included in the contract itself.<br/><br/>
        **See the clause section within the Transaction Checklists for commonly used 
        terms and conditions.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1005,
    form: `CPS-res`,
    page: `5`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-5.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `7%`,
        data: `<p><strong>Completion Date: </strong> This is the proposed date of 
        completion (the date that the money changes hands and the title will be 
        transferred to the Buyer). 
        It is strongly advised that the date placed here is not a weekend or holiday.
        </p>`,
      },
      {
        x: `1%`,
        y: `11.5%`,
        data: `<p><strong>Possession Date: </strong> Insert the date/time of 
        possession, typically the day after the completion date. 
        This can mean when the Buyer can physically move in (physical) or just 
        becoming the legal owner while tenants remain. Usually, both happen at the 
        same time, but not always—and the Buyer can't move in until the Seller has 
        been paid. It is important to consider that if the property is tenanted and 
        the Buyer wants vacant possession, enough notice must be given so the Seller 
        can legally end the tenancy and provide vacant possession. If possession is 
        subject to any tenancies, they must be listed in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `17.5%`,
        data: `<p><strong>Adjustments: </strong> The adjustment date, often the same 
        as possession, is when the Buyer begins paying property expenses like taxes, 
        fees, and utilities, and also starts receiving any income, such as rent, from 
        the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `23%`,
        data: `<p><strong>Included Items: </strong> As per the pre-printed statement, 
        fixtures are included in the purchase price, unless otherwise stated below in 
        the "but excluding" section.  Insert any additional items (chattels) such as: 
        appliances, garage door remotes, mirrors not fixed to the walls...etc. that 
        are to be included in the Purchase Price. It is important to be as detailed 
        as possible when describing these items. Some items such as fixed tv mounts 
        have been greatly debated as to whether they need to be included. As a rule 
        of thumb, "if in doubt, include it" so that it is clear to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>But Excluding: </strong>These are items that are attached 
        to the home but the Seller wishes to exclude them from the sale. One reason 
        may be that the item listed has sentimental value like a lighting fixture. 
        Precision is key when itemizing excluded items, for instance, specifying 
        "master bedroom light fixture."
        </p>`,
      },
      {
        x: `1%`,
        y: `47%`,
        data: `<p><strong>Viewed: </strong>Insert the date(s) that the Buyer viewed 
        the property. The Seller agrees as per this statement that the property, and 
        all included items, will be in the same condition when the Buyers take 
        possession of the property. If the Buyer did not view the property, you may 
        require additional terms and conditions. Consult your Managing Broker for 
        guidance in cases where the Buyer did not view the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `51%`,
        data: `<p><strong>Title: </strong>This statement confirms that the Seller 
        must transfer ownership with a clear title, except for any encumbrances 
        specifically agreed to in the contract, and both parties should get legal 
        advice to confirm which encumbrances need to be cleared before closing.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Tender: </strong>This item outlines the acceptable methods 
        of payment, which include a certified cheque, bank draft, lawyer/notary 
        trust cheque, and real estate Brokerage trust cheques.<br/><br/>
        <strong>Documents: </strong>All documents needed to complete the sale must 
        be properly prepared and in a form that can be registered with the Land 
        Title Office by the completion date.<br/><br/>
        <strong>Sellers Particulars and Residency: </strong>By the completion date, 
        the Seller must provide sworn declarations about tax matters to help the 
        Buyer's lawyer or notary prepare closing documents and determine if taxes 
        like the Speculation and Vacancy Tax or Empty Homes Tax apply, or if the 
        Buyer needs to withhold money for the Seller's income tax.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1006,
    form: `CPS-res`,
    page: `6`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-6.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>GST Certificate: </strong>If the sale is GST-exempt, the 
        Seller must give the Buyer a GST exemption certificate by the completion 
        date. If GST does apply, both the Buyer and Seller must exchange GST 
        certificates by the completion date.</p>`,
      },
      {
        x: `1%`,
        y: `23%`,
        data: `<p><strong>Time: </strong>This statement reiterates the fact that 
        "time is of the essence" which means that all parties to the contract must 
        adhere to the dates/deadlines set out in the contract. Failure to do so can 
        result in serious consequences.</p>`,
      },
      {
        x: `1%`,
        y: `32%`,
        data: `<p><strong>Buyer Financing: </strong>If the Buyer needs a new 
        mortgage to complete the purchase, the lender won't release funds until both 
        the transfer and the mortgage are submitted for registration. To avoid 
        delays, the Buyer's lawyer can start the registration process on the 
        completion date before receiving the mortgage money, as long as the Buyer 
        has met all mortgage conditions, provided their share of the funds, and the 
        lawyer has given the Seller's lawyer the standard legal assurances.</p>`,
      },
      {
        x: `1%`,
        y: `51%`,
        data: `<p><strong>Clearing Title: </strong>If the Seller still has mortgages or 
        other financial charges on the property, they can use the Buyer's purchase 
        funds on the completion date to pay them off. The lawyers will handle paying 
        out and discharging these charges, then give the Seller any remaining balance 
        from the Purchase Price.</p>`,
      },
      {
        x: `1%`,
        y: `60.5%`,
        data: `<p><strong>Costs: </strong>The Buyer must pay for expenses related to 
        financing and transferring the title, while the Seller covers the cost of 
        providing a clear title. Legal costs include both professional fees and 
        disbursements (such as Land Title Office charges, property transfer tax, 
        mortgage payout penalties, and courier or photocopying fees). These 
        disbursements can be significant, so both parties should review them with their 
        lawyers to understand what to expect.</p>`,
      },
      {
        x: `1%`,
        y: `64.5%`,
        data: `<p><strong>Risk: </strong>The Buyer becomes responsible for the property 
        at 12:01 a.m. on the Completion Date and should have insurance in place starting 
        at that time to protect against any loss or damage.</p>`,
      },
      {
        x: `1%`,
        y: `70.5%`,
        data: `<p><strong>Plural: </strong>References to Buyer(s) or Seller(s) include 
        their heirs and executors. The contract continues if a party dies, and singular, 
        plural, masculine, or feminine terms apply as needed.</p>`,
      },
      {
        x: `1%`,
        y: `74.5%`,
        data: `<p><strong>Representations and Warranties: </strong>The contract includes 
        only what is written in the CPS; outside promises are not binding unless 
        referenced. Certain terms, like warranties, survive completion and can still be 
        enforced after closing.</p>`,
      },
      {
        x: `1%`,
        y: `80.5%`,
        data: `<p><strong>Personal Information: </strong>By signing the CPS, Buyers and 
        Sellers consent to REALTORS® collecting, using, and disclosing their personal 
        information as required for the transaction, in line with privacy laws and the 
        Privacy Notice and Consent form.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1007,
    form: `CPS-res`,
    page: `7`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-7.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `31%`,
        data: `<p><strong>Assignment of Remuneration: </strong>Authorizes payment of the 
        REALTOR® commission directly from the sale proceeds by the Buyer or their 
        representative.</p>`,
      },
      {
        x: `1%`,
        y: `36.5%`,
        data: `<p><strong>Restriction on Assignment: </strong>The contract cannot be 
        assigned without the Seller's written consent, and any profit from an assignment 
        goes to the Seller. This restriction cannot be changed without written 
        instructions, and REALTORS® must disclose if it is not included. It is the 
        Buyer's REALTOR®'s responsibility to provide the "Notice to Seller Regarding 
        Assignment Terms" to the Seller's REALTOR® at the same time the offer is 
        presented.</p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p><strong>Agency Disclosure: </strong>Confirms the Buyer's and Seller's 
        agency relationships with their REALTORS®. All agents, co-listings, or Personal 
        Real Estate Corporations must be identified, with extra details added in the 
        contract or addendum if needed.<br/><br/>
        Have your clients initial the boxes that apply to the transaction as well as 
        insert the designated agent(s) and Brokerage involved.
        <ul >
          <li><strong>A:</strong> Seller acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>B:</strong> Buyer acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>C:</strong> In limited situations where dual agency is allowed, complete this 
          section with the appropriate information.</li>
          <li><strong>D (next page):</strong> To be completed if the Seller has an agency 
          relationship with a REALTOR® and the Buyer does not. Buyer initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
          <li><strong>E (next page):</strong> To be completed if the Buyer has an agency 
          relationship with a REALTOR® and the Seller does not. Seller initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1008,
    form: `CPS-res`,
    page: `8`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-8.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Acceptance Irrevocable: </strong>By initialing this section, 
        both the Buyers and Sellers confirm the contract is made “under seal.” The 
        Seller cannot revoke (back out of) an accepted conditional offer until the 
        Buyer's conditions are removed or any contract options expire.
        </p>`,
      },
      {
        x: `1%`,
        y: `59.5%`,
        data: `<p><strong>Disclosure of Buyer Rescission Right: </strong>Both parties 
        acknowledge that, unless exempt, the Buyer may cancel the contract within the 
        legal rescission period by written notice. Initials are required to confirm 
        this disclosure under real estate law. Read the terms and understand the 
        process to carry this out. The next page continues the exemptions from the 
        Rescission Right.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1009,
    form: `CPS-res`,
    page: `9`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-9.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `32%`,
        data: `<p><strong>24: </strong>This statement stresses the importance that 
        all parties read the document and information page fully before signing.</p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Counterparts: </strong>The contract and any amendments may be 
        signed in separate copies and delivered by email, fax, or other electronic means. 
        All counterparts together are treated as one original document.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10010,
    form: `CPS-res`,
    page: `10`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-10.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `9%`,
        data: `<p><strong>Offer: </strong>Fully complete this section by 
        inserting the time and date of when this offer will be open for acceptance. 
        The offer or counter-offer remains open until the specified date and time unless 
        withdrawn in writing first. Once accepted in writing and notice is given, it 
        becomes a binding contract. If the offer is being countered, "counter-offer" 
        should be circled to indicate that it is a counter-offer. If new times are 
        needed, they should be amended and initialed each time a counter-offer is made.
        </p>`,
      },
      {
        x: `1%`,
        y: `23.5%`,
        data: `<p><strong>Buyer Declaration: </strong>The Buyer must initial in the 
        Yes or No box to declare whether they are a Canadian citizen or permanent 
        resident. If the Buyer is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `31%`,
        data: `<p><strong>Buyer Signature/Printed Name: </strong>Complete this 
        section by having all Buyers sign the offer along with their printed name. 
        You may only act as a witness for the Buyers signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Acceptance: </strong> By signing, the Seller accepts the offer 
        subject to any conditions. Once conditions are met or waived, the Seller must 
        complete the sale. Signatures should be witnessed where possible, and authority 
        must be shown if signing for another. The Seller must also provide contact 
        details (or their REALTOR®'s) for receiving any Buyer rescission notices.</p>`,
      },
      {
        x: `1%`,
        y: `60%`,
        data: `<p><strong>Seller Declaration: </strong>The Seller must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Seller is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `68%`,
        data: `<p><strong>Seller Signature/Printed Name: </strong>Complete this 
        section by having all Sellers sign the offer along with their printed name. 
        You may only act as a witness for the Sellers signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `80%`,
        data: `<p><strong>Final Acceptance Date: </strong>Insert the date of when 
        final acceptance 
        occurred. The Seller must also provide contact details (or their REALTOR®'s) 
        for receiving any Buyer rescission notices.</p>`,
      },
    ],
  },
  {
    id: 10011,
    form: `CPS-res`,
    page: `11`,
    imageURL: "../../images/BritishColumbia/forms/CPS-res/CPS-11.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `11%`,
        data: `<p><strong>Rescission Right Notice: </strong>Notice of rescission is 
        considered delivered on the day it is sent if done according to the Home Buyer 
        Rescission Period Regulation, and email notices must request a read receipt. The 
        last party to sign the CPS must record the acceptance date and the deadline for 
        rescission. The deadline is 3 clear business days after acceptance (excluding 
        weekends and statutory holidays), ending at 11:59:59 p.m. on the third day. If a 
        Buyer wishes to cancel, notice must be served in the proper way and within this 
        time frame, and if any details conflict with the Regulation, the Regulation 
        prevails. Sellers may insert their REALTOR®'s contact details if they wish 
        to receive such notices through their REALTOR®.</p>`,
      },
      {
        x: `1%`,
        y: `80.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1011,
    form: `CPS-addendum`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-addendum/CPS-addendum.png",
    description: `<p>The Contract of Purchase and Sale (CPS) Addendum/Amendment form 
    is used to change or clarify a Contract of Purchase and Sale. An addendum is 
    added at the time of signing to include extra terms or conditions, while an 
    amendment is used after signing to change terms already agreed upon. 
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Property Information: </strong>Complete this section by 
        inputting the MLS number, Date of the Amendment/Addendum, Property Address, 
        Legal Description, and PID(s).</p>`,
      },
      {
        x: `1%`,
        y: `28.5%`,
        data: `<p><strong>Dated/Party Information: </strong>Insert the date here. This 
        date refers to the date of the Contract of Purchase and Sale that it relates 
        to. If it is an addendum, this date will likely be the same date as the CPS. 
        If it is an amendment, the date is likely to be different from the CPS as it 
        is proposing changes to the already agreed upon CPS.
        Additionally, include the full names of the Buyers and Sellers involved in 
        the transaction.
        </p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Terms and Conditions: </strong>Insert any additional terms 
        and conditions that will form part of the Contract.</p>`,
      },
      {
        x: `1%`,
        y: `71%`,
        data: `<p><strong>Buyer/Seller Signatures: </strong> Complete this section by 
        having all Buyers/Sellers sign along with their printed name. You may only 
        act as a witness for the signatures if you are present and watch them sign.
        By signing, all parties confirm their agreement to add the terms or 
        conditions in this document to the Contract of Purchase and Sale.</p>`,
      },
    ],
  },
  {
    id: 1021,
    form: `CPS-nothird`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-1.png",
    description: `<p>This Contract of Purchase and Sale (CPS) is specifically for 
    the purchase of property on First Nations reserve lands where 3rd party 
    approval is not required.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Contract: </strong>Once signed by both parties, the CPS 
        is a legally binding contract, so all agreed terms must be in writing. Any 
        deposit shortfall must be paid directly by the Buyer.</p>`,
      },
      {
        x: `1%`,
        y: `24%`,
        data: `<p><strong>Deposit(s): </strong>Deposits are held by the Brokerage 
        as a neutral stakeholder and cannot be released without written agreement 
        from both parties or a court order if there is a dispute.</p>`,
      },
      {
        x: `1%`,
        y: `35.5%`,
        data: `<p><strong>Third Party Approval: </strong>This contract should only 
        be used if no third-party approvals, such as government or First Nations 
        authority approval, are required for completion.</p>`,
      },
      {
        x: `1%`,
        y: `41.5%`,
        data: `<p><strong>Terms and Conditions: </strong>The Buyer must be satisfied 
        with the lease documents in Schedule A and is strongly encouraged to have 
        a lawyer review them before proceeding.</p>`,
      },
      {
        x: `1%`,
        y: `47.5%`,
        data: `<p><strong>Trust Completion: </strong>The trust completion date is 
        when documents and funds are exchanged in trust. The Buyer's lawyer prepares 
        documents, the Seller signs them, and funds are deposited before 
        registration. Insurance must be in place if possession occurs before final 
        completion.</p>`,
      },
      {
        x: `1%`,
        y: `75%`,
        data: `<p><strong>Final Completion: </strong>The sale is finalized once the 
        Assignment of Lease is registered, and the Buyer's lawyer must notify the 
        Seller's lawyer when registration is complete.</p>`,
      },
    ],
  },
  {
    id: 1022,
    form: `CPS-nothird`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Possession: </strong>Possession is granted on or after 
        final completion, or earlier on the trust completion date if agreed, 
        provided the Buyer has proper insurance and financing in place.</p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Included Items: </strong>If movable items, such as a 
        manufactured home, are included in the sale, separate transfer documents may 
        be required, and legal advice is recommended.</p>`,
      },
      {
        x: `1%`,
        y: `30%`,
        data: `<p><strong>Title: </strong>The Buyer must confirm zoning, 
        restrictions, hazards, and encumbrances before being bound, while the Seller 
        must disclose any encumbrances that remain. Mortgage lenders may refuse 
        funding if issues are unacceptable, and Sellers allowing mortgage assumption 
        may still remain liable unless released by the lender.</p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Customary Costs: </strong>Sellers usually pay costs such 
        as clearing title, real estate commissions, and their lawyer's fees. Buyers 
        cover financing expenses, title searches, insurance, surveys, taxes, and 
        disbursements. Some costs like title insurance or assignment fees may be 
        shared if agreed.</p>`,
      },
      {
        x: `1%`,
        y: `72%`,
        data: `<p><strong>Goods and Services Tax (GST): </strong>Unless agreed 
        otherwise in writing, the purchase price includes GST if it applies. Buyers 
        and Sellers should seek professional advice to confirm whether GST is 
        applicable. If it does apply, the Buyer pays the GST to the Seller on the 
        Completion Date, and the Seller remits it to CRA.</p>`,
      },
    ],
  },
  {
    id: 1023,
    form: `CPS-nothird`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Risk: </strong>Risk of loss transfers to the Buyer on the 
        earlier of possession or final completion. Buyers must have insurance if 
        taking early possession, and Sellers should keep insurance until payment 
        is received.</p>`,
      },
      {
        x: `1%`,
        y: `30.5%`,
        data: `<p><strong>Form of Contract: </strong>This form is designed for 
        residential leasehold purchases on First Nations reserve lands. Other 
        transactions, such as business or commercial sales, may require a different 
        form and legal advice.</p>`,
      },
      {
        x: `1%`,
        y: `46%`,
        data: `<p><strong>Alternate Dispute Resolution: </strong>If disputes arise 
        after completion, the parties should first attempt mediation, and if 
        unsuccessful, disputes may proceed to arbitration under the Arbitration 
        Act.</p>`,
      },
    ],
  },
  {
    id: 1024,
    form: `CPS-nothird`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `17.5%`,
        data: `<p><strong>Prepared By: </strong>Complete this section by inserting 
        the full Brokerage Name, Date, Office Address, Postal Code, Phone 
        Number, the REALTOR®'s Name preparing the offer, and the MLS® Number for 
        the listing.</p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Buyer/Seller Information: </strong>Input the full 
        legal names of both Buyers and Sellers. For Sellers, verify and insert their 
        names as they appear on title, along with the current addresses where they 
        reside. Check with the Seller's REALTOR® to obtain the Seller's current 
        address if it is not available in the Title Document.
        Take the extra step of cross-referencing your clients' IDs to guarantee 
        accuracy. If the client is a corporation, be sure to obtain documents, 
        such as the Articles of Incorporation, to confirm signing authority. 
        </p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Property Information: </strong>Insert the full details 
        of the property as they are shown in the Title Document. Insert all PID(s)/PIN 
        (from Land Registry) associated with the property. In the box below, insert 
        the full legal description of the property as it appears in the title document.
        Do not copy this information from the listing as discrepancies may exist. 
        Insert the lot or Canada Lands Surveys Records (CLSR) number if available. 
        Since errors may exist, verify the information to ensure it properly reflects 
        the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `72.5%`,
        data: `<p><strong>Purchase Price: </strong>This is the price the Buyer is 
        offering for the property. It's important to confirm that the price is 
        consistent in both numerical and textual formats (example: $500,000 / Five 
        Hundred Thousand). This price includes all applicable GST, unless otherwise 
        agreed to in writing. If a counter offer occurs, ensure number/text formats 
        remain consistent.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer/Seller Initials: </strong>As with most other pages 
        within the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1025,
    form: `CPS-nothird`,
    page: `5`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-5.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Deposit: </strong>Insert the amount of the deposit to be 
        paid by the Buyer as part of the contract. The deposit is part of the 
        purchase price and must be paid in the way and to the person specified in 
        the contract. Unless stated otherwise, it's due within 24 hours of the 
        offer being accepted. Paying the deposit is an essential requirement—if the 
        Buyer doesn't pay on time, the Seller may choose to cancel the contract. 
        Any Deposit payments that are late require the REALTOR® to notify their 
        Managing Broker.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Deposit Holder: </strong>Insert where the deposit will be held. 
        This is typically the Buyer's Brokerage in most circumstances. Ensure you enter 
        the full name of the Brokerage. The deposit is held by a neutral 
        stakeholder and can't be released until the money clears and both Buyer 
        and Seller agree, unless the Buyer cancels using their legal rescission 
        right. If the Buyer cancels, part of the deposit equal to the rescission 
        fee goes to the Seller, and any leftover deposit is returned to the Buyer. 
        If the deposit isn't enough to cover the fee, the Buyer must pay the 
        difference directly to the Seller.
        </p>`,
      },
      {
        x: `1%`,
        y: `79.5%`,
        data: `<p><strong>Third Party Approval: </strong>This confirms that no 
        outside approvals, such as from government authorities, are required for the 
        sale of the Seller's leasehold interest in the property.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer/Seller Initials: </strong>As with most other pages 
        within the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1026,
    form: `CPS-nothird`,
    page: `6`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-6.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Terms & Conditions: </strong>Add all applicable terms and 
        conditions pertaining to the Contract in this section. It is strongly advised 
        to utilize the BCREA/BCFSA approved terms/conditions which are available 
        to all BC REALTORS®. For any customized clauses, it's essential to seek legal 
        advice/Managing Broker to ensure they are drafted correctly and protect your 
        clients' best interests.
        Only terms/conditions pertaining to the Buyers/Sellers should be 
        included in this section. Any conditions must be either fulfilled/waived in 
        a timely manner, using proper procedures, otherwise the contract may not be 
        enforceable.<br/>
        Any statements or acknowledgements made by a party to someone who is not part 
        of the contract (for example, their REALTOR®) should be recorded separately 
        and not included in the contract itself.<br/><br/>
        **See the clause section within the Transaction Checklists for commonly used 
        terms and conditions.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1027,
    form: `CPS-nothird`,
    page: `7`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-7.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Trust Completion: </strong>Insert the date when the 
        Buyer will deliver funds, in trust, to their lawyer. This amount due at 
        this time will be equal to the purchase price, less any portion being 
        financed. The Trust Completion 
        Date is when all closing documents and funds are delivered by the Buyer in 
        trust before registration. The Buyer's lawyer/notary prepares and exchanges 
        documents with the Seller's lawyer/notary, and the Buyer pays their portion 
        of the purchase price.
        Once funds and documents are in trust, the Buyer's lawyer submits them 
        for registration. If possession is allowed before Final Completion, title 
        insurance (gap coverage) and home insurance must be arranged.
        </p>`,
      },
      {
        x: `1%`,
        y: `40.5%`,
        data: `<p><strong>Buyer Financing: </strong>If the Buyer is getting a new 
        mortgage, they must pay their share by the Trust Completion Date and meet all 
        lender requirements (except registration). Mortgage funds are advanced either 
        before Final Completion if possession is early and title insurance is in place, 
        or on the Final Completion Date if possession is later. In both cases, the 
        Buyer's lawyer/notary guarantees payment once registration is done and funds are 
        advanced.</p>`,
      },
      {
        x: `1%`,
        y: `76%`,
        data: `<p><strong>Final Completion: </strong>The sale is only complete once the 
        assignment of lease is registered. When registration is confirmed, the Buyer’s 
        lawyer/notary must notify the Seller’s lawyer/notary.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1028,
    form: `CPS-nothird`,
    page: `8`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-8.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Possession (explanation): </strong>The Buyer normally gets possession on the 
        Final Completion Date (subject to any existing tenancies). Possession can be 
        taken earlier after the Trust Completion Date if the Buyer gives written notice 
        or both parties agree in writing, but the Buyer must arrange title insurance 
        with gap coverage. The cost of insurance may be paid by the Buyer, the Seller, or 
        shared. Until Final Completion, the Buyer occupies as a tenant under the lease 
        and must maintain all required insurance, with benefits of coverage belonging to 
        the Buyer.</p>`,
      },
      {
        x: `1%`,
        y: `11%`,
        data: `<p><strong>Possession Time: </strong>Insert the Date, Time, and number 
        of days after the Final Completion Date that possession will take place.
        </p>`,
      },
      {
        x: `1%`,
        y: `16%`,
        data: `<p><strong>Possession before Final Completion: </strong>If possession 
        is to occur before the Final Completion Date, specify the number of days 
        after the Trust Completion Date on which possession will take place.
        </p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Gap Insurance Coverage: </strong>If “gap coverage” is 
        required based on the agreement between the parties, check the box that 
        specifies which party will be responsible for the Title Insurance Policy. 
        </p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Adjustments: </strong>Insert the adjustment date in this 
        section.The Adjustment Date is usually the same 
        as the Possession Date. From this date, the Buyer begins paying property 
        expenses (like taxes, utilities, and fees) and receives any income (such as 
        rent) from the property.</p>`,
      },
      {
        x: `1%`,
        y: `65.5%`,
        data: `<p><strong>Included Items: </strong> As per the pre-printed statement, 
        fixtures are included in the purchase price, unless otherwise stated below in 
        the "but excluding" section.  Insert any additional items (chattels) such as: 
        appliances, garage door remotes, mirrors not fixed to the walls...etc. that 
        are to be included in the Purchase Price. It is important to be as detailed 
        as possible when describing these items. Some items such as fixed tv mounts 
        have been greatly debated as to whether they need to be included. As a rule 
        of thumb, "if in doubt, include it" so that it is clear to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `82%`,
        data: `<p><strong>But Excluding: </strong>These are items that are attached 
        to the home but the Seller wishes to exclude them from the sale. One reason 
        may be that the item listed has sentimental value like a lighting fixture. 
        Precision is key when itemizing excluded items, for instance, specifying 
        "master bedroom light fixture."
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1029,
    form: `CPS-nothird`,
    page: `9`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-9.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Viewed: </strong>Insert the date(s) that the Buyer viewed 
        the property. The Seller agrees as per this statement that the property, and 
        all included items, will be in the same condition when the Buyers take 
        possession of the property. If the Buyer did not view the property, you may 
        require additional terms and conditions. Consult your Managing Broker for 
        guidance in cases where the Buyer did not view the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `17.5%`,
        data: `<p><strong>Title: </strong>This statement confirms that the Seller 
        must transfer ownership with a clear title, except for any encumbrances 
        specifically agreed to in the contract. Both parties should get legal 
        advice to confirm which encumbrances need to be cleared before closing.
        </p>`,
      },
      {
        x: `1%`,
        y: `22%`,
        data: `<p><strong>Tender (13): </strong>This item outlines the acceptable methods 
        of payment, which include a certified cheque, bank draft, lawyer/notary 
        trust cheque, and real estate Brokerage trust cheques.<br/><br/>
        <strong>Documents (14): </strong>All documents needed to complete the sale must 
        be properly prepared and in a form that can be registered with the Land 
        Title Office by the completion date.<br/><br/>
        <strong>Sellers Particulars and Residency (14A): </strong>By the completion date, 
        the Seller must provide sworn declarations about tax matters to help the 
        Buyer's lawyer or notary prepare closing documents and determine if taxes 
        like the Speculation and Vacancy Tax or Empty Homes Tax apply, or if the 
        Buyer needs to withhold money for the Seller's income tax.
        </p>`,
      },
      {
        x: `1%`,
        y: `43.5%`,
        data: `<p><strong>Time (15): </strong>This statement reiterates the fact that 
        "time is of the essence" which means that all parties to the contract must 
        adhere to the dates/deadlines set out in the contract. Failure to do so can 
        result in serious consequences.<br/><br/>
        <strong>Clearing Title (16): </strong>If the Seller still has mortgages or 
        other financial charges on the property, they can use the Buyer's purchase 
        funds on the completion date to pay them off. The lawyers will handle paying 
        out and discharging these charges, then give the Seller any remaining balance 
        from the Purchase Price.
        </p>`,
      },
      {
        x: `1%`,
        y: `66.5%`,
        data: `<p><strong>Costs: </strong>The Buyer must pay for expenses related to 
        financing and transferring the title, while the Seller covers the cost of 
        providing a clear title. Legal costs include both professional fees and 
        disbursements (such as Land Title Office charges, property transfer tax, 
        mortgage payout penalties, and courier or photocopying fees). These 
        disbursements can be significant, so both parties should review them with their 
        lawyers to understand what to expect.</p>`,
      },
      {
        x: `1%`,
        y: `71%`,
        data: `<p><strong>Risk (18): </strong>The Buyer becomes responsible for the property 
        at 12:01 a.m. on the Completion Date and should have insurance in place starting 
        at that time to protect against any loss or damage.<br/><br/>
        <strong>Plural (19): </strong>References to Buyer(s) or Seller(s) include 
        their heirs and executors. The contract continues if a party dies, and singular, 
        plural, masculine, or feminine terms apply as needed.
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10210,
    form: `CPS-nothird`,
    page: `10`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-10.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Representations and Warranties (20): </strong>The contract includes 
        only what is written in the CPS; outside promises are not binding unless 
        referenced. Certain terms, like warranties, survive completion and can still be 
        enforced after closing. <br/><br/>
        <strong>Personal Information (21): </strong>By signing the CPS, Buyers and 
        Sellers consent to REALTORS® collecting, using, and disclosing their personal 
        information as required for the transaction, in line with privacy laws and the 
        Privacy Notice and Consent form.
        </p>`,
      },
      {
        x: `1%`,
        y: `48%`,
        data: `<p><strong>Restriction on Assignment: </strong>The contract cannot be 
        assigned without the Seller's written consent, and any profit from an assignment 
        goes to the Seller. This restriction cannot be changed without written 
        instructions, and REALTORS® must disclose if it is not included. It is the 
        Buyer's REALTOR®'s responsibility to provide the "Notice to Seller Regarding 
        Assignment Terms" to the Seller's REALTOR® at the same time the offer is 
        presented.</p>`,
      },
      {
        x: `1%`,
        y: `54.5%`,
        data: `<p><strong>Agency Disclosure: </strong>Confirms the Buyer's and Seller's 
        agency relationships with their REALTORS®. All agents, co-listings, or Personal 
        Real Estate Corporations must be identified, with extra details added in the 
        contract or addendum if needed.<br/><br/>
        Have your clients initial the boxes that apply to the transaction as well as 
        insert the designated agent(s) and Brokerage involved.
        <ul >
          <li><strong>A:</strong> Seller acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>B:</strong> Buyer acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>continued on next page...</strong> </li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10211,
    form: `CPS-nothird`,
    page: `11`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-11.png",
    description: `<p>The Contract of Purchase and Sale (CPS) Not Hiring Agent form 
    is used to indicate that the Buyer or Seller does not wish to hire an agent.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `9%`,
        data: `<p><strong>Agency Disclosure (continued): </strong>Confirms the Buyer's and Seller's 
        agency relationships with their REALTORS®. All agents, co-listings, or Personal 
        Real Estate Corporations must be identified, with extra details added in the 
        contract or addendum if needed.<br/><br/>
        Have your clients initial the boxes that apply to the transaction as well as 
        insert the designated agent(s) and Brokerage involved.
        <ul >
          <li><strong>C:</strong> In limited situations where dual agency is allowed, complete this 
          section with the appropriate information.</li>
          <li><strong>D:</strong> To be completed if the Seller has an agency 
          relationship with a REALTOR® and the Buyer does not. Buyer initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
          <li><strong>E:</strong> To be completed if the Buyer has an agency 
          relationship with a REALTOR® and the Seller does not. Seller initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Assignment of Remuneration: </strong>Authorizes payment of the 
        REALTOR® commission directly from the sale proceeds by the Buyer or their 
        representative.</p>`,
      },
      {
        x: `1%`,
        y: `39.5%`,
        data: `<p><strong>Acceptance Irrevocable: </strong>By initialing this section, 
        both the Buyers and Sellers confirm the contract is made “under seal.” The 
        Seller cannot revoke (back out of) an accepted conditional offer until the 
        Buyer's conditions are removed or any contract options expire.
        </p>`,
      },
      {
        x: `1%`,
        y: `65%`,
        data: `<p><strong>Counterparts: </strong>The contract and any amendments may be 
        signed in separate copies and delivered by email, fax, or other electronic means. 
        All counterparts together are treated as one original document.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10212,
    form: `CPS-nothird`,
    page: `12`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-12.png",
    description: `<p>The Contract of Purchase and Sale (CPS) Not Hiring Agent form 
    is used to indicate that the Buyer or Seller does not wish to hire an agent.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Offer: </strong>Fully complete this section by 
        inserting the time and date of when this offer will be open for acceptance. 
        The offer or counter-offer remains open until the specified date and time unless 
        withdrawn in writing first. Once accepted in writing and notice is given, it 
        becomes a binding contract. If the offer is being countered, "counter-offer" 
        should be circled to indicate that it is a counter-offer. If new times are 
        needed, they should be amended and initialed each time a counter-offer is made.
        </p>`,
      },

      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Buyer Signature/Printed Name: </strong>Complete this 
        section by having all Buyers sign the offer along with their printed name. 
        You may only act as a witness for the Buyers signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `38%`,
        data: `<p><strong>Buyer Declaration: </strong>The Buyer must initial in the 
        Yes or No box to declare whether they are a Canadian citizen or permanent 
        resident. If the Buyer is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p><strong>Acceptance: </strong>Insert the date of when acceptance 
        occurred. By signing, the Seller accepts the offer 
        subject to any conditions. Once conditions are met or waived, the Seller must 
        complete the sale. Signatures should be witnessed where possible, and authority 
        must be shown if signing for another. The Seller must also provide contact 
        details (or their REALTOR®'s) for receiving any Buyer rescission notices.</p>`,
      },
      {
        x: `1%`,
        y: `59.5%`,
        data: `<p><strong>Seller Declaration: </strong>The Seller must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Seller is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `67%`,
        data: `<p><strong>Seller Signature/Printed Name: </strong>Complete this 
        section by having all Sellers sign the offer along with their printed name. 
        You may only act as a witness for the Sellers signature if you are present 
        and watch them sign.
        </p>`,
      },
    ],
  },
  {
    id: 10213,
    form: `CPS-nothird`,
    page: `13`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-13.png",
    description: `<p>The Contract of Purchase and Sale (CPS) Not Hiring Agent form 
    is used to indicate that the Buyer or Seller does not wish to hire an agent.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `19%`,
        data: `<p><strong>Leasehold Interest Description: </strong> As per the 
        pre-printed statement, the Seller must describe 
        their leasehold interest in the property, list all lease agreements that form 
        part of it, and/or attach a copy of the parcel abstract report for the property.</p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1031,
    form: `listing-amendment`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Listing/amendment.png",
    description: `<p>This form is used to make changes to the terms of an existing 
    Listing Contract. It can be used to change the expiration date, price, or any 
    other terms and conditions of the Multiple Listing Contract. If your listing is 
    Exclusive, be sure to use "Amendment of Exclusive Listing Contract" form instead.
    For an example of Amending a Lease Listing, see the form below this one.  
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `10%`,
        data: `<p><strong>Listing MLS Number (far right): </strong>Insert the MLS® 
        Number of the listing that this amendment pertains to.
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Seller(s) Information: </strong> Input the full 
        legal names of all the Sellers of the listed property.

        </p>`,
      },
      {
        x: `1%`,
        y: `22%`,
        data: `<p><strong>Property Information: </strong> Insert the full 
        civic address of the listed property.
        
        </p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Brokerage Information: </strong> Insert the full 
        name of the listing Brokerage.
        
        </p>`,
      },
      {
        x: `1%`,
        y: `34%`,
        data: `<p><strong>Amendments: </strong> This section contains some pre-printed 
        options based on common uses for this form.  Only complete the options that 
        apply. If additional space is required, a separate page/schedule can be 
        attached. 
        <ol >
          <li><strong>Expiration Date: </strong> If the expiration date is being 
          amended, insert the new date of expiry.</li>
          <li><strong>Listing Price Change: </strong> Insert the current list price 
          and the new list price.</li>
          <li><strong>Change Terms: </strong> Use this section to make changes to other 
          terms that are present in the original listing contract.</li>
          <li><strong>Hold Action: </strong> Use this section if any amendments are to 
          be delayed, suspended, or only take effect starting on a specific date 
          and/or time, including the reason for the delay.</li>
          <li><strong>Other Changes: </strong> Use this section if additional changes 
          are required that aren't covered in other areas of this form.</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `60%`,
        data: `<p>This section confirms that all other terms in the Multiple Listing 
        Contract remain the same and in force, except for the specific changes listed 
        above. 
        Additionally, all parties acknowledge they have read, understood, and have 
        received a copy of this amendment.
        </p>`,
      },
      {
        x: `1%`,
        y: `66%`,
        data: `<p><strong>Signed, Sealed and Delivered: </strong>The date recorded is the 
        day the last party signs the amendment. For example, if one party signs on 
        September 9th and the other on September 14th, the official date is 
        September 14th. The date must only be inserted once the final signature is 
        made (including Managing Broker signature), and a copy of the fully executed 
        amendment must be given to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `71%`,
        data: `<p><strong>Seller(s) Signature: </strong>Have all Sellers sign the 
        amendment. All Sellers must sign in order to make this amendment valid.
        </p>`,
      },
      {
        x: `1%`,
        y: `80%`,
        data: `<p><strong>Agent/Brokerage Signature(s): </strong>In this section, 
        have the designated agent sign (if more than one, only one is required) and 
        insert the printed name of the agent. Additionally, insert the name of the 
        listing Brokerage and follow office procedures to submit to the Managing 
        Broker for signature.
        </p>`,
      },
    ],
  },
  {
    id: 1032,
    form: `listing-amendment`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Listing/lease-amend.png",

    hotspots: [
      {
        x: `1%`,
        y: `10%`,
        data: `<p><strong>Listing MLS Number (far right): </strong>Insert the MLS® 
        Number of the listing that this amendment pertains to.
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Landlords(s) Information: </strong> Input the full 
        legal names of all the Landlords of the listed property.

        </p>`,
      },
      {
        x: `1%`,
        y: `22%`,
        data: `<p><strong>Property Information: </strong> Insert the full 
        civic address of the listed property.
        
        </p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Brokerage Information: </strong> Insert the full 
        name of the listing Brokerage.
        
        </p>`,
      },
      {
        x: `1%`,
        y: `34%`,
        data: `<p><strong>Amendments: </strong> This section contains some pre-printed 
        options based on common uses for this form.  Only complete the options that 
        apply. If additional space is required, a separate page/schedule can be 
        attached. 
        <ol >
          <li><strong>Expiration Date: </strong> If the expiration date is being amended, insert the new 
          date of expiry.</li>
          <li><strong>Lease Price Change: </strong> Insert the current lease price (including 
          the appropriate period, ie. "per month"). Insert the new lease price, also including 
          the appropriate period.</li>
          <li><strong>Change Terms: </strong> Use this section to make changes to other terms 
          that are present in the original listing contract.</li>
          <li><strong>Hold Action: </strong> Use this section if any amendments are to 
          be delayed, suspended, or only take effect starting on a specific date 
          and/or time, including the reason for the delay.</li>
          <li><strong>Other Changes: </strong> Use this section if additional changes 
          are required that aren't covered in other areas of this form.</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `60%`,
        data: `<p>This section confirms that all other terms in the Authority to Lease 
        remain the same and in force, except for the specific changes listed above. 
        Additionally, all parties acknowledge they have read, understood, and have 
        received a copy of this amendment.
        </p>`,
      },
      {
        x: `1%`,
        y: `66%`,
        data: `<p><strong>Signed, Sealed and Delivered: </strong>The date recorded is the 
        day the last party signs the amendment. For example, if one party signs on 
        September 9th and the other on September 14th, the official date is 
        September 14th. The date must only be inserted once the final signature is 
        made, and a copy of the fully executed amendment must be given to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `71%`,
        data: `<p><strong>Landlord Signature(s): </strong>Have all landlords sign the 
        amendment. All landlords must sign in order to make this amendment valid.
        </p>`,
      },
      {
        x: `1%`,
        y: `80%`,
        data: `<p><strong>Agent/Brokerage Signature(s): </strong>In this section, 
        have the designated agent sign (if more than one, only one is required) and 
        insert the printed name of the agent. Additionally, insert the name of the 
        listing Brokerage and follow office procedures to submit to the Managing 
        Broker for signature.
        </p>`,
      },
    ],
  },
  {
    id: 1051,
    form: `PNC`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/PNC/PNC-1.png",
    description: `<p>BC privacy laws require 
  informed consent before personal information can be collected, used, or disclosed. 
  The Privacy Notice and Consent form provides disclosure and records the consumer's 
  consent. By signing and dating the form, the consumer confirms they understand and 
  agree to the REALTOR®'s use of their personal information.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Note the total number of pages that make up 
        the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>Have ALL of your clients initial 
        in the box that applies. 
        </p>`,
      },
    ],
  },
  {
    id: 1052,
    form: `PNC`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/PNC/PNC-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Note the total number of pages that make up 
        the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `36%`,
        data: `<p><strong>Opt Out Options: </strong>Privacy laws dictate that a 
        consumer has the right to decline the use of their personal information. 
        This form allows for the consumer to opt out of certain uses that are 
        integral to the services a REALTOR® provides. It's important to review 
        each option and have your clients initial any box that applies.
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Client Initials: </strong>Have ALL of your clients initial 
        in the box that applies. 
        <ol class="letter-ol">
          <li>By selecting this option, the consumer is opting out of 
          receiving any communications from the REALTOR®/Brokerage about any 
          additional future real estate services. Example: sending out a calendar 
          at a future time to market real estate services.</li>
          <li>By selecting this option, the consumer is opting out of 
          receiving any communications from the REALTOR®/Brokerage about any 
          other products or services. Examples: insurance products, renovation 
          services, cleaning, etc.</li>
          <li>By selecting this option, the consumer does not want any REALTOR® who 
          has access to their personal information to contact them for any reason 
          other than what is necessary to complete the transaction.</li>
          <li>By selecting this option, the consumer does not want any REALTOR® or 
          your real estate board to contact them in relation to conducting a survey.
          </li>
          </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `72%`,
        data: `<p><strong>Signatures/Information: </strong>Have ALL of your clients 
        sign, date, and insert their printed name. Additionally, insert the name of 
        the REALTOR® & Brokerage who is receiving this consent. 
        </p>`,
      },
    ],
  },

  {
    id: 1071,
    form: `ELC`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-1.png",
    description: `<p>This contract outlines the professional relationship between the 
    Seller and the REALTOR®'s Brokerage, as well as the terms of the contract as agreed 
    to by all parties. This contract is used when the property is to be listed on the 
    MLS® system. If the property is not being listed on the MLS® system, use the 
    Exclusive Listing Contract form instead.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Seller Information: </strong>Insert the full legal names 
        of all Sellers as noted on the Title Document. Double check your clients IDs 
        to ensure accuracy. Insert the address where they currently live. Ensure you 
        verify the sellers current address as it may differ from the address that is 
        on Title.<br/><br/>
        <strong>Brokerage Information: </strong>Insert the full Brokerage 
        name as well as the other information requested in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `39%`,
        data: `<p><strong>Effective Date: </strong>Insert the date that this contract 
        starts. Typically it is the same date as when it is signed/delivered. If all 
        parties agree that the date is to be a future date, insert that date. It cannot 
        be a date that is before the contract is signed/delivered.<br/><br/>
        <strong>Expiry Date: </strong>Insert the date that this contract expires. It's 
        important to note that while this date is negotiable, some real estate boards 
        MLS rules have minimum listing periods.  
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Seller Authorizations: </strong>The Seller authorizes the 
        Listing Brokerage to (i) obtain property information from authorities and share 
        it with others, (ii) advertise and show the property to buyers, (iii) control all 
        advertising unless permission is given to other boards, (iv) place “For Sale” and 
        “Sold” signs on the property, and (v) allow cooperating Brokerages, and with 
        written consent, sub-agents, to show the property to buyers.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1072,
    form: `ELC`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `37%`,
        data: `<p><strong>Property: </strong> Insert the full civic address, PID 
        (parcel identifier), and legal description (next page) as shown in the title 
        search. It is important to cross reference this information with other sources
        such as BC Assessment to ensure accuracy. 
        </p>`,
      },
      {
        x: `1%`,
        y: `54.5%`,
        data: `<p><strong>List Price and Terms: </strong>This section specifies the 
        price at which the broker will list and advertise the property. The Seller 
        may still accept offers above or below the list price. Add any extra terms 
        the Seller wants to include here. 
        </p>`,
      },
      {
        x: `1%`,
        y: `60%`,
        data: `<p><strong>Total Commission: </strong> Insert the amount 
        of commission the listing Brokerage will receive under this contract. As per 
        the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1073,
    form: `ELC`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Designated Agent: </strong>Insert the name(s) of the 
        designated agent(s) for the property. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1074,
    form: `ELC`,
    page: `4`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1076,
    form: `ELC`,
    page: `6`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1077,
    form: `ELC`,
    page: `7`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Contract Signed, Sealed, and Delivered Date: </strong>Insert 
         the date that the contract was signed, sealed, and delivered.  The date must 
         not be inserted until the last party signs. This date must be on or before 
         the effective (start) date of the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Seller Declaration: </strong>The Seller must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Seller is unsure of their residency status, 
        they should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Seller Signature/Printed Name: </strong>Complete this 
        section by having all Sellers sign the contract.  You may only act as a 
        witness for the Sellers signature if you are present and watch them sign. In 
        the case of a Power of Attorney (POA), the individual signing would be their 
        name followed by "as POA for (full legal name of the individual)".
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Managing Broker/Designated Agent Signatures: </strong> 
        Complete this section by having the Managing Broker/Designated Agent sign the 
        contract. Additionally, insert the full Brokerage name and the printed name of 
        the designated agent in their respective locations.
        </p>`,
      },
    ],
  },
  {
    id: 1077,
    form: `ELC`,
    page: `8`,
    imageURL: "../../images/BritishColumbia/forms/Listing/ELC/ELC-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being listed and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `14.5%`,
        data: `<p><strong>List of Services Provided to the Seller: </strong>This Schedule is where 
        you  must outline the services you will provide to the Client. It should be 
        treated as a living document, evolving as you expand your list of 
        services.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Seller Initials: </strong>Have ALL of the Sellers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1081,
    form: `CPS-yesthird`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-1.png",
    description: `<p>This Contract of Purchase and Sale (CPS) is specifically for 
    the purchase of property on First Nations reserve lands where 3rd party 
    approval is required.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `22%`,
        data: `<p><strong>Contract: </strong>Once signed by both parties, this is a 
        legally binding contract. All agreed terms must be in writing, so parties should 
        read it carefully.</p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Deposit(s): </strong>Deposits are held by the brokerage as a 
        stakeholder for the transaction, not for either party. They can only be released 
        with written agreement from both parties or a court order if there is a dispute.</p>`,
      },
      {
        x: `1%`,
        y: `37.5%`,
        data: `<p><strong>Third Party Approval: </strong>The contract requires approval 
        from relevant authorities, such as First Nations governments or other 
        governmental bodies, if needed. Approvals must be obtained before trust 
        completion, and the buyer usually handles requests. If approvals are not 
        obtained within 60 days, the period can extend another 90 days unless agreed 
        otherwise. If approvals are not received in time, the contract is void and 
        deposits are returned.</p>`,
      },
      {
        x: `1%`,
        y: `60.5%`,
        data: `<p><strong>Terms and Conditions: </strong>The Buyer must be satisfied with 
        the lease documents listed in Schedule “A”. It is strongly recommended that a 
        lawyer review these documents to ensure the terms are acceptable.</p>`,
      },
      {
        x: `1%`,
        y: `66.5%`,
        data: `<p><strong>Trust Completion: </strong>The Trust Completion Date is when 
        documents and funds are delivered in trust for registration. This occurs on the 
        later of the agreed date or 7 business days after required third party 
        approvals are obtained. The Buyer's lawyer prepares documents for the Seller to 
        sign at least 2 days before, and the Buyer must provide their portion of the 
        purchase price to their lawyer/notary by the Trust Completion Date.</p>`,
      },
    ],
  },
  {
    id: 1082,
    form: `CPS-yesthird`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Possession: </strong>The Buyer may take possession on or after 
        the final completion date, or earlier on the trust completion date if proper 
        title insurance and home insurance are in place and financing arrangements are 
        approved. Possession details should be arranged through the real estate 
        licensees.</p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Included Items: </strong>If the purchase price includes movable 
        items (like a manufactured home), a separate transfer document may be required 
        and legal advice is recommended.</p>`,
      },
      {
        x: `1%`,
        y: `30%`,
        data: `<p><strong>Title: </strong>The Buyer must ensure zoning, restrictions, 
        hazards, and encumbrances are acceptable before being bound. The Seller must 
        disclose any encumbrances staying on title. Mortgage lenders may refuse funding 
        if title or restrictions are unacceptable, and Sellers allowing mortgage 
        assumption may remain liable unless released by the lender.</p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Customary Costs: </strong>Typically, Sellers pay for clearing 
        title, real estate commissions, and their lawyer’s/notary’s fees. Buyers usually 
        cover financing expenses, title searches, insurance, surveys, taxes, and 
        disbursements. Some costs (like title insurance, assignment fees, or property 
        taxes) may be shared if agreed. Adjustments between parties may also apply.</p>`,
      },
      {
        x: `1%`,
        y: `71%`,
        data: `<p><strong>Goods and Services Tax (GST): </strong>Unless agreed otherwise 
        in writing, the purchase price includes applicable GST. Buyers and Sellers 
        should confirm whether GST applies with professional advice. If GST is payable, 
        the Buyer pays it to the Seller on the Completion Date, and the Seller remits it 
        to CRA.</p>`,
      },
    ],
  },
  {
    id: 1083,
    form: `CPS-yesthird`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Risk: </strong>Risk transfers to the Buyer on the earlier of the 
        possession date or the final completion date. If the Buyer takes early 
        possession, they must have appropriate insurance, while the Seller must keep 
        their insurance until the later of final completion or receipt of sale proceeds. 
        Both parties must ensure coverage to protect their interests and meet lease or 
        mortgage requirements.</p>`,
      },
      {
        x: `1%`,
        y: `30.5%`,
        data: `<p><strong>Form of Contract: </strong>This form is intended for residential 
        leasehold sales in First Nations reserve lands registered under federal systems 
        such as ILRS, SGFNLRS, or FNLRS. If the transaction involves a business, 
        commercial development, or other special circumstances, additional provisions 
        may be required, and legal or professional advice should be sought.</p>`,
      },
      {
        x: `1%`,
        y: `46%`,
        data: `<p><strong>Alternate Dispute Resolution: </strong>If disputes arise after 
        completion, parties are encouraged to mediate first. If mediation fails, disputes 
        can then be resolved through arbitration under the Arbitration Act.</p>`,
      },
    ],
  },
  {
    id: 1084,
    form: `CPS-yesthird`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Prepared By: </strong>Complete this section by inserting 
        the full Brokerage Name, Date, Office Address, Postal Code, Phone 
        Number, the REALTOR®'s Name preparing the offer, and the MLS® Number for 
        the listing.</p>`,
      },
      {
        x: `1%`,
        y: `28%`,
        data: `<p><strong>Buyer/Seller Information: </strong>Input the full 
        legal names of both Buyers and Sellers. For Sellers, verify and insert their 
        names as they appear on title, along with the current addresses where they 
        reside. Check with the Seller's REALTOR® to obtain the Seller's current 
        address if it is not available in the Title Document.
        Take the extra step of cross-referencing your clients' IDs to guarantee 
        accuracy. If the client is a corporation, be sure to obtain documents, 
        such as the Articles of Incorporation, to confirm signing authority. 
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Property Information: </strong>Insert the full details 
        of the property as they are shown in the Title Document. Insert all PID(s)/PIN 
        (from Land Registry) associated with the property. In the box below, insert 
        the full legal description of the property as it appears in the title document.
        Do not copy this information from the listing as discrepancies may exist. 
        Insert the lot or Canada Lands Surveys Records (CLSR) number if available. 
        Lastly, insert the Indian Reserve Number. 
        Since errors may exist, verify the information to ensure it properly reflects 
        the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `77%`,
        data: `<p><strong>Purchase Price: </strong>This is the price the Buyer is 
        offering for the property. It's important to confirm that the price is 
        consistent in both numerical and textual formats (example: $500,000 / Five 
        Hundred Thousand). This price includes all applicable GST, unless otherwise 
        agreed to in writing. If a counter offer occurs, ensure number/text formats 
        remain consistent.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer/Seller Initials: </strong>As with most other pages 
        within the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1085,
    form: `CPS-yesthird`,
    page: `5`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Deposit: </strong>Insert the amount of the deposit to be 
        paid by the Buyer as part of the contract. The deposit is part of the 
        purchase price and must be paid in the way and to the person specified in 
        the contract. Unless stated otherwise, it's due within 24 hours of the 
        offer being accepted. Paying the deposit is an essential requirement—if the 
        Buyer doesn't pay on time, the Seller may choose to cancel the contract. 
        Any Deposit payments that are late require the REALTOR® to notify their 
        Managing Broker.
        </p>`,
      },
      {
        x: `1%`,
        y: `28%`,
        data: `<p><strong>Deposit Holder: </strong>Insert where the deposit will be held. 
        This is typically the Buyer's Brokerage in most circumstances. Ensure you enter 
        the full name of the Brokerage. The deposit is held by a neutral 
        stakeholder and can't be released until the money clears and both Buyer 
        and Seller agree, unless the Buyer cancels using their legal rescission 
        right. If the Buyer cancels, part of the deposit equal to the rescission 
        fee goes to the Seller, and any leftover deposit is returned to the Buyer. 
        If the deposit isn't enough to cover the fee, the Buyer must pay the 
        difference directly to the Seller.
        </p>`,
      },
      {
        x: `1%`,
        y: `46%`,
        data: `<p><strong>Third Party Approval: </strong>The transfer of the Seller’s 
        leasehold interest requires approval from one or more third parties (such as 
        First Nations governments or other authorities). The contract is conditional on 
        these approvals being obtained within 60 days, or the period may extend for 
        another 90 days (or as otherwise agreed in writing). If approvals are not 
        obtained in time, the contract becomes void and deposits are returned. Once 
        approvals are received, the Buyer must cover costs as agreed (Buyer, Seller, or 
        shared), and both parties must cooperate and make reasonable efforts to secure 
        the approvals.</p>`,
      },
      {
        x: `1%`,
        y: `72%`,
        data: `<p><strong>Third Party Approval Costs: </strong>Check the box to 
        confirm who will be covering the costs associated with obtaining the third 
        party approval.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer/Seller Initials: </strong>As with most other pages 
        within the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1086,
    form: `CPS-yesthird`,
    page: `6`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Terms & Conditions: </strong>Add all applicable terms and 
        conditions pertaining to the Contract in this section. It is strongly advised 
        to utilize the BCREA/BCFSA approved terms/conditions which are available 
        to all BC REALTORS®. For any customized clauses, it's essential to seek legal 
        advice/Managing Broker to ensure they are drafted correctly and protect your 
        clients' best interests.
        Only terms/conditions pertaining to the Buyers/Sellers should be 
        included in this section. Any conditions must be either fulfilled/waived in 
        a timely manner, using proper procedures, otherwise the contract may not be 
        enforceable.<br/>
        Any statements or acknowledgements made by a party to someone who is not part 
        of the contract (for example, their REALTOR®) should be recorded separately 
        and not included in the contract itself.<br/><br/>
        **See the clause section within the Transaction Checklists for commonly used 
        terms and conditions.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1087,
    form: `CPS-yesthird`,
    page: `7`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },

      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Trust Completion: </strong>Insert the date when the 
        Buyer will deliver funds, in trust, to their lawyer. This amount due at 
        this time will be equal to the purchase price, less any portion being 
        financed.<br/>The Trust Completion Date is the 
        later of (i) the agreed date, or (ii) 7 days after all required third party 
        approvals are obtained (or the next business day). By 4 pm that day: (A) the 
        Seller must deliver an assignment of lease and transfer documents to the Buyer’s 
        lawyer/notary, and the Buyer's lawyer must provide standard undertakings; (B) 
        the Buyer must deposit the Purchase Price in trust; and (C) the Buyer must 
        authorize release of funds to the Seller on Final Completion or earlier if 
        possession occurs before. The Buyer must also ensure the lease and any mortgage 
        are registered promptly.</p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p><strong>Buyer Financing: </strong>If the Buyer is getting a new 
        mortgage, they must pay their share by the Trust Completion Date and meet all 
        lender requirements (except registration). Mortgage funds are advanced either 
        before Final Completion if possession is early and title insurance is in place, 
        or on the Final Completion Date if possession is later. In both cases, the 
        Buyer's lawyer/notary guarantees payment once registration is done and funds are 
        advanced.</p>`,
      },
      {
        x: `1%`,
        y: `79%`,
        data: `<p><strong>Final Completion: </strong>The sale is complete once the 
        assignment of lease is registered in the appropriate lands registry (Final 
        Completion Date).</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1088,
    form: `CPS-yesthird`,
    page: `8`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Possession (explanation): </strong>
        The Buyer normally gets possession on the Final Completion Date (subject to 
        any existing tenancies). 
        Possession can be taken earlier after the Trust Completion Date if the Buyer 
        gives written notice or both parties agree in writing, but the Buyer must 
        arrange title insurance with gap coverage. The cost of insurance may be paid 
        by the Buyer, the Seller, or shared. Until Final Completion, the Buyer occupies 
        as a tenant under the lease and must maintain all required insurance, with 
        benefits of coverage belonging to the Buyer.
        </p>`,
      },
      {
        x: `1%`,
        y: `11%`,
        data: `<p><strong>Possession Time: </strong>Insert the Date, Time, and number 
        of days after the Final Completion Date that possession will take place.
        </p>`,
      },
      {
        x: `1%`,
        y: `15.5%`,
        data: `<p><strong>Possession before Final Completion: </strong>If possession 
        is to occur before the Final Completion Date, specify the number of days 
        after the Trust Completion Date on which possession will take place.
        </p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Gap Insurance Coverage: </strong>If “gap coverage” is 
        required based on the agreement between the parties, check the box that 
        specifies which party will be responsible for the Title Insurance Policy. 
        </p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Adjustments: </strong>Insert the adjustment date in this 
        section.The Adjustment Date is usually the same 
        as the Possession Date. From this date, the Buyer begins paying property 
        expenses (like taxes, utilities, and fees) and receives any income (such as 
        rent) from the property.</p>`,
      },
      {
        x: `1%`,
        y: `65.5%`,
        data: `<p><strong>Included Items: </strong> As per the pre-printed statement, 
        fixtures are included in the purchase price, unless otherwise stated below in 
        the "but excluding" section.  Insert any additional items (chattels) such as: 
        appliances, garage door remotes, mirrors not fixed to the walls...etc. that 
        are to be included in the Purchase Price. It is important to be as detailed 
        as possible when describing these items. Some items such as fixed tv mounts 
        have been greatly debated as to whether they need to be included. As a rule 
        of thumb, "if in doubt, include it" so that it is clear to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `80.5%`,
        data: `<p><strong>But Excluding: </strong>These are items that are attached 
        to the home but the Seller wishes to exclude them from the sale. One reason 
        may be that the item listed has sentimental value like a lighting fixture. 
        Precision is key when itemizing excluded items, for instance, specifying 
        "master bedroom light fixture."
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1089,
    form: `CPS-yesthird`,
    page: `9`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-9.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Viewed: </strong>Insert the date(s) that the Buyer viewed 
        the property. The Seller agrees as per this statement that the property, and 
        all included items, will be in the same condition when the Buyers take 
        possession of the property. If the Buyer did not view the property, you may 
        require additional terms and conditions. Consult your Managing Broker for 
        guidance in cases where the Buyer did not view the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Title: </strong>This statement confirms that the Seller 
        must transfer ownership with a clear title, except for any encumbrances 
        specifically agreed to in the contract. Both parties should get legal 
        advice to confirm which encumbrances need to be cleared before closing.
        </p>`,
      },
      {
        x: `1%`,
        y: `16.5%`,
        data: `<p><strong>Tender (13): </strong>This item outlines the acceptable methods 
        of payment, which include a certified cheque, bank draft, lawyer/notary 
        trust cheque, and real estate Brokerage trust cheques.<br/><br/>
        <strong>Documents (14): </strong>All documents needed to complete the sale must 
        be properly prepared and in a form that can be registered with the appropriate 
        lands office by the completion date.<br/><br/>
        <strong>Sellers Particulars and Residency (14A): </strong>By the completion date, 
        the Seller must provide sworn declarations about tax matters to help the 
        Buyer's lawyer or notary prepare closing documents and determine if taxes 
        like the Speculation and Vacancy Tax or Empty Homes Tax apply, or if the 
        Buyer needs to withhold money for the Seller's income tax.
        </p>`,
      },
      {
        x: `1%`,
        y: `38.5%`,
        data: `<p><strong>Time (15): </strong>This statement reiterates the fact that 
        "time is of the essence" which means that all parties to the contract must 
        adhere to the dates/deadlines set out in the contract. Failure to do so can 
        result in serious consequences.<br/><br/>
        <strong>Clearing Title (16): </strong>If the Seller still has mortgages or 
        other financial charges on the property, they can use the Buyer's purchase 
        funds on the completion date to pay them off. The lawyers will handle paying 
        out and discharging these charges, then give the Seller any remaining balance 
        from the Purchase Price.
        </p>`,
      },
      {
        x: `1%`,
        y: `58%`,
        data: `<p><strong>Costs: </strong>The Buyer must pay for expenses related to 
        financing and transferring the title, while the Seller covers the cost of 
        providing a clear title. Legal costs include both professional fees and 
        disbursements (such as Land Title Office charges, property transfer tax, 
        mortgage payout penalties, and courier or photocopying fees). These 
        disbursements can be significant, so both parties should review them with their 
        lawyers to understand what to expect.</p>`,
      },
      {
        x: `1%`,
        y: `62.5%`,
        data: `<p><strong>Risk (18): </strong>The Buyer becomes responsible for the property 
        at 12:01 a.m. on the earlier of the Final Completion Date or the Possession 
        Date and should have insurance in place starting at that time to protect against 
        any loss or damage.<br/><br/>
        <strong>Plural (19): </strong>References to Buyer(s) or Seller(s) include 
        their heirs and executors. The contract continues if a party dies, and singular, 
        plural, masculine, or feminine terms apply as needed.
        </p>`,
      },
      {
        x: `1%`,
        y: `72.5%`,
        data: `<p><strong>Representations and Warranties (20): </strong>The contract includes 
        only what is written in the CPS and the Assignment of Lease; outside promises are not binding unless 
        referenced. Certain terms, like warranties, survive completion and can still be 
        enforced after closing. <br/><br/>
        <strong>Personal Information (21): </strong>By signing the CPS, Buyers and 
        Sellers consent to REALTORS® collecting, using, and disclosing their personal 
        information as required for the transaction, in line with privacy laws and the 
        Privacy Notice and Consent form.
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10810,
    form: `CPS-yesthird`,
    page: `10`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-10.png",

    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },

      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Restriction on Assignment: </strong>The contract cannot be 
        assigned without the Seller's written consent, and any profit from an assignment 
        goes to the Seller. This restriction cannot be changed without written 
        instructions, and REALTORS® must disclose if it is not included. It is the 
        Buyer's REALTOR®'s responsibility to provide the "Notice to Seller Regarding 
        Assignment Terms" to the Seller's REALTOR® at the same time the offer is 
        presented.</p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Agency Disclosure: </strong>Confirms the Buyer's and Seller's 
        agency relationships with their REALTORS®. All agents, co-listings, or Personal 
        Real Estate Corporations must be identified, with extra details added in the 
        contract or addendum if needed.<br/><br/>
        Have your clients initial the boxes that apply to the transaction as well as 
        insert the designated agent(s) and Brokerage involved.
        <ul >
          <li><strong>A:</strong> Seller acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>B:</strong> Buyer acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>C:</strong> In limited situations where dual agency is allowed, complete this 
          section with the appropriate information.</li>
          <li><strong>D:</strong> To be completed if the Seller has an agency 
          relationship with a REALTOR® and the Buyer does not. Buyer initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
          <li><strong>E:</strong> To be completed if the Buyer has an agency 
          relationship with a REALTOR® and the Seller does not. Seller initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10811,
    form: `CPS-yesthird`,
    page: `11`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-11.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },

      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Assignment of Remuneration: </strong>Authorizes payment of the 
        REALTOR® commission directly from the sale proceeds by the Buyer or their 
        representative.</p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Acceptance Irrevocable: </strong>By initialing this section, 
        both the Buyers and Sellers confirm the contract is made “under seal.” The 
        Seller cannot revoke (back out of) an accepted conditional offer until the 
        Buyer's conditions are removed or any contract options expire.
        </p>`,
      },
      {
        x: `1%`,
        y: `39%`,
        data: `<p><strong>Counterparts: </strong>The contract and any amendments may be 
        signed in separate copies and delivered by email, fax, or other electronic means. 
        All counterparts together are treated as one original document.</p>`,
      },
      {
        x: `1%`,
        y: `57.5%`,
        data: `<p><strong>Offer: </strong>Fully complete this section by 
        inserting the time and date of when this offer will be open for acceptance. 
        The offer or counter-offer remains open until the specified date and time unless 
        withdrawn in writing first. Once accepted in writing and notice is given, it 
        becomes a binding contract. If the offer is being countered, "counter-offer" 
        should be circled to indicate that it is a counter-offer. If new times are 
        needed, they should be amended and initialed each time a counter-offer is made.
        </p>`,
      },
      {
        x: `1%`,
        y: `69%`,
        data: `<p><strong>Buyer Signature/Printed Name: </strong>Complete this 
        section by having all Buyers sign the offer along with their printed name. 
        You may only act as a witness for the Buyers signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Declaration: </strong>The Buyer must initial in the 
        Yes or No box to declare whether they are a Canadian citizen or permanent 
        resident. If the Buyer is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
    ],
  },
  {
    id: 10812,
    form: `CPS-yesthird`,
    page: `12`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-12.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },

      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Acceptance: </strong>Insert the date of when acceptance 
        occurred. By signing, the Seller accepts the offer 
        subject to any conditions. Once conditions are met or waived, the Seller must 
        complete the sale. Signatures should be witnessed where possible, and authority 
        must be shown if signing for another. The Seller must also provide contact 
        details (or their REALTOR®'s) for receiving any Buyer rescission notices.</p>`,
      },
      {
        x: `1%`,
        y: `23.5%`,
        data: `<p><strong>Seller Declaration: </strong>The Seller must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Seller is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `29%`,
        data: `<p><strong>Seller Signature/Printed Name: </strong>Complete this 
        section by having all Sellers sign the offer along with their printed name. 
        You may only act as a witness for the Sellers signature if you are present 
        and watch them sign.
        </p>`,
      },
    ],
  },
  {
    id: 10813,
    form: `CPS-yesthird`,
    page: `13`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-yesthird/CPS-yesthird-13.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being purchased and note the total number of pages that make up the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `19%`,
        data: `<p><strong>Leasehold Interest Description: </strong> As per the 
        pre-printed statement, the Seller must describe 
        their leasehold interest in the property, list all lease agreements that form 
        part of it, and/or attach a copy of the parcel abstract report for the property.</p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1091,
    form: `CPS-manu`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-1.png",
    description: `<p>This Contract of Purchase and Sale (CPS) stands as 
    the primary document employed in acquiring Mobile/Manufactured homes on rental 
    sites. As you complete this contract, it is imperative to cross-reference all property 
    details with secondary sources like the Land Title Document/Mobile Home Registry. While 
    the listing agent bears the responsibility of ensuring listing accuracy, it remains 
    crucial to undertake thorough due diligence for your client, refraining from solely 
    depending on the listing information.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `17.5%`,
        data: `<p><strong>Contract: </strong>Once signed by both parties, this is a 
        legally binding contract; read carefully and ensure all agreed terms are in 
        writing.</p>`,
      },
      {
        x: `1%`,
        y: `21.5%`,
        data: `<p><strong>Deposit(s): </strong>Deposits are held by the brokerage 
        as a neutral stakeholder (not for either party) and can only be released 
        with both parties’ written agreement or a court order; if a subject clause 
        isn't removed, written agreement is required to release the deposit.
        </p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Manufactured Home: </strong>The Buyer must obtain and 
        review the manufactured home park rules (Sections 4 and 5).
        </p>`,
      },
      {
        x: `1%`,
        y: `41.5%`,
        data: `<p><strong>Seller's Disclosure (A) - Principle: </strong>Whether disclosure 
        is provided at acceptance or after, the Buyer did not have it when making the 
        offer, so the contract treats both timings similarly.
        </p>`,
      },
      {
        x: `1%`,
        y: `47.5%`,
        data: `<p><strong>Disclosure Received Before Offer (B): </strong>If the 
        Buyer/REALTOR® already has the Site Tenancy Agreement and park rules, tick 
        “has disclosed” in Section 4 and any applicable boxes in (a) and (b); all 
        parties initial at that time.
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Disclosure Not Received Before Offer (C): </strong>Tick 
        “shall provide” in Section 4 and include the subject clause below. After 
        the offer, the Seller/listing agent completes (a) and (b), initials, and 
        returns the updated offer with disclosure; the Buyer initials changes and 
        gives written notice waiving/fulfilling their condition.
        </p>`,
      },
      {
        x: `1%`,
        y: `70%`,
        data: `<p><strong>Subject Clause - Seller's Disclosure: </strong><br/>Condition 
        for the Buyer's sole benefit:<br/> (a) Buyer to receive the Seller's Disclosure 
        within 48 hours of acceptance; and <br/>(b) Buyer to review and approve it 
        within 48 hours of delivery.
        </p>`,
      },
    ],
  },
  {
    id: 1092,
    form: `CPS-manu`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `12.5%`,
        data: `<p><strong>Park Owner's Consent - Overview: </strong>In a manufactured 
        home park, owners own the home but rent the site under the MHPTA; selling a 
        home on a rental site can require the park owner's consent to assign the site 
        tenancy.
        </p>`,
      },
      {
        x: `1%`,
        y: `37%`,
        data: `<p><strong>True Condition Precedent - Consent: </strong>If consent 
        is required, it must be obtained before the sale can complete; if consent 
        is not granted, the transaction cannot complete and the contract ends.
        If the park owner gives consent before the Section 5B deadline, the consent  
        condition is automatically satisfied, and both parties must complete the 
        sale. This condition operates independently from all other conditions in 
        the contract.</p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Step (a) - Request for Consent: </strong>If the Site 
        Tenancy Agreement requires consent, the Seller must complete and serve a 
        consent request per the MHPTA and its regulations (use Residential Tenancy 
        Branch Form RTB-10).
        </p>`,
      },
      {
        x: `1%`,
        y: `66%`,
        data: `<p><strong>Step (b) - RTB Form & 10-Day Window: </strong>The Seller and 
        Buyer complete and sign the RTB form; the Seller delivers it to the park 
        owner, who has 10 days to approve or refuse—no response within 10 days = 
        consent deemed given.
        </p>`,
      },
      {
        x: `1%`,
        y: `74%`,
        data: `<p><strong>Step (c) - Outside Date: </strong>Set the outside date at 
        least 10 days after notice so the park owner has the full MHPTA review period 
        to consider the Buyer as a proposed tenant.
        </p>`,
      },
      {
        x: `1%`,
        y: `79%`,
        data: `<p><strong>Step (d) - Agent Authorization: </strong>Section 5 authorizes 
        the Seller's designated agent/brokerage to communicate with the park owner 
        about consent, acting as the Seller's agent and identifying themselves as such.
        </p>`,
      },
    ],
  },
  {
    id: 1093,
    form: `CPS-manu`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Section 5B requires the party who receives the park 
        owner’s consent to promptly notify the other party, but this notice is 
        just for clarity. Not giving the notice does not cancel or affect the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Step (f) - When Consent Not Required: </strong>If the Site 
        Tenancy Agreement does not require consent, cross out Section 5 and have both 
        Buyer and Seller initial the change.
        </p>`,
      },
      {
        x: `1%`,
        y: `25%`,
        data: `<p><strong>Consent Limits & Termination: </strong>Park owners may only 
        withhold consent as allowed under the MHPTA. If consent isn't granted by the 
        deadline set in Section 5 (and the contract isn't amended), the sale cannot 
        complete and the contract ends; the Seller may request dispute resolution if 
        consent is improperly withheld.
        </p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Completion: </strong>Completion should follow this 
        sequence: 
        <ol class="letter-ol">
          <li>The Buyer's lawyer/notary prepares documents and sends them for the 
          Seller to sign and return</li>
          <li>The Buyer pays the price/down payment in trust several days before 
          completion and signs documents</li>
          <li>The Buyer's lawyer/notary files the signed title documents (and any 
          mortgages) at the Manufactured Home Registry</li>
          <li>The Buyer's lawyer/notary releases sale proceeds.</li>
        </ol>
        To avoid delays, deposit money and signed documents at least two days before completion, and the Seller should deliver signed transfers no later than the morning before completion.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Possession: </strong>Arrange possession through the 
        REALTORS®. The Buyer generally cannot move in until the Seller has received 
        sale proceeds. If there are residential tenants, both parties must follow 
        the Manufactured Home Park Tenancy Act and the Residential Tenancy Act.
        </p>`,
      },
      {
        x: `1%`,
        y: `67.5%`,
        data: `<p><strong>Included Items: </strong>List any outbuildings or similar 
        items <em>not</em> included in the sale in the “Excluding” section; otherwise, 
        all outbuildings are included.
        </p>`,
      },
      {
        x: `1%`,
        y: `73%`,
        data: `<p><strong>Title: </strong>The Buyer must satisfy themselves about 
        zoning, use/building restrictions, hazards, encroachments, and any encumbrances 
        that remain on title; the Seller must specify any encumbrances staying on 
        title. Lenders may refuse funding if title/restrictions are unacceptable. 
        If the Buyer assumes the Seller'’'s mortgage, the Seller may remain liable 
        unless released by the lender.
        </p>`,
      },
    ],
  },
  {
    id: 1094,
    form: `CPS-manu`,
    page: `4`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Customary Costs: </strong>Sellers typically pay their lawyer/notary
        for execution of documents, clearing title (discharge fees, prepayment penalties),
        and real estate commission. Buyers usually pay their lawyer/notary for title
        searches, investigations, drafting, Manufactured Home Registry fees, any required
        survey, mortgage-related costs (lender’s lawyer/notary, appraisal, registration),
        fire insurance premium, and applicable taxes (e.g., GST, sales tax). Adjustments
        between parties may also apply.</p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Risk: </strong>The Buyer should have insurance effective at
        12:01 a.m. on the completion date. The Seller should keep their insurance in
        place until the later of the completion date or the date the Seller receives
        the sale proceeds or vacates the unit.</p>`,
      },
      {
        x: `1%`,
        y: `58%`,
        data: `<p><strong>Form of Contract: </strong>This form is intended for buying/selling
        manufactured homes on rental sites. If the deal involves a new build, a different
        type of lease, a business, a non–rental-site assignment, a freehold residence,
        a bare land strata lot purchase, relocating the home at completion, or other
        special circumstances (e.g., land on a First Nations reserve), additional or
        different provisions may be needed and professional advice should be obtained.</p>`,
      },
    ],
  },
  {
    id: 1095,
    form: `CPS-manu`,
    page: `5`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Brokerage Information: </strong>Include the Brokerage's information 
        as displayed in this section. If applicable, include the MLS number of the 
        listing that the Buyer is making an offer on. In the "Prepared By" line, 
        include the name of the agent that is preparing the offer.</p>`,
      },

      {
        x: `1%`,
        y: `24.5%`,
        data: `<p><strong>Buyer/Seller Information: </strong>Input the full 
        legal names of both Buyers and Sellers. For Sellers, verify and insert their 
        names as they appear on title, along with the current addresses where they 
        reside. Check with the Seller's REALTOR® to obtain the Seller's current 
        address if it is not available in the Title Document.
        Take the extra step of cross-referencing your clients' IDs to guarantee 
        accuracy. If the client is a corporation, be sure to obtain documents, 
        such as the Articles of Incorporation, to confirm signing authority. 
        </p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p><strong>Manufactured Home Information: </strong>Enter the 
        Registration #, Serial Number, and CSA or TSBC Silver Label for the 
        manufactured home. Additionally, enter the Year, Make, and Model. Verify 
        this information against the Manufactured Home Registry search.
        The most common locations for this information is on the Data Plate
        which can usually be found in a kitchen cabinet, electrical panel, 
        bedroom closet, or stamped on the steel frame of the building.
        </p>`,
      },
      {
        x: `1%`,
        y: `53%`,
        data: `<p><strong>Site Location: </strong>In this Section, enter the details 
        of the site location where the manufactured home is located.
        </p>`,
      },
      {
        x: `1%`,
        y: `73%`,
        data: `<p><strong>Purchase Price: </strong>This is the price the Buyer is 
        offering for the property. It's important to confirm that the price is 
        consistent in both numerical and textual formats (example: $500,000 / Five 
        Hundred Thousand). This price includes all applicable GST, unless otherwise 
        agreed to in writing. If a counter offer occurs, ensure number/text formats 
        remain consistent.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1096,
    form: `CPS-manu`,
    page: `6`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Deposit: </strong>Insert the amount of the deposit to be 
        paid by the Buyer as part of the contract. The deposit is part of the 
        purchase price and must be paid in the way and to the person specified in 
        the contract. Unless stated otherwise, it's due within 24 hours of the 
        offer being accepted. Paying the deposit is an essential requirement—if the 
        Buyer doesn't pay on time, the Seller may choose to cancel the contract. 
        Any Deposit payments that are late require the REALTOR® to notify their 
        Managing Broker.
        </p>`,
      },
      {
        x: `1%`,
        y: `29.5%`,
        data: `<p><strong>Deposit Holder: </strong>Insert where the deposit will be 
        held.  This is typically the Buyer's Brokerage in most circumstances. Ensure 
        you enter the full name of the Brokerage. The deposit is held by a neutral 
        stakeholder and can't be released until the money clears and both Buyer and 
        Seller agree. If the Buyer fails to pay the deposit, the Seller may terminate 
        the contract. If the sale does not complete or park owner consent is 
        withheld under Clause 5, the funds must be returned to the appropriate party 
        or paid into Court.
        </p>`,
      },
      {
        x: `1%`,
        y: `46.5%`,
        data: `<p><strong>Terms & Conditions: </strong>Add all applicable terms and 
        conditions pertaining to the Contract in this section. It is strongly advised 
        to utilize the BCREA/BCFSA approved terms/conditions which are available 
        to all BC REALTORS®. For any customized clauses, it's essential to seek legal 
        advice/Managing Broker to ensure they are drafted correctly and protect your 
        clients' best interests.
        Only terms/conditions pertaining to the Buyers/Sellers should be 
        included in this section. Any conditions must be either fulfilled/waived in 
        a timely manner, using proper procedures, otherwise the contract may not be 
        enforceable.<br/>
        Any statements or acknowledgements made by a party to someone who is not part 
        of the contract (for example, their REALTOR®) should be recorded separately 
        and not included in the contract itself.<br/><br/>
        **See the clause section within the Transaction Checklists for commonly used 
        terms and conditions.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1097,
    form: `CPS-manu`,
    page: `7`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Manufactured Home Provisions: </strong>
        <ol>
          <li>Check the box that applies as to whether the Seller has either already 
          disclosed or will provide the disclosure within 48 hours of acceptance. 
          The Buyer then has 48 hours from delivery to review/approve, after which 
          the disclosure becomes part of the contract.</li>
          <li><strong>Section A: </strong> 
          Check the boxes that apply - The Seller must state whether a written 
          Site Tenancy Agreement exists and attach/provide copies within 48 hours if 
          they do.</li>
          <li><strong>Section B:</strong> Check the boxes that apply - The Seller must 
          state whether written Park Rules exist and attach/provide copies within 48 
          hours if they do.
          </li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Seller Compliance & Representations: </strong>The Seller 
        will comply with the Manufactured Home Park Tenancy Act and Regulations and 
        provide the Buyer copies of the written Site Tenancy Agreement (if any) and 
        Park Rules (if any). <br/><br/>The Seller confirms: <br/>(i) they are not, and 
        will not at Completion be, in breach of the Site Tenancy Agreement<br/> 
        (ii) the park owner is not entitled to terminate the agreement<br/>
        (iii) no termination notice has been given<br/>
        (iv) there are no active Rental Tenancy Breach (RTB) dispute applications or 
        grounds to start one.<br/>
        <br/>The Seller will keep complying with the Site Tenancy Agreement until the 
        Buyer takes possession.
        </p>`,
      },
      {
        x: `1%`,
        y: `47.5%`,
        data: `<p><strong>Park Owner's Consent - A: </strong>If consent is required, 
        the Seller must, within 5 days of acceptance, prepare a consent request that 
        complies with the MHPTA/Regulations. The Buyer promptly provides needed info; 
        within 2 days of receiving the request, both parties sign it, and the Seller 
        delivers it to the Park Owner. Both parties must promptly supply any further 
        information the Park Owner reasonably requests.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Park Owner's Consent - B: </strong>Insert the deadline for 
        the Park Owner to grant consent. This is a true condition precedent. If the 
        Park Owner gives consent on time, the consent condition is automatically 
        satisfied, and—assuming all other contract conditions are satisfied—the 
        Buyer and Seller must complete the transaction as agreed. Whoever receives 
        the consent must promptly notify the other party, but forgetting to give 
        that notice does not cancel the contract. 
        </p>`,
      },
      {
        x: `1%`,
        y: `81%`,
        data: `<p><strong>Park Owner's Consent - C: </strong>The Seller authorizes 
        their designated agent(s) and brokerage to communicate with the Park Owner, 
        deliver the consent request, and provide/receive information on the Seller's 
        behalf. The Park Owner may communicate directly with the Seller's 
        agent(s)/brokerage, and neither the agent(s)/brokerage nor the Park Owner 
        must confirm this authority with the Seller.
        </p>`,
      },

      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1098,
    form: `CPS-manu`,
    page: `8`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>Completion: </strong>This is the proposed date of 
        completion (the date that the money changes hands and the title will be 
        transferred to the Buyer). The sale completes at the Manufactured Home 
        Registry, and the assignment of the Site Tenancy Agreement takes effect on 
        the specified Completion Date you enter.
        </p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Possession Date: </strong> Insert the date/time of 
        possession, typically the day after the completion date. 
        This can mean when the Buyer can physically move in (physical) or just 
        becoming the legal owner while tenants remain. Usually, both happen at the 
        same time, but not always—and the Buyer can't move in until the Seller has 
        been paid. It is important to consider that if the property is tenanted and 
        the Buyer wants vacant possession, enough notice must be given so the Seller 
        can legally end the tenancy and provide vacant possession. If possession is 
        subject to any tenancies, they must be listed in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `37%`,
        data: `<p><strong>Adjustments: </strong> The adjustment date, often the same 
        as possession, is when the Buyer begins paying property expenses like taxes, 
        fees, and utilities, and also starts receiving any income, such as rent, from 
        the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p><strong>Included Items: </strong>Insert any additional items 
        (chattels) that are to be included in the Purchase Price.
        The Purchase Price includes the assignment of the Site Tenancy Agreement 
        and—unless listed under “Excluding”—all site outbuildings (e.g., garage/carport, 
        shed, lean-to, patio, entrance way, similar structures), plus all improvements to 
        the unit/outbuildings, fixtures, appurtenances and attachments (e.g., blinds, 
        awnings, screen doors/windows, curtain rods, tracks, valances, 
        fixed mirrors, fixed carpeting, and electric/plumbing/heating/AC fixtures) 
        as viewed on inspection.</p>`,
      },

      {
        x: `1%`,
        y: `63.5%`,
        data: `<p><strong>Excluding: </strong>These are items that are attached 
        to the home but the Seller wishes to exclude them from the sale. One reason 
        may be that the item listed has sentimental value like a lighting fixture. 
        Precision is key when itemizing excluded items, for instance, specifying 
        "master bedroom light fixture."
        </p>`,
      },
      {
        x: `1%`,
        y: `69%`,
        data: `<p><strong>Viewed: </strong>Insert the date(s) that the Buyer viewed 
        the property. The Seller agrees as per this statement that the property, and 
        all included items, will be in the same condition when the Buyers take 
        possession of the property. If the Buyer did not view the property, you may 
        require additional terms and conditions. Consult your Managing Broker for 
        guidance in cases where the Buyer did not view the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `73.5%`,
        data: `<p><strong>Title: </strong>This statement confirms that the Seller 
        must transfer ownership with a clear title, except for any encumbrances 
        specifically agreed to in the contract, and both parties should get legal 
        advice to confirm which encumbrances need to be cleared before closing.<br/><br/>
        <strong>Tender: </strong>This item outlines the acceptable methods 
        of payment, which include a certified cheque, bank draft, lawyer/notary 
        trust cheque, and real estate Brokerage trust cheques.<br/><br/>
        <strong>Documents: </strong>All documents needed to complete the sale must 
        be properly prepared and in a form that can be registered with the Manufactured 
        Home Registry by 4pm on the completion date.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1099,
    form: `CPS-manu`,
    page: `9`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-9.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Statutory Declaration Regarding Residency: </strong>If the 
        Seller is a resident of Canada, they must provide the Buyer, on or 
        before the Completion Date, a statutory declaration confirming they are 
        (and will be) a Canadian resident. If the Seller is a non-resident on the 
        Completion Date, the Buyer may withhold from the Purchase Price the amount 
        required under section 116 of the Income Tax Act. Failure to provide 
        residency status may cause the buyer complications. The buyer may need legal 
        and accounting advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `19.5%`,
        data: `<p><strong>GST Certificate: </strong>If the deal is GST-exempt, the 
        Seller must give the Buyer a GST exemption certificate by the Completion 
        Date. If GST applies, both Buyer and Seller must exchange appropriate GST 
        certificates by the Completion Date. This form is typically prepared by 
        the lawyers/notaries as part of the closing documents.
        </p>`,
      },
      {
        x: `1%`,
        y: `31%`,
        data: `<p><strong>Time: </strong>All contract dates must be strictly met. If 
        the Buyer fails to complete by the Completion Date, the Seller may terminate 
        and, in most cases, the Buyer's deposit is forfeited as damages. However, 
        the non-breaching party is not obliged to terminate and should weigh options 
        and seek legal advice before taking action.
        </p>`,
      },
      {
        x: `1%`,
        y: `41%`,
        data: `<p><strong>Buyer Financing: </strong>New mortgage funds are usually 
        not advanced until both the transfer and the lender's mortgage are submitted 
        to the Manufactured Home Registry. The Buyer and their lawyer/notary may 
        start registration on the Completion Date before mortgage funds arrive 
        if: <br/>(i) all lender conditions (except registration) are satisfied<br/>
        (ii) the Buyer has deposited their own required funds (excluding the 
        mortgage) with their lawyer/notary and <br/>(iii) the lawyer/notary gives 
        the Seller's lawyer standard undertakings. <br/>The Buyer must arrange the 
        mortgage and closing steps in advance; otherwise, they would need all funds 
        before registration starts.</p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Clearing Title: </strong>Where the Seller needs the Buyer's 
        funds to clear title, the Seller's lawyer/notary will receive the net sale 
        proceeds on an undertaking to first pay out and discharge any registered 
        encumbrances not permitted to remain under the CPS, then remit any balance to 
        the Seller. Without this arrangement, the Seller would have to deliver clear 
        title before closing.
        </p>`,
      },
      {
        x: `1%`,
        y: `67%`,
        data: `<p><strong>Costs: </strong>The Buyer pays all conveyance costs 
        (and any mortgage-arrangement costs, if applicable), while the Seller pays 
        all costs to clear title.<br/><br/>
        <strong>Risk: </strong>Until 12:01 a.m. on the Completion Date, the Unit and 
        Included Items are at the Seller's risk; after that time, risk shifts to the 
        Buyer.<br/><br/>
        <strong>Plural: </strong>References to a party include that party's 
        heirs, executors, administrators, successors, and assigns; singular includes 
        plural, and masculine includes feminine.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10910,
    form: `CPS-manu`,
    page: `10`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-10.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Representations and Warranties: </strong>The contract includes 
        only what is written in the CPS; outside promises are not binding unless 
        referenced. Certain terms, like warranties, survive completion and can still be 
        enforced after closing.
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Restriction on Assignment: </strong>The contract cannot be 
        assigned without the Seller's written consent, and any profit from an assignment 
        goes to the Seller. This restriction cannot be changed without written 
        instructions, and REALTORS® must disclose if it is not included. It is the 
        Buyer's REALTOR®'s responsibility to provide the "Notice to Seller Regarding 
        Assignment Terms" to the Seller's REALTOR® at the same time the offer is 
        presented.</p>`,
      },
      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Personal Information: </strong>By signing the CPS, Buyers and 
        Sellers consent to REALTORS® collecting, using, and disclosing their personal 
        information as required for the transaction, in line with privacy laws and the 
        Privacy Notice and Consent form.</p>`,
      },
      {
        x: `1%`,
        y: `50%`,
        data: `<p><strong>Agency Disclosure: </strong>Confirms the Buyer's and Seller's 
        agency relationships with their REALTORS®. All agents, co-listings, or Personal 
        Real Estate Corporations must be identified, with extra details added in the 
        contract or addendum if needed.<br/><br/>
        Have your clients initial the boxes that apply to the transaction as well as 
        insert the designated agent(s) and Brokerage involved.
        <ul >
          <li><strong>A:</strong> Seller acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>B:</strong> Buyer acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>C: </strong> In limited situations where dual agency is allowed, complete this 
          section with the appropriate information.</li>
          <li><strong>continued on next page...</strong></li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10911,
    form: `CPS-manu`,
    page: `11`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-11.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `8.5%`,
        data: `<p><strong>Agency Disclosure continued: </strong><br/><br/>
        <ul >
          <li><strong>D: </strong> To be completed if the Seller has an agency 
          relationship with a REALTOR® and the Buyer does not. Buyer initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
          <li><strong>E: </strong> To be completed if the Buyer has an agency 
          relationship with a REALTOR® and the Seller does not. Seller initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>Assignment of Remuneration: </strong>Authorizes payment of the 
        REALTOR® commission directly from the sale proceeds by the Buyer or their 
        representative.</p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Acceptance Irrevocable: </strong>By initialing this section, 
        both the Buyers and Sellers confirm the contract is made “under seal.” The 
        Seller cannot revoke (back out of) an accepted conditional offer until the 
        Buyer's conditions are removed or any contract options expire.
        </p>`,
      },
      {
        x: `1%`,
        y: `52.5%`,
        data: `<p><strong>Counterparts: </strong>The contract and any amendments may be 
        signed in separate copies and delivered by email, fax, or other electronic means. 
        All counterparts together are treated as one original document.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Client Initials: </strong>As with most other pages within 
        the Purchase Contract, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 10912,
    form: `CPS-manu`,
    page: `12`,
    imageURL: "../../images/BritishColumbia/forms/CPS-manu/CPS-manu-12.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Offer: </strong>Fully complete this section by 
        inserting the time and date of when this offer will be open for acceptance. 
        The offer or counter-offer remains open until the specified date and time unless 
        withdrawn in writing first. Once accepted in writing and notice is given, it 
        becomes a binding contract. If the offer is being countered, "counter-offer" 
        should be circled to indicate that it is a counter-offer. If new times are 
        needed, they should be amended and initialed each time a counter-offer is made.
        </p>`,
      },
      {
        x: `1%`,
        y: `22.5%`,
        data: `<p><strong>Buyer Declaration: </strong>The Buyer must initial in the 
        Yes or No box to declare whether they are a Canadian citizen or permanent 
        resident. If the Buyer is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `28.5%`,
        data: `<p><strong>Buyer Signature/Printed Name: </strong>Complete this 
        section by having all Buyers sign the offer along with their printed name. 
        You may only act as a witness for the Buyers signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>Acceptance: </strong> By signing, the Seller accepts the 
        offer subject to any conditions. Once conditions are met or waived, the 
        Seller must complete the sale. Signatures should be witnessed where possible, 
        and authority must be shown if signing for another.</p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Seller Declaration: </strong>The Seller must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Seller is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `63%`,
        data: `<p><strong>Seller Signature/Printed Name: </strong>Complete this 
        section by having all Sellers sign the offer along with their printed name. 
        You may only act as a witness for the Sellers signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `75%`,
        data: `<p><strong>Final Acceptance Date: </strong>Insert the date of when 
        final acceptance occurred. 
        </p>`,
      },
    ],
  },
  {
    id: 1101,
    form: `lease-res`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-1.png",
    description: `<p>The Lease Residential form is used to create a lease agreement 
    on behalf of a landlord for a residential property so that it can be listed on 
    the MLS®.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `16.5%`,
        data: `<p><strong>Landlord Information: </strong>Insert the full legal names 
        of all Owners/Landlords as noted on the Title Search. Double check your clients IDs 
        to ensure accuracy. Insert the address where they currently live. Ensure you 
        verify the owners/landlords current address as it may differ from the address 
        that is on Title.<br/><br/>
        <strong>Brokerage Information: </strong>Insert the full Brokerage 
        name as well as the other information requested in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Effective Date: </strong>Insert the date that this contract 
        starts. Typically it is the same date as when it is signed/delivered. If all 
        parties agree that the date is to be a future date, insert that date. It cannot 
        be a date that is before the contract is signed/delivered.<br/><br/>
        <strong>Expiry Date: </strong>Insert the date that this contract expires. It's 
        important to note that while this date is negotiable, some real estate boards 
        MLS rules have minimum listing periods.  
        </p>`,
      },
      {
        x: `1%`,
        y: `51%`,
        data: `<p><strong>Landlord Authorizations (1B): </strong>The Landlord:<br/> 
        (i) authorizes the Listing Brokerage to obtain property information from 
        authorities (e.g., BC Assessment) <br/>(ii) authorizes the Brokerage to 
        advertise the property and show it to prospective tenants during reasonable 
        hours <br/>(iii) agrees the Brokerage may place “For Rent”/“Rental” signs 
        and allow cooperating brokerages—and, with the Landlord's written consent, 
        a sub-agent—to show the property and <br/>(iv) restricts advertising to the 
        Listing Brokerage unless the Brokerage permits advertising by members of 
        its board or other real estate boards.
        </p>`,
      },
      {
        x: `1%`,
        y: `71.5%`,
        data: `<p><strong>Property: </strong> Insert the full civic address, unit 
        number (if applicable), city/town/municipality, postal code, leaseable 
        area/square footage, and the legal description as shown in the title search.
        It is important to cross reference this information with other sources
        such as BC Assessment to ensure accuracy. 
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1102,
    form: `lease-res`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `17%`,
        data: `<p><strong>Rent Price and Terms: </strong>This section specifies the 
        price at which the broker will list and advertise the property for rent. 
        The Owner/Landlord may still accept offers above or below the list price. 
        Add any extra terms the Owner/Landlord wants to include here. 
        </p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Listing Service & Cooperating Brokerages (Section 4): 
        </strong>The Landlord authorizes the Listing Brokerage to: <br/>(A) list the 
        property on the Board's MLS® or other boards it chooses and cooperate with 
        other brokerages/agents acting for tenants <br/>(B) publish and share 
        contract/data-input details and the rental rate (once there's an 
        unconditional accepted offer) on MLS®, the internet, and with parties like 
        BC Assessment <br/>(C) make all required agency disclosures.
        </p>`,
      },
      {
        x: `1%`,
        y: `44.5%`,
        data: `<p><strong>Listing Brokerage's Remuneration (Section 5) </strong><br/>
        A: The Landlord agrees to pay the commission set in 5D if:<br/>(i) a tenancy 
        agreement is entered during the contract term, or <br/>(ii) a tenancy is 
        entered within 6 months after expiry with a tenant introduced during the term 
        (by anyone).<br/><br/>
        B: Payment is due at the earlier of completion/commencement (or within 7 days 
        of written demand if no contract).<br/><br/>
        C: The Brokerage may share commission with 
        cooperating brokerages/sub-agents, and amounts payable (including taxes) are 
        set in 5D; if a co-broker is involved, their share is paid out of the 
        Landlord's remuneration.
        </p>`,
      },
      {
        x: `1%`,
        y: `68%`,
        data: `<p><strong>Total Commission: </strong> Insert the amount 
        of commission the listing Brokerage will receive under this contract. As per 
        the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `77.5%`,
        data: `<p><strong>Cooperating Brokerage Commission: </strong> Insert the amount 
        of commission that will be offered to a cooperating Brokerage, if one exists. 
        As per the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1103,
    form: `lease-res`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `10%`,
        data: `<p><strong>Listing Brokerage Commission Remaining: </strong> If a 
        Cooperating Brokerage is involved, insert the amount of commission that will 
        be retained by the listing Brokerage. <br/><br/>
        <strong> The amount inserted here = Total Commission - Cooperating Brokerage 
        Commission.</strong>
        </p>`,
      },
      {
        x: `1%`,
        y: `17%`,
        data: `<p><strong>Listing Brokerage Commission (if no Cooperating Brokerage): 
        </strong> If there is no Cooperating Brokerage, insert the amount of 
        commission that the listing Brokerage will receive.<br/><br/>

        <strong>This amount should be the same as the Total Commission located in 5D (i).</strong>
        </p>`,
      },
      {
        x: `1%`,
        y: `30%`,
        data: `<p><strong>Assignment of Remuneration: </strong>The Landlord is 
        giving the Listing Brokerage full rights to collect the commission that's 
        owed. The Brokerage is allowed to take their payment directly from any 
        deposit money being held. The Landlord understands that the Brokerage may 
        share some or all of that commission with another brokerage or an agent who 
        helped in the deal.
        </p>`,
      },
      {
        x: `1%`,
        y: `40.5%`,
        data: `<p><strong>Designated Agent: </strong>Insert the name(s) of the 
        designated agent(s) for the property. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1104,
    form: `lease-res`,
    page: `4`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>Listing Brokerage Agrees: </strong>The Brokerage will 
        <br/>(A) not accept payment from the tenant without the Landlord's knowledge 
        and consent<br/>(B) provide the services in Schedule “A”<br/>(C) supervise 
        the Designated Agent's compliance with this contract and brokerage 
        policies<br/>(D) keep the Landlord's confidential information private unless 
        authorized or required by law<br/>(E) treat the Landlord, tenants, and other 
        represented landlords even-handedly and impartially<br/>(F) hold all monies 
        in trust in accordance with the Real Estate Services Act.
        </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>Landlord Agrees: </strong>The Landlord will<br/>(A) 
        promptly direct all tenancy inquiries/offers to the Designated Agent<br/>(B) 
        accept a bona fide offer during the term from a ready, willing, and able 
        tenant on the stated terms<br/>(C) confirm authority to rent and to enter this 
        contract<br/>(D) disclose all third-party claims/interests<br/>(E) disclose 
        known material latent defects and allow the agent to inform prospects<br/>(F) 
        ensure information provided is accurate to the best of their knowledge<br/>(G) 
        immediately advise of material changes to the property or information 
        provided<br/>(H) supply all information needed to list/market the 
        property<br/>(I) acknowledge the Designated Agent provides real estate
         services only (not legal/tax/inspection/etc.)<br/>(J) confirm the property 
         is not under another listing contract.
         </p>`,
      },

      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1105,
    form: `lease-res`,
    page: `5`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Landlord Acknowledges: </strong><br/>
        (A - previous page) Property information may be disclosed to interested parties (prospective 
        tenants and their agents, appraisers, financial institutions, governments, 
        and related departments/agencies).<br/>
        (B) Real Estate Services Rule 30 duties apply only to the Designated Agent 
        (not to other REALTORS® at the Listing Brokerage).<br/>
        (C) The Listing Brokerage/Designated Agent may represent other landlords or 
        tenants provided this does not create a prohibited dual agency.<br/>
        (D) If services to the Landlord and to another party would create an 
        impermissible dual agency, the Brokerage/Designated Agent must follow 
        Rule 65 and may need to cease acting for the Landlord.<br/>
        (E) The Brokerage/Designated Agent are not required to disclose to the 
        Landlord confidential information obtained through any other agency 
        relationship.<br/>
        (F) A Designated Agent acting only for a tenant owes no agency duties to the 
        Landlord.
        </p>`,
      },
      {
        x: `1%`,
        y: `33.5%`,
        data: `<p><strong>12. Conflicts of Interest: </strong>If the Designated 
        Agent's work for the Landlord and an existing agency with a tenant would 
        create a prohibited dual agency, the Agent may seek consent from both 
        parties; otherwise the parties must adjust representation as follows:<br/>
        (i) If the Agent stops acting for the tenant, the Landlord acknowledges the 
        Agent may act for that tenant later on other properties.<br/>(ii) If the 
        Agent stops acting for the Landlord, the Brokerage may designate another 
        REALTOR® for the Landlord or refer the Landlord to another brokerage (the 
        Landlord need not accept the referral).<br/>(iii) If the Agent stops acting 
        for the Landlord: (A) the Agent has no further duties to the Landlord (other 
        than confidentiality under Rule 30(e)); and (B) the Brokerage and Agent may 
        continue to represent the tenant consistent with the consent process and 
        Real Estate Services Rules.
        </p>`,
      },

      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1106,
    form: `lease-res`,
    page: `6`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Collection, Use & Disclosure of Personal Information: </strong>
        The Landlord consents to the Listing Brokerage (and its managing/associate brokers and reps), the Board, and any other real estate board collecting, using, and disclosing the Landlord’s personal information:<br/>
        (i) for purposes consistent with listing, marketing, and renting the Property;<br/>
        (ii) for placement in the MLS® database of the Board and any other board the Brokerage selects and accesses;<br/>
        (iii) for marketing by the Board/other boards in any medium, including posting/distributing personal information to the public, Board members, other boards, governments and agencies, appraisers, and others;<br/>
        (iv) for compilation/retention/publication of statistics (including historical MLS® data) for authorized MLS® users;<br/>
        (v) for enforcing codes of conduct/ethics for Board and other real estate board members;<br/>
        (vi) for other purposes authorized in this Contract (including Clauses 1B, 4A, 7B, 9A); and<br/>
        (vii) for the purposes/recipients described in BCREA’s Privacy Notice and Consent form.<br/>
        <em>Note:</em> (B) Personal information may be stored on databases outside Canada and be subject to the laws of that jurisdiction.</p>`,
      },
      {
        x: `1%`,
        y: `39%`,
        data: `<p><strong>Termination: </strong><br/>
        (A) Subject to acquired rights under 
        Clause 5, this Contract ends:<br/>(i) on the expiry date in Clause 1A<br/>(ii) earlier if the Landlord and 
        Brokerage agree in writing<br/>(iii) upon a completed tenancy agreement before 
        expiry<br/>(iv) immediately if the Brokerage's licence is 
        suspended/cancelled/inoperative under the Real Estate Services Act<br/>(v) on 
        the Brokerage's bankruptcy/insolvency/receivership<br/>(vi) if the Brokerage 
        and Designated Agent cannot continue to provide trading services due to 
        Part 5 of the Real Estate Services Rules.<br/>
        <br/>(B) Upon termination, the Brokerage/Designated Agent will: <br/>(i) 
        cease all marketing<br/>(ii) remove all signs and <br/>(iii) if requested 
        by the Landlord, return all documents and materials provided by the 
        Landlord.
        </p>`,
      },
      {
        x: `1%`,
        y: `68%`,
        data: `<p><strong>Miscellaneous Provisions: </strong><br/>
        (A) The “term” includes any written extensions.<br/>
        (B) Interpretation/enforcement is governed by the laws of British Columbia.<br/>
        (C) This contract constitutes the entire agreement between the parties.<br/>
        (D) The contract binds and benefits the parties and their heirs, executors, administrators, successors, and assigns.<br/>
        (E) The Landlord and Listing Brokerage assign to the Board (and other real estate boards) the rights/interests needed to disseminate property information.</p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1107,
    form: `lease-res`,
    page: `7`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Counterparts: </strong>The contract and any amendments may be 
        signed in separate copies and delivered by email, fax, or other electronic means. 
        All counterparts together are treated as one original document.</p>`,
      },
      {
        x: `1%`,
        y: `30.5%`,
        data: `<p><strong>Contract Signed, Sealed, and Delivered Date: </strong>Insert 
         the date that the contract was signed, sealed, and delivered.  The date must 
         not be inserted until the last party signs. This date must be on or before 
         the effective (start) date of the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `39%`,
        data: `<p><strong>Landlord Declaration: </strong>The Landlord must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Landlord is unsure of their residency status, 
        they should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `47%`,
        data: `<p><strong>Landlord Signature/Printed Name: </strong>Complete this 
        section by having all Landlords sign the contract.  You may only act as a 
        witness for the Landlords signature if you are present and watch them sign. In 
        the case of a Power of Attorney (POA), the individual signing would be their 
        name followed by "as POA for (full legal name of the individual)".
        </p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Managing Broker/Designated Agent Signatures: </strong> 
        Complete this section by having the Managing Broker/Designated Agent sign the 
        contract. Additionally, insert the full Brokerage name and the printed name of 
        the designated agent in their respective locations.
        </p>`,
      },
    ],
  },
  {
    id: 1108,
    form: `lease-res`,
    page: `8`,
    imageURL: "../../images/BritishColumbia/forms/lease-res/lease-res-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Address/Pages: </strong>Insert the property address 
        being leased and note the total number of pages that make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>List of Services Provided to the Landlord: </strong>This Schedule is where 
        you  must outline the services you will provide to the Client. It should be 
        treated as a living document, evolving as you expand your list of 
        services.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Owner/Landlord Initials (far right): </strong>Have ALL of the 
        Owners/Landlords initial in the box.
        </p>`,
      },
    ],
  },
  {
    id: 1111,
    form: `buyer-acknowledgement`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Buyer/buyer-acknowledgement-1.png",
    description: `<p>The Buyer Acknowledgement form is used to indicate that the Buyer 
    has read and acknowledged the terms of the contract as well as understands their 
    rights under their agency relationshipt with a REALTOR®. It's meant for buyers 
    who want to work with a REALTOR® but aren't ready to commit to an exclusive 
    contract with a brokerage.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
    ],
  },
  {
    id: 1112,
    form: `buyer-acknowledgement`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Buyer/buyer-acknowledgement-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
    ],
  },
  {
    id: 1113,
    form: `buyer-acknowledgement`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Buyer/buyer-acknowledgement-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
    ],
  },
  {
    id: 1121,
    form: `BAEC`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-1.png",
    description: `<p>This form is a legally binding agreement that defines the 
    relationship between the Buyer, the REALTOR®, and the Brokerage. It sets the 
    terms of service and clarifies the REALTOR'S® duties, including limits on 
    loyalty, confidentiality, and disclosure, to protect both the client and the 
    REALTOR®.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
    ],
  },
  {
    id: 1122,
    form: `BAEC`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13.5%`,
        data: `<p><strong>Buyer Information: </strong>Insert the full legal names 
        of all Buyers. Double check your clients IDs to ensure accuracy. Insert the 
        address where they currently live.
        <br/><br/>
        <strong>Brokerage Information: </strong>Insert the full Brokerage 
        name as well as the other information requested in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Commencement Date: </strong>Insert the date that this contract 
        starts. Typically it is the same date as when it is signed/delivered. If all 
        parties agree that the date is to be a future date, insert that date. It cannot 
        be a date that is before the contract is signed/delivered.<br/><br/>
        <strong>Expiry Date: </strong>Insert the date that this contract expires. It's 
        important to note that this date is negotiable. Discuss the current market 
        conditions and Buyer's needs to help determine a reasonable expiry date.
        </p>`,
      },
      {
        x: `1%`,
        y: `50%`,
        data: `<p><strong>Market Area: </strong>Insert the market area(s) that the 
        Buyer is interested in. It can be more than one, depending on the Buyer's 
        needs.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Designated Agent: </strong>Insert the name(s) of the 
        designated agent(s) acting for the Buyer. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1123,
    form: `BAEC`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Designated Agent Duties: </strong><br/>The Designated Agent 
        will:<br/>(A) act only for the Buyer for any property of interest<br/>(B) 
        subject to Clause 4A, use reasonable commercial efforts to promote the 
        Buyer's interests<br/>(C) at the earliest reasonable opportunity, advise 
        any seller that they represent the Buyer<br/>(D) obey all lawful Buyer 
        instructions consistent with the Real Estate Services Act, the Real Estate 
        Services Rules, the REALTOR® Code, and applicable board/association rules, 
        bylaws, regulations, and policies<br/>(E) fulfill duties under (i) Real 
        Estate Services Rule 30 (as modified or made inapplicable by agreement with 
        the Buyer's Brokerage) and (ii) Rules 33 and 34 and<br/>(F) make the Buyer 
        aware of MLS® listings in the market area and other properties known to the 
        agent that may meet the Buyer's requirements.
        </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>Buyer's Brokerage Agrees: </strong><br/>The Brokerage will:
        <br/>(A) provide the services set out in Schedule “A” (if attached)<br/>(B) 
        monitor and supervise the Designated Agent to ensure compliance and the 
        Brokerage's policies/procedures for designated agents<br/>
        (C) keep the Buyer's confidential information private unless authorized by 
        the Buyer or required by law<br/>(D) treat the interests of the Buyer and 
        all sellers/other buyers represented by the Brokerage in an even-handed, 
        objective, and impartial manner<br/>(E) hold all monies received by the 
        Buyer's Brokerage in trust in accordance with the Real Estate Services Act
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Buyer Agrees: </strong><br/>The Buyer will:<br/>(A) not use 
        any other brokerage/licensee within the Market Area during this Contract 
        term<br/>(B) tell the Designated Agent about properties of interest in the 
        Market Area<br/>(C) provide enough financial information for the Agent to 
        assess ability to purchase or obtain a mortgage<br/>(D) negotiate in good 
        faith on satisfactory properties and terms<br/>(E) allow disclosure of the 
        Buyer's identity unless the Buyer instructs otherwise in writing<br/>(F) 
        acknowledge the Agent provides real estate services only (not legal, tax, 
        lending, appraisal, surveying, engineering, inspection, or other 
        professional advice)<br/>(G) understand the Agent may have limited knowledge 
        of a property's condition; information from sellers/listing brokerages/others 
        isn't warranted by the Agent or Brokerage and is relied on at the Buyer's 
        risk—the Buyer should conduct their own inquiries and obtain an independent 
        inspection
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1124,
    form: `BAEC`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `16%`,
        data: `<p><strong>Remuneration: </strong>Insert the amount of remuneration agree to 
        by the Buyer and the Brokerage. Typically this is shown as a percentage but 
        can be shown as a fixed amount. Discuss with your client how remuneration is 
        paid and what their obligations are under the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `65%`,
        data: `<p><strong>Agency Disclosures (Buyer): </strong><br/>(A) Rule 30 
        duties apply only to the Designated Agent—not to other licensees at the 
        Buyer's Brokerage and, subject to Clauses 4B-4D, not to the Brokerage 
        itself.<br/>(B) The Brokerage/Designated Agent may act for other buyers or 
        for sellers, provided this does not create a prohibited dual agency under 
        Part 5 of the Real Estate Services Rules.<br/>(C) If representation would 
        create an impermissible dual agency, the Brokerage/Designated Agent must 
        comply with Rule 65 and may have to cease providing certain services to the 
        Buyer.<br/>(D) Despite Rule 30(f), the Brokerage/Designated Agent are not 
        required to disclose to the Buyer confidential information obtained through 
        any other agency relationship.<br/>(E) If the property isn't listed with a 
        brokerage, the Buyer's Brokerage may enter a fee agreement with the seller, 
        but the Designated Agent will not act as the seller's agent.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1125,
    form: `BAEC`,
    page: `5`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Dual Agency (8A) - Buyer vs. Seller:</strong> If 
        representing both the Buyer and the Seller would create a prohibited dual 
        agency, the Designated Agent may seek consent for a Consent Agreement so they 
        can continue for only one party and end agency with the other.<br/>If the 
        Agent ceases to act for the Buyer:<br/>
        (i) the Agent may still act for the Buyer in future on other properties<br/>
        (ii) the Buyer's Brokerage may designate another licensee for the Buyer or 
        refer the Buyer to another brokerage (referral not obligatory to accept) and
        <br/>(iii) the Agent's agency duties to the Buyer end (except confidentiality 
        under Rule 30(e)), and the Brokerage/Agent may continue to represent the Seller 
        under the Consent Agreement and the Rules.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Dual Agency (8B) - Buyer vs. Other Buyer:</strong> If 
        representing the Buyer and another client-buyer (“Other Buyer”) would create 
        a prohibited dual agency, the Agent may seek consent via a Consent Agreement 
        to continue with only one buyer and terminate with the other.<br/>If the Agent 
        ceases to act for the Buyer:<br/>
        (i) the Agent may continue to act for the Buyer in future on properties other 
        than the subject Property<br/>
        (ii) the Buyer's Brokerage may designate another licensee for the Buyer or 
        refer the Buyer to another brokerage (referral not obligatory to accept) 
        and<br/>
        (iii) the Agent's agency duties to the Buyer end (except confidentiality 
        under Rule 30(e)), and the Brokerage/Agent may continue to represent the O
        ther Buyer under the Consent Agreement and the Rules.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1126,
    form: `BAEC`,
    page: `6`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `23%`,
        data: `<p><strong>Buyer Privacy Consent: </strong>The Buyer consents to the 
        Buyer's Brokerage, its managing/associate brokers and representatives 
        (“Licensee”), and the relevant real estate board collecting, using, and 
        disclosing the Buyer's personal information:<br/>
        (i) for providing real estate services, including: (a) 
        locating/assessing/qualifying properties; (b) advertising on the Buyer's 
        behalf (c) sharing information with third parties (lawyers/notaries, lenders, government bodies, inspectors, etc.)<br/>
        (ii) for placement in the MLS® database if the purchased property is listed on MLS®;<br/>
        (iii) for compilation/retention/publication of statistics (including historical MLS® data) for authorized MLS® users;<br/>
        (iv) for enforcing professional conduct/ethics codes of real estate boards;<br/>
        (v) for other purposes appropriate to listing, marketing, and selling real estate;<br/>
        (vi) for all other purposes authorized in this Contract; and<br/>
        (vii) for the purposes (and recipients) described in BCREA’s Privacy Notice and Consent form.<br/>
        <em>Note:</em> (B) Buyer’s personal information may be stored on databases outside Canada and thus be subject to the laws of that jurisdiction.</p>`,
      },
      {
        x: `1%`,
        y: `63%`,
        data: `<p><strong>Termination: </strong>Without affecting any acquired rights (including Section 6), this Contract ends:<br/>
        (i) at the expiry date in Clause 1B;<br/>
        (ii) earlier if the Buyer and the Buyer’s Brokerage agree in writing;<br/>
        (iii) upon the Buyer completing a purchase in the Market Area before expiry;<br/>
        (iv) immediately if the Brokerage’s licence is suspended/cancelled/inoperative under the Real Estate Services Act;<br/>
        (v) upon the Brokerage’s bankruptcy/insolvency/receivership; and<br/>
        (vi) if the Brokerage and Designated Agent cannot continue to provide trading services due to Part 5 of the Real Estate Services Rules.<br/><br/>
        <strong>Upon termination:</strong><br/>
        (i) the Brokerage and Designated Agent will cease all activities for the Buyer; and<br/>
        (ii) if the Buyer requests, they will return all Buyer-provided documents and materials.</p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1127,
    form: `BAEC`,
    page: `7`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `12.5%`,
        data: `<p><strong>Miscellaneous Provisions: </strong><br/>
        (A) “Sale” includes an exchange, and “purchase price” includes the value of property exchanged.<br/>
        (B) The “period” or “date of expiration” includes any written extension.<br/>
        (C) Interpretation and enforcement are governed by the laws of British Columbia.<br/>
        (D) This Contract is the entire agreement between the parties.<br/>
        (E) The Contract binds and benefits the parties and their heirs, executors, administrators, successors, and assigns.<br/>
        (F) “Property” may include a leasehold interest; a business (with goodwill and assets); an interest/partnership/share in a business (or its goodwill/assets); a manufactured home; and any other real property designated by a seller.</p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Agreement: </strong><br/>
        (A) The Buyer has read and understands this Contract, confirms it accurately reflects the agreement with the Buyer’s Brokerage, and has received a copy.<br/>
        (B) If there is more than one Buyer, each Buyer’s obligations are joint and several.<br/>
        (C) This Contract (and any amendments/attachments) may be signed in counterparts and delivered by fax, email, or other electronic means; all counterparts together form one original document.</p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Contract Signed, Sealed, and Delivered Date: </strong>Insert 
         the date that the contract was signed, sealed, and delivered.  The date must 
         not be inserted until the last party signs. This date must be on or before 
         the commencement (start) date of the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Buyer Declaration: </strong>The Buyer must initial in the 
        "Yes" or "No" box to declare whether they are a Canadian citizen or a 
        permanent resident as defined by the Immigration and Refugee Protection Act.
        If the Buyer is unsure of their residency status, they should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `69%`,
        data: `<p><strong>Buyer Signature: </strong>Complete this 
        section by having all Buyers sign the contract.  You may only act as a 
        witness for the Buyers signature if you are present and watch them sign. 
        </p>`,
      },
      {
        x: `1%`,
        y: `77%`,
        data: `<p><strong>Managing Broker/Designated Agent Signatures: </strong> 
        Complete this section by having the Managing Broker/Designated Agent sign the 
        contract. Additionally, insert the full Brokerage name and the printed name of 
        the designated agent in their respective locations.
        </p>`,
      },
    ],
  },
  {
    id: 1128,
    form: `BAEC`,
    page: `8`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/BAEC/BAEC-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>List of Services Provided to the Buyer: </strong>This Schedule is where 
        you  must outline the services you will provide to the Client. It should be 
        treated as a living document, evolving as you expand your list of 
        services.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1131,
    form: `buyer-ack-info`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/buyer-ack-info-1.png",
    description: `<p>This form confirms that the REALTOR® advised buyers about the 
    risks of making offers without typical conditions. It helps buyers make informed 
    choices, highlights that the 3-day Home Buyer Rescission Period may not allow 
    enough time for due diligence, and reduces risk for all parties by drawing 
    attention to these issues.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Brokerage/Buyer Information: </strong>Insert the date that 
        this form is being prepared, the full brokerage name, the designated agent's 
        name, and the Buyer's name(s). For the Address, insert the civic address of 
        the property being offered on.
        </p>`,
      },
      {
        x: `1%`,
        y: `30%`,
        data: `<p><strong>Buyer Acknowledgment: </strong>The Buyer understands the 
        increased risks and potential consequences of omitting typical conditions 
        and not completing due diligence in BC real estate transactions, and 
        instructs the REALTOR® to submit an offer for this Property without the 
        initialed conditions below.
        </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial in 
        the applicable box(es) corresponding to the conditions they have chosen to 
        exclude from the offer. Ensure they initial for each of the conditions that 
        are being excluded. If you have advised conditions not listed in the above list, 
        you can use the "Other" section to document them and have the Buyer(s) initial 
        in the box. 
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer Initials: </strong>Have ALL of the Buyers initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1132,
    form: `buyer-ack-info`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Buyer/buyer-ack-info-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `25%`,
        data: `<p><strong>Relevant Advisements: </strong>REALTORS® must act in 
        their clients' best interests and make reasonable efforts to gather 
        and share accurate information. If certain details cannot be confirmed, 
        you should document the information, its source, and the reason it 
        cannot be verified. This section is meant for noting such 
        uncertainties—for example, unverified property square footage—rather 
        than placing them in the Contract of Purchase and Sale.
        </p>`,
      },
      {
        x: `1%`,
        y: `75%`,
        data: `<p><strong>Date/Buyer(s) Signature/Printed Name: </strong>Insert 
        the date when this acknowledgement is being signed by the Buyer(s). 
        Complete this section by having the Buyer(s) sign the acknowledgement 
        along with their printed name. You may only act as a witness for the 
        Buyer(s) signature if you are present and watch them sign.
        </p>`,
      },
    ],
  },
  {
    id: 1141,
    form: `colist-joint`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Listing/colist-joint-1.png",
    description: `<p>This form is used when a seller engages multiple brokerages or 
    agents to list and represent their property jointly. It may also be used by a 
    sole Seller who wishes to work with more than one listing agent.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Date: </strong>Insert the date that the listing contract 
        was entered into.<br/><br/>
        <strong>Property Address: </strong> Insert the civic address of the property 
        that is listed
        </p>`,
      },

      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Listing Brokerage: </strong> Insert the full name of the Listing 
        Brokerage.<br/><br/>
        <strong>Co-Listing Brokerage: </strong>Insert the full Co-Listing
        Brokerage name/address as well as the other information requested in this 
        section.<br/><br/>
        <strong>Co-Listing Designated Agent(s): </strong>Insert the name(s) of the 
        designated agent(s) for the property. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted. 
        </p>`,
      },
      {
        x: `1%`,
        y: `32%`,
        data: `<p><strong>Remuneration: </strong> 
        <ol> 
        <li>Insert the full breakdown of commission for the situation where there 
        is a Listing Brokerage, Co-Listing Brokerage, and Co-operating Brokerage.</li>
        <li>Insert the full breakdown of commission for the situation where there 
        is no Co-operating Brokerage and only a Listing Brokerage and a Co-Listing 
        Brokerage exist in the transaction.</li>
        <li>Insert the full breakdown of expenses between the Listing and Co-Listing 
        Brokerage in relation to advertising, MLS® fees, and other expenses. Be exact 
        about the fees and the split—just saying 50/50 could leave you with a big 
        bill, especially for advertising expenses.</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `54%`,
        data: `<p><strong>Expiration Date: </strong> Insert the date that the listing 
        contract will expire if the parties wish to amend it from the original listing 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `77%`,
        data: `<p><strong>Listing Brokerage/Designated Agent(s): </strong>Insert the 
        name(s) of the listing brokerage and the designated agent(s) for the property. 
        If a team, all team members must be listed individually. If a PREC, then the
        REALTOR®'s name followed by  "Personal Real Estate Corporation" or "PREC" 
        should be inserted. 
        </p>`,
      },
      {
        x: `1%`,
        y: `83%`,
        data: `<p><strong>Signed, Sealed, and Delivered Date: </strong>Insert 
        the date that this form was signed, sealed, and delivered.  The date must 
        not be inserted until the last party signs. This date must be on or before 
        the listing contract has been fully signed.<br/><br/>
        <strong>Seller(s)/Managing Broker Signature: </strong>Complete this 
        section by having the Seller(s) sign the form. Additionally, have the 
        Managing Brokers from both the Listing and Co-Listing Brokerages sign the form.
        </p>`,
      },
    ],
  },
  {
    id: 1151,
    form: `colist-separate`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Listing/colist-separate-1.png",
    description: `<p>This form lets Sellers with conflicting interests each choose 
    their own brokerage or agent, even within the same company. Common uses for 
    this type of form are in a divorce situation. Before using this 
    form, REALTORS® should advise Sellers to seek legal advice to confirm this 
    co-listing protects their interests and is their preferred choice.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Property Address: </strong>Insert the civic address of the 
        property that is listed.
        </p>`,
      },
      {
        x: `1%`,
        y: `22%`,
        data: `<p><strong>Sellers: </strong>Insert full legal names of the Seller(s). 
        It is important to separate them in the "A" or "B" section accordingly. These 
        designations will match the Brokerages representing each Seller.
        </p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Seller A Brokerage/Designated Agent(s): </strong>Complete this section by 
        inserting the full details of Brokerage A. Double check that the information 
        matches the Seller that this brokerage is representing.
        </p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Seller B Brokerage/Designated Agent(s): </strong>Complete this section by 
        inserting the full details of Brokerage B. Double check that the information 
        matches the Seller that this brokerage is representing.
        </p>`,
      },
      {
        x: `1%`,
        y: `57.5%`,
        data: `<p><strong>Summary of Roles & Confidentiality (A): </strong>Seller A's 
        Designated Agent represents Seller A and Seller B's Designated Agent 
        represents Seller B, with each Brokerage owing its client the duties of 
        designated agency. All parties will act reasonably and cooperate on the 
        co-listing, promptly sharing material information about the property and 
        marketing; however, neither Brokerage nor Designated Agent will disclose 
        their client's confidential information without that client's prior consent.
        </p>`,
      },
      {
        x: `1%`,
        y: `66.5%`,
        data: `<p><strong>MLS Listing Brokerage & Changes (B): </strong>For MLS® posting, 
        Seller A's Brokerage is the “Listing Brokerage.” It must not make MLS® changes 
        without written instructions from both Sellers (or, for Seller B, from Seller 
        B's Brokerage or Designated Agent).<br/><br/>
        <strong>Marketing Plan (C): </strong>The Brokerages and Designated Agents 
        will market the Property in accordance with the marketing plan in Schedule A, 
        if any.
        </p>`,
      },
      {
        x: `1%`,
        y: `74.5%`,
        data: `<p><strong>Occupancy: </strong> Check the applicable box(es). 
        The parties confirm who resides/has possession (Seller A, Seller B, both, or 
        neither). </p>`,
      },
      {
        x: `1%`,
        y: `81%`,
        data: `<p><strong>Access: </strong> Check the applicable box(es). 
        Only the selected party(ies) and their Designated Agent(s) may access the 
        Property for listing activities without prior consent; all others require 
        consent, which must not be unreasonably withheld. 
        </p>`,
      },
      {
        x: `1%`,
        y: `88.5%`,
        data: `<p><strong>Initials: </strong>Have ALL of the parties initial in their 
        respective boxes.
        </p>`,
      },
    ],
  },
  {
    id: 1152,
    form: `colist-separate`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Listing/colist-separate-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `9%`,
        data: `<p><strong>New Listing Price & Terms: </strong> Insert the Listing 
        Price and other terms of the Listing. Section 3 of both 
        Sellers' Listing Agreements is deleted, and the Listing will proceed under 
        the replacement price and terms set out here.
        </p>`,
      },
      {
        x: `1%`,
        y: `9%`,
        data: `<p><strong>New Listing Price & Terms: </strong> Insert the Listing 
        Price and other terms of the Listing. Section 3 of both 
        Sellers' Listing Agreements is deleted, and the Listing will proceed under 
        the replacement price and terms set out here.
        </p>`,
      },
      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Brokerage Remuneration (Brief Summary): </strong><br/>
        Seller A & Seller B (jointly and severally) owe the commission in Clause 
        3C(i) to both brokerages if:<br/>(i) a binding sale contract is entered 
        during the Listing term or<br/>(ii) a buyer introduced during the term leads 
        to a sale within 60 days after expiry (or later if the brokerages' efforts 
        were an effective cause)—no fee if re-listed and sold under a new listing, or 
        if the buyer validly rescinds or<br/>(iii) a ready, willing, and able buyer 
        at the Listing Price/terms is produced during the term, even if the Sellers 
        refuse to sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Total Commission: </strong> Insert the amount 
        of commission the Brokerages will receive under this contract. As per 
        the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Total Commission: </strong> Insert the amount 
        of commission the Brokerages will receive under this contract. As per 
        the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `63%`,
        data: `<p><strong>Cooperating Brokerage Commission: </strong> Insert the amount 
        of commission that will be offered to a cooperating Brokerage, if one exists. 
        As per the preprinted statement, GST is added to the amount stated herein.
        </p>`,
      },
      {
        x: `1%`,
        y: `73%`,
        data: `<p><strong>Listing Brokerages Commission Remaining: </strong> If a 
        Cooperating Brokerage is involved, insert the amount of commission that will 
        be retained by the listing Brokerages. <br/><br/>
        <strong> The amount inserted here = Total Commission - Cooperating Brokerage 
        Commission.</strong>
        </p>`,
      },
      {
        x: `1%`,
        y: `80%`,
        data: `<p><strong>Listing Brokerage Commission (if no Cooperating Brokerage): 
        </strong> If there is no Cooperating Brokerage, insert the amount of 
        commission that the listing Brokerages will receive.<br/><br/>
        <strong>This amount should be the same as the Total Commission located in 5D (i).</strong>
        </p>`,
      },
      {
        x: `1%`,
        y: `88.5%`,
        data: `<p><strong>Initials: </strong>Have ALL of the parties initial in their 
        respective boxes.
        </p>`,
      },
    ],
  },
  {
    id: 1153,
    form: `colist-separate`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Listing/colist-separate-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `9%`,
        data: `<p><strong>Commission (if a Cooperating Brokerage is involved): 
        </strong> Insert the amount of commission that each Brokerage will receive in 
        the event that a Cooperating Brokerage is involved.
        </p>`,
      },
      {
        x: `1%`,
        y: `18%`,
        data: `<p><strong>Commission (if there is no Cooperating Brokerage): 
        </strong> Insert the amount of commission that each Brokerage will receive in 
        the event that there is no Cooperating Brokerage.
        </p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Sharing of Expenses: </strong> Insert how the listing 
        expenses will be shared between the listing Brokerages. Be exact 
        about the fees and the split—just saying 50/50 could leave you with a big 
        bill, especially for advertising expenses.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Other Terms of the Co-Listing: </strong> Insert any 
        additional agreed upon terms of the co-listing. As per the statement, you 
        can include a schedule if you run out of space.
        </p>`,
      },
      {
        x: `1%`,
        y: `54%`,
        data: `<p><strong>Expiry Date of the Co-Listing: </strong> If the parties 
        want to amend the expiration date as set out in the listing contract, insert 
        the new expiration date here.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Additional Acknowledgments: </strong><br/>(A) MLS® will 
        only accept listing instructions/changes from Seller A's Brokerage.<br/>
        (B) Any co-listing amendments must be in writing and signed by both 
        brokerages' managers and all Sellers.<br/>(C) Except as modified here, each 
        Seller's Listing Agreement remains in full force; no further changes without 
        a written agreement of all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `70%`,
        data: `<p><strong>Signed, Sealed, and Delivered Date: </strong>Insert 
         the date that the contract was signed, sealed, and delivered.  The date must 
         not be inserted until the last party signs.
        </p>`,
      },
      {
        x: `1%`,
        y: `75%`,
        data: `<p><strong>Seller Signature: </strong>Complete this 
        section by having all Sellers sign in their designated spot.  You may only 
        act as a witness for the Sellers signature if you are present and watch them 
        sign. In the case of a Power of Attorney (POA), the individual signing would 
        be their name followed by "as POA for (full legal name of the individual)". 
        If a Power of Attorney (POA) is used, insert the full legal name of the 
        individual and the name of the individual signing as POA.
        </p>`,
      },
      {
        x: `1%`,
        y: `83%`,
        data: `<p><strong>Managing Broker Signatures: </strong> 
        Complete this section by having the Managing Broker for each Brokerage sign 
        in their designated spot.
        </p>`,
      },
    ],
  },
  {
    id: 1154,
    form: `colist-separate`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/Listing/colist-separate-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Schedule A: </strong>This form requires each designated 
        agent to provide a list of intended joint and separate marketing activities. 
        </p>`,
      },
      {
        x: `1%`,
        y: `88.5%`,
        data: `<p><strong>Initials: </strong>Have ALL of the parties initial in their 
        respective boxes.
        </p>`,
      },
    ],
  },
  {
    id: 1161,
    form: `CPS-manu-addendum`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-addendum/CPS-addendum-manu.png",
    description: `<p>This addendum is a standard form used with the Contract of 
    Purchase and Sale of a Manufactured Home on a Rental Site to include additional 
    terms or conditions. It is attached to and becomes part of the contract when 
    signed by the parties. 
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the number of pages that form 
        the whole contract (far right of the page).</p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>MLS Information: </strong>Complete this section by 
        inputting the MLS number & Date of the Addendum.</p>`,
      },
      {
        x: `1%`,
        y: `19%`,
        data: `<p><strong>Property Information: </strong>Complete this section by 
        inputting the details of the property as found on the related CPS.</p>`,
      },
      {
        x: `1%`,
        y: `32%`,
        data: `<p><strong>Date & Party Information: </strong>Insert the date of the related
        CPS here. Since this is an addendum and to be added at the time of the CPS, the 
        date here should match that of the related CPS. 
        Additionally, include the full names of the Buyers and Sellers involved in 
        the transaction.
        </p>`,
      },
      {
        x: `1%`,
        y: `44%`,
        data: `<p><strong>Terms and Conditions: </strong>In this section, insert any 
        addtional terms and conditions that will form part of the Contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `69%`,
        data: `<p><strong>Buyer/Seller Signatures: </strong> Complete this section by 
        having all Buyers/Sellers sign along with their printed name. You may only 
        act as a witness for the signatures if you are present and watch them sign.
        By signing, all parties confirm their agreement to add the terms or 
        conditions in this document to the Contract of Purchase and Sale of a 
        Manufactured Home on a Rental Site.</p>`,
      },
    ],
  },
  {
    id: 1171,
    form: `disc-referral-payment`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-ref-payment.png",
    description: `<p>The Disclosure of Referral Payment form is used to inform 
    clients when a REALTOR® plans to make a referral payment. This ensures compliance 
    with the Real Estate Services Rules, such as when commission is shared with 
    another brokerage or an eligible individual. Disclosure should occur before 
    a client enters into a contract. While referral payments to unlicensed 
    individuals is allowed, it is important to know the rules and regulations 
    surrounding these circumstances as some restrictions do exist.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `16%`,
        data: `<p><strong>Date: </strong>Insert the date that the form is prepared.
        <br/><br/>
        <strong>Name of Client(s): </strong>Insert all client(s) full 
        legal names here.
        </p>`,
      },
      {
        x: `1%`,
        y: `24.5%`,
        data: `<p><strong>Property Address: </strong>Insert the civic address of the 
        property the referral payment is being made for.
        </p>`,
      },
      {
        x: `1%`,
        y: `41%`,
        data: `<p><strong>Referrer's Name: </strong>Insert the name(s) of the 
        REALTOR®(s) making the disclosure (sending the payment). If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `48%`,
        data: `<p><strong>Payment Amount: </strong> Insert the percentage of 
        remuneration or the dollar amount of the payment that the REALTOR® intends 
        to pay to another brokerage or person (including unlicensed individuals).
        </p>`,
      },
      {
        x: `1%`,
        y: `51.5%`,
        data: `<p><strong>Party Receiving Payment Amount: </strong> Insert the full 
        name of the Brokerage or unlicensed person who is to receive the payment.
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Referrer's Information: </strong> Insert the full 
        name of the Brokerage, the Designated Agent Signature, and the Designated 
        Agent's printed name who is making the disclosure. 
        </p>`,
      },
      {
        x: `1%`,
        y: `67%`,
        data: `<p><strong>Date of Receipt of Disclosure: </strong> Insert the date 
        when this disclosure is being acknowledged/signed by the client(s).<br/><br/>
        <strong>Client(s) Signature: </strong> Have all client(s) sign the form to 
        acknowledge their receipt of the disclosure.
        </p>`,
      },
    ],
  },
  {
    id: 1181,
    form: `disc-seller-remuneration`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-seller-remuneration-1.png",
    description: `<p>This form is required when presenting an offer to purchase 
    for your Seller's property. It discloses the amount the brokerages involved 
    will be paid in the transaction. These amounts may vary depending on the offers 
    that are received, and this information may influence how your Seller chooses to 
    proceed with the sale of their property. If you receive a counter-offer, the form 
    must be updated with the new amounts. The date on this form must be on or before 
    the acceptance of the offer.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `16%`,
        data: `<p><strong>Review Information: </strong>Ensure that you review the 
        information with your Seller client(s) so that they are aware of the purpose 
        of this form and how to properly interpret the information.
        </p>`,
      },
    ],
  },
  {
    id: 1182,
    form: `disc-seller-remuneration`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-seller-remuneration-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `25%`,
        data: `<p><strong>Name/Property Address: </strong>Insert the name of the Designated Agent 
        that is making the disclosure and the property address.
        </p>`,
      },
      {
        x: `1%`,
        y: `30.5%`,
        data: `<p><strong>Team Name & Members: </strong>Insert the team name and 
        any additional Designated Agents of the team that represent the Seller(s).
        <br/><br/>
        <strong>Seller(s): </strong>Insert the names of all the Sellers.
        </p>`,
      },
      {
        x: `1%`,
        y: `36%`,
        data: `<p><strong>Brokerage Name: </strong>Insert the full name of the 
        Listing Brokerage.
        <br/><br/>
        <strong>Buyers(s): </strong>Insert the names of all the potential Buyers.
        </p>`,
      },
      {
        x: `1%`,
        y: `41%`,
        data: `<p><strong>Signature of Designated Agent: </strong>The Designated 
        Agent making the disclosure should sign here. Only one signature is required.
        <br/><br/>
        <strong>Buyers(s) Brokerage: </strong>Insert the names of the Buyers 
        Brokerage, if applicable.
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Offer Details: </strong>In this section, insert the 
        following details for the original offer and each 
        counter-offer. 
        <ol>
        <li>Date of the offer/counter-offer</li>
        <li>Offered purchase price</li>
        <li>Date of the disclosure</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Payment Details: </strong>In this section, insert the 
        following details for the original offer and each counter-offer. The 
        amounts stated here must be a number and not a percentage.
        <ol>
        <li>Total amount of Remuneration</li>
        <li>The amount the Listing Brokerage will keep</li>
        <li>The amount the Buyers Brokerage will receive</li>
        <li>Any additional amounts the Sellers Designated Agent may receive from 
        other sources in relation to this transaction. If you are receiving this 
        type of payment an additional form is required, "Disclosure of Remuneration 
        - Trading Services"</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `80%`,
        data: `<p><strong>Consumer Acknowledgment: </strong>Although not required, 
        the Seller should initial to acknowledge that they have received the 
        disclosure.
        </p>`,
      },
    ],
  },
  {
    id: 1191,
    form: `disc-of-remuneration`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-of-remuneration-1.png",
    description: `<p>This form is required when you are expecting to receive 
    remuneration, related to the transaction, from a party that is not your client. 
    Generally, this would involve when you are representing a Buyer in a transaction 
    or when you are receiving a referral fee or other remuneration, related to the 
    transaction.
    <strong>Important: </strong> Must be dated on or before acceptance date on the 
    contract. Must be signed by all REALTOR®s receiving remuneration and all clients. You must disclose full 
    commission (pre-GST), including any bonuses or incentives.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>Notice/Property Address (Part A): </strong>Insert the name of the 
        client(s) as well as the property address that this disclosure relates to.
        </p>`,
      },
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Disclosure of Commission (Part B): </strong>Depending on the 
        transaction environment, fill out one of the following sections below.
        <ol>
        <li><strong>Acting for One Party: </strong>Fill out this section by inserting 
        the appropriate information when you are acting for one party. If you are 
        operating as a dual agent then leave this section blank and complete the next
        section.</li>
        <li><strong>Acting as a Dual Agent: </strong>Fill out this section by inserting 
        the appropriate information when you are acting as a dual agent. If you are 
        acting for one party then leave this section blank and complete the section 
        above.</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `54%`,
        data: `<p><strong>Disclosure of Referral Fees & Other (Part C): </strong> 
        If you are receiving a referral fee or other remuneration, related to the 
        transaction, from a party that is not your client, then fill out this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `75%`,
        data: `<p><strong>Acknowledgement (Part D): </strong> Complete this 
        section by inserting the geographical location where you are 
        signing from as well as the date of the disclosure. Insert your name and 
        complete with your signature.
        <br/><br/>
        <strong>Signature of Client(s): </strong> Insert the geographical location 
        where your clients are signing from as well as the date of the disclosure. 
        Have all client(s) sign the form to acknowledge their receipt of the 
        disclosure.
        </p>`,
      },
    ],
  },
  {
    id: 1201,
    form: `notice-seller-assignment-terms`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Buyer/notice-seller-assignment-terms-1.png",
    description: `<p>This form is required to be provided BEFORE ACCEPTANCE OF 
    AN OFFER by the Buyer's Agent to inform the Seller if an offer does not 
    include protections, as described in the form, against contract assignment. 
    If the Buyer's Agent does not provide it, the Listing Agent should. The form 
    explains that without these terms, the Buyer can assign the contract without 
    consent and keep any profit, ensuring the Seller is aware of the risks. If the 
    Buyer intends to add or change Buyers in the contract, this form must be used.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `16%`,
        data: `<p><strong>When to Use this Form: </strong> Ensure you read this carefully 
        to understand its requirements. If the offer contains terms that state the 
        contract cannot be assigned without written consent and/or that any profit 
        resulting from an assignment goes to the Seller, this form is not required.
        </p>`,
      },
      {
        x: `1%`,
        y: `45%`,
        data: `<p><strong>Part A: </strong> Insert the Seller names, civic 
        address, legal description, name of licensee providing notice, and the 
        date this notice is being provided.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Part B - Signatures/Acknowledgement: </strong> Insert all 
        Seller names, the date of the disclosure and signatures of all Sellers.
        </p>`,
      },
      {
        x: `1%`,
        y: `73%`,
        data: `<p><strong>Brokerage Use Only: </strong> This section is to be 
        completed by the Brokerage. Ensure a copy is provided so that it can be 
        completed and stored with the transaction files.
        </p>`,
      },
    ],
  },
  {
    id: 1211,
    form: `disc-interest-buying`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-buying-1.png",
    description: `<p>This disclosure must be provided to the client before 
    accepting a purchase contract. Its purpose is to inform the client of potential 
    risks when a licensee has a direct or indirect personal interest, such as 
    conflicts of interest or unequal bargaining power due to greater market 
    knowledge. The consumer is encouraged to ask questions or seek independent 
    advice if they have concerns about this disclosure or the risks involved. <br/>
    <strong>Important: </strong> Must be dated on or before acceptance date on the 
    contract. Must be completed if the REALTOR®, their spouse, parents, or kids are 
    Buying/Selling. If you are representing a REALTOR®, make sure they fill out this 
    form.
    </p>`,
    hotspots: [],
  },
  {
    id: 1212,
    form: `disc-interest-buying`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-buying-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Buyer/Seller Name(s)/Address Information: </strong> 
        Insert either the Buyer's or Seller's full name. The names refer to the party 
        you are disclosing to. Include the property address being sold or purchased. 
        Add the legal description of the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Licensee Information: </strong> Insert your name and 
        select the option below that applies to your situation in the transaction. 
        Depending on the selection, follow through to the indicated section in that 
        statement.<br/><br/>
        <strong>Definitions: </strong> Refer to the bottom of the last page of this
        document for the definitions of what an associate means.  
        </p>`,
      },
      {
        x: `1%`,
        y: `36%`,
        data: `<p><strong>Complete (if applicable): </strong> If applicable to your 
        situation, complete this section by inserting the name of the associate(s) 
        and your relationship to them. It is important to be as detailed as possible.
        </p>`,
      },
      {
        x: `1%`,
        y: `50.5%`,
        data: `<p><strong>Part B - Licensee or Associate is Buying: </strong> Complete 
        this section if the transaction involves a licensee or associate buying the 
        property.
        </p>`,
      },
      {
        x: `1%`,
        y: `56%`,
        data: `<p><strong>Details of Purchase:</strong> Complete 
        this section detailing the reason for the purchase by selecting the 
        appropriate option.
        </p>`,
      },
      {
        x: `1%`,
        y: `70%`,
        data: `<p><strong>Remuneration: </strong> If remuneration is being received 
        for this transaction, specify the amounts in dollars in the applicable 
        areas. If zero, you must insert "0".
        </p>`,
      },
    ],
  },
  {
    id: 1213,
    form: `disc-interest-buying`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-buying-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Part C - Licensee or Associate is Selling: </strong> This 
        section is only applicable if the transaction involves a licensee or an associate 
        they represent, selling the property. Select the option that applies to your situation.
        </p>`,
      },
      {
        x: `1%`,
        y: `35%`,
        data: `<p><strong>Location/Date: </strong> Insert the geographical location 
        where you are signing from as well as the date of the disclosure.<br/><br/>
        <strong>Signature of Licensee/Witness: </strong> As indicated in this section, 
        sign the form and if a witness is present, have them sign the form as well.
        </p>`,
      },
      {
        x: `1%`,
        y: `65%`,
        data: `<p><strong>Consumer Acknowledgement: </strong> Have the consumer(s) 
        sign and insert the date they have received the disclosure. This is the consumer 
        you are disclosing to. <br/><br/>
        Example: If you represent the Buyer, you are disclosing to the Seller. As a 
        result, the Seller must sign the disclosure.
        </p>`,
      },
    ],
  },
  {
    id: 1214,
    form: `disc-interest-buying`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-buying-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Brokerage Use Only: </strong> As per this section, a copy 
        of this form must be provided to your brokerage and be fully completed.
        </p>`,
      },
    ],
  },
  {
    id: 1221,
    form: `disc-interest-lease`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-lease-1.png",
    description: `<p>This disclosure must be given to the client before entering 
    into any rental or lease agreement with a licensee or their associate. Its 
    purpose is to inform the client of potential risks when a licensee has a 
    personal interest, such as conflicts of interest or unequal bargaining power 
    due to greater knowledge of property values, rental rates, and the market. The 
    client is encouraged to ask questions or seek independent advice if they have 
    concerns. See the bottom of the last page for definitions and exemptions for 
    this disclosure.
    </p>`,
    hotspots: [],
  },
  {
    id: 1222,
    form: `disc-interest-lease`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-lease-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Landlord/Tenant Name(s)/Address Information: </strong> 
        Insert either the Landlord's or Tenant's full name. The names refer to the 
        party you are disclosing to. Include the property address being leased or 
        rented. Add the legal description of the property.
        </p>`,
      },
      {
        x: `1%`,
        y: `20%`,
        data: `<p><strong>Licensee Information: </strong> Insert your name and 
        select the option below that applies to your situation in the transaction. 
        Depending on the selection, follow through to the indicated section in that 
        statement.<br/><br/>
        <strong>Definitions: </strong> Refer to the bottom of the last page of this
        document for the definitions of what an associate means.  
        </p>`,
      },
      {
        x: `1%`,
        y: `39%`,
        data: `<p><strong>Complete (if applicable): </strong> If applicable to your 
        situation, complete this section by inserting the name of the associate(s) 
        and your relationship to them. It is important to be as detailed as possible.
        </p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Part B - Licensee or Associate is the Tenant: 
        </strong> Complete this section if the transaction involves a licensee, or 
        an associate they represent, leasing or renting the property as a tenant.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Details of Lease/Rent:</strong> Complete 
        this section detailing the reason for the lease/rent by selecting the 
        appropriate option.
        </p>`,
      },
      {
        x: `1%`,
        y: `74%`,
        data: `<p><strong>Remuneration: </strong> If remuneration is being received 
        for this transaction, specify the amounts in dollars in the applicable 
        areas.
        </p>`,
      },
    ],
  },
  {
    id: 1223,
    form: `disc-interest-lease`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-lease-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Part C - Licensee or Associate is the Landlord: </strong> This 
        section is only applicable if the transaction involves a licensee or associate 
        leasing/renting the property as a landlord. Select the option that applies 
        to your situation.
        </p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Location/Date: </strong> Insert the geographical location 
        where you are signing from as well as the date of the disclosure.<br/><br/>
        <strong>Signature of Licensee/Witness: </strong> As indicated in this section, 
        sign the form and if a witness is present, have them sign the form as well.
        </p>`,
      },
      {
        x: `1%`,
        y: `72%`,
        data: `<p><strong>Consumer Acknowledgement: </strong> Have the consumer(s) 
        sign and insert the date they have received the disclosure. This section is 
        optional.
        </p>`,
      },
    ],
  },
  {
    id: 1224,
    form: `disc-interest-lease`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-interest-lease-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Brokerage Use Only: </strong> As per this section, a copy 
        of this form must be provided to your brokerage and be fully completed.
        </p>`,
      },
    ],
  },
  {
    id: 1231,
    form: `disc-unrep`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Additional/disc-unrep-1.png",
    description: `<p>This disclosure must be provided when a consumer has chosen 
    not to engage the services of a REALTOR® in a transaction. Its purpose is to 
    inform the consumer of the risks involved in being unrepresented. The consumer 
    is encouraged to ask questions or seek independent advice if they have concerns 
    about this disclosure or the risks involved. <br/>
    <strong>Important: </strong> Must be presented if the person will not be represented 
    by you before providing any services. Must  be explained and signed by REALTOR®.
    </p>`,
    hotspots: [],
  },
  {
    id: 1232,
    form: `disc-unrep`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Additional/disc-unrep-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `26%`,
        data: `<p><strong>Agent, Team, Team Member Name(s): </strong> Complete this 
        section by inserting your name and if applicable, the Team Name along with 
        any Team Member Name(s).<br/><br/>
        <strong>Brokerage Name: </strong> Insert the full name of the brokerage.<br/><br/>
        <strong>Signature/Date: </strong> As indicated in this section, sign the form 
        and insert the date of the disclosure.<br/><br/>
        <strong>Property Address: </strong> Add the property address being sold or 
        purchased. 
        </p>`,
      },
      {
        x: `1%`,
        y: `82%`,
        data: `<p><strong>Consumer Acknowledgement: </strong> Complete this 
        section by having the consumer(s) sign as well as insert the date they have 
        received the disclosure. 
        </p>`,
      },
    ],
  },
  {
    id: 1241,
    form: `general-release`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/general-release-1.png",
    description: `<p>This form provides written confirmation that the Buyer and 
    Seller release each other and their agents from obligations and claims, agree 
    the contract has ended, and instruct the deposit holder on where to pay the 
    funds. It should not be used when a Buyer rescinds their offer under the Home 
    Buyer Rescission Period regulation.<br/>
    <strong>Important: </strong>This form should only be used if all parties 
    agree to release the contract. If there is no agreement from all parties, the 
    form should not be used, and legal advice should be obtained.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the form. (far right of the page).
        </p>`,
      },
      {
        x: `1%`,
        y: `17%`,
        data: `<p><strong>Date of Release: </strong>Insert the date that this 
        release was prepared.
        </p>`,
      },
      {
        x: `1%`,
        y: `24%`,
        data: `<p><strong>Buyer(s)/Seller(s): </strong>Insert ALL Buyer(s) and 
        Seller(s) full names as they appear on the Purchase Contract.<br/><br/>
        <strong>Property Address: </strong>Insert the property address that 
        this release applies to.
        </p>`,
      },
      {
        x: `1%`,
        y: `34.5%`,
        data: `<p><strong>Purchase Contract Date: </strong>Insert the date of 
          the contract that this release applies to.
        </p>`,
      },
      {
        x: `1%`,
        y: `41%`,
        data: `<p><strong>Seller Release (1): </strong>Insert the designated agent(s) 
        and the name of the Brokerage representing the Seller. This is their 
        agreement to release these parties from the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `51%`,
        data: `<p><strong>Buyer Release (2): </strong>Insert the designated agent(s) 
        and the name of the Brokerage representing the Buyer. This is their 
        agreement to release these parties from the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Deposit Holder (3): </strong>Select the option that applies 
        to the transaction.
        <ol>
        <li>Select this if no deposit was paid</li>
        <li>Select this if a deposit was paid and complete the section below. The 
        first field represents the party that is holding the deposit. Secondly, 
        complete the amount of the deposit that each party will receive.
        </li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `75.5%`,
        data: `<p><strong>Legal Advice (4): </strong>Before signing, both the 
        Buyer and Seller acknowledge they've been advised to seek—and have had the 
        opportunity to obtain—independent legal advice satisfactory to them about: 
        (i) the legal effects of the release they are giving in paragraph 1 or 2 
        (as applicable); and (ii) the direction regarding payment of the deposit 
        set out in paragraph 3.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Buyer/Seller Initials: </strong>Have ALL of your clients 
        initial in the box that applies.
        </p>`,
      },
    ],
  },
  {
    id: 1242,
    form: `general-release`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/general-release-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the form. (far right of the page).
        </p>`,
      },
      {
        x: `1%`,
        y: `8.5%`,
        data: `<p><strong>General (5): </strong>This Release and Authorization 
        binds and benefits the Buyer/Seller and their agents, heirs, executors, 
        administrators, and assigns. Gender and singular/plural terms include 
        each other as context requires. It may be signed in counterparts and 
        delivered electronically—no original hard copy is required.
        </p>`,
      },
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>Buyer/Seller Signatures: </strong> Complete this section by 
        having all Buyers/Sellers sign along with their printed name. You may only 
        act as a witness for the signatures if you are present and watch them sign.
        By signing, all parties confirm their agreement to the General Release.</p>`,
      },
    ],
  },
  {
    id: 1251,
    form: `disc-conflict-interest`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-conflict-interests-1.png",
    description: `<p>This form is typically used when you represent 2 or more sets 
    of clients in a transaction and must release one or all. Most common scenarios 
    involve when you represent a Seller and your Buyer is interested in the listing 
    or when you have 2 sets of Buyers interested in the same property. The form 
    ensures your clients understand the conflict and agree on how to proceed.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>This: </strong> ...</p>`,
      },
    ],
  },
  {
    id: 1252,
    form: `disc-conflict-interest`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-conflict-interests-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>This: </strong> ...</p>`,
      },
    ],
  },
  {
    id: 1253,
    form: `disc-conflict-interest`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-conflict-interests-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>This: </strong> ...</p>`,
      },
    ],
  },
  {
    id: 1254,
    form: `disc-conflict-interest`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-conflict-interests-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `21%`,
        data: `<p><strong>This: </strong> ...</p>`,
      },
    ],
  },
  {
    id: 1261,
    form: `disc-referral-received`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/disc-referral-received.png",
    description: `<p>This form is used to inform clients when a REALTOR® is to 
    receive a referral payment. This ensures compliance with the Real Estate 
    Services Rules, such as when commission is shared with another brokerage or an 
    eligible individual. Disclosure should occur before a client enters into a 
    contract. While referral payments to unlicensed individuals is allowed, it is 
    important to know the rules and regulations surrounding these circumstances as 
    some restrictions do exist.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `12%`,
        data: `<p><strong>Date: </strong>Insert the date that the form is prepared.
        <br/><br/>
        <strong>Name of Client(s): </strong>Insert all client(s) full 
        legal names here.<br/><br/>
        <strong>Property Address: </strong>Insert the civic address of the 
        property the referral payment is being received for.
        </p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Agent Receiving Referral Payment Name: </strong>Insert the 
        name(s) of the agent receiving the referral payment. If a team, all team members 
        must be listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Payment Amount: </strong> Insert the percentage of 
        remuneration or the dollar amount of the payment that the REALTOR® intends 
        to receive.
        </p>`,
      },
      {
        x: `1%`,
        y: `64%`,
        data: `<p><strong>Party Providing Referral Payment: </strong> Insert the full 
        name of the Brokerage or unlicensed person who is providing the payment.
        </p>`,
      },
      {
        x: `1%`,
        y: `70%`,
        data: `<p><strong>Initials/Signatures: </strong> Ensure that all parties involved 
        sign/initial in their respective locations to acknowledge their receipt of 
        the disclosure.
        </p>`,
      },
    ],
  },
  {
    id: 1271,
    form: `fee-service-agreement`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-service-agreement-1.png",
    description: `<p>The Fee for Service Retainer Agreement allows Brokerages and 
    Agents to formally set out the terms for providing services to a client and 
    receiving payment. It also records the client's agreement regarding the 
    duration of the contract, the type of representation provided by the agent, 
    and their consent to the collection and use of personal information.
    </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the form. (far right of the page).
        </p>`,
      },
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Brokerage/Service Recipient(s): </strong>Complete this 
        section by inserting the full name of the Brokerage/Address who is 
        providing the services. Additionally, insert the names of all the persons 
        receiving the services.
        </p>`,
      },
      {
        x: `1%`,
        y: `27%`,
        data: `<p><strong>Designated Representative(s): </strong>Complete this 
        section by inserting the full name of the Designated Representative(s) 
        providing the services.
        </p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Contract Duration: </strong>Complete this section by 
        inserting the start and end dates of the contract. Ensure that this duration 
        is long enough to allow the services to be provided to the client.
        </p>`,
      },
      {
        x: `1%`,
        y: `38%`,
        data: `<p><strong>Existing Agency Confirmation: </strong>Check the box 
        that applies, indicating whether or not the agent has an agency relationship 
        with the service recipient.
        </p>`,
      },
      {
        x: `1%`,
        y: `69%`,
        data: `<p><strong>Signed, Sealed and Delivered: </strong>The date recorded is the 
        day the last party signs the form. For example, if one party signs on 
        September 9th and the other on September 14th, the official date is 
        September 14th. The date must only be inserted once the final signature is 
        made (including Managing Broker signature), and a copy of the fully executed 
        form must be given to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `74%`,
        data: `<p><strong>Signatures: </strong>Ensure all necessary signatures 
        are collected in this section to complete and confirm acceptance of the 
        agreement's terms.
        </p>`,
      },
    ],
  },
  {
    id: 1272,
    form: `fee-service-agreement`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-service-agreement-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `6%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the form. (far right of the page).
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Schedule A - Services to be Provided: </strong>Complete this section 
        by inserting the services that are being provided to the service recipient. 
        Be as detailed as possible so that it is clear what the agreed upon 
        services are.
        </p>`,
      },
      {
        x: `1%`,
        y: `89%`,
        data: `<p><strong>Service Recipient Initials: </strong>Have the service 
        recipient initial in the applicable box.
        </p>`,
      },
    ],
  },
  {
    id: 1273,
    form: `fee-service-agreement`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-service-agreement-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `6%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that 
        make up the form. (far right of the page).
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Schedule B - Fees for Services: </strong>Insert the fees 
        that are being charged for the services that are being provided to the 
        service recipient. This section should also include the terms for payment 
        and when the fees are due.
        </p>`,
      },
      {
        x: `1%`,
        y: `89%`,
        data: `<p><strong>Service Recipient Initials: </strong>Have the service 
        recipient initial in the applicable box.
        </p>`,
      },
    ],
  },
  {
    id: 1281,
    form: `PDS-res`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/PDS/PDS-res-1.png",
    description: `<p>The Property Disclosure Statement (PDS) allows sellers to 
    disclose the condition and history of a property, such as past damage, 
    repairs, or known defects. It helps buyers understand the property's status 
    and guides their due diligence. Sellers usually complete it before listing, 
    and buyers should review it early. For the PDS to be legally relied upon, 
    it must be referenced in the Contract of Purchase and Sale.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `28%`,
        data: `<p>This form helps protect Sellers by 
        documenting that they've shared all relevant property information with 
        the buyer. Sellers must answer truthfully and completely, disclosing 
        anything they would want to know as a buyer. However, under BC's “buyer 
        beware” principle, the PDS doesn't replace buyer due diligence—buyers 
        should verify details independently and seek professional inspections or 
        advice.
      </p>`,
      },
      {
        x: `1%`,
        y: `40%`,
        data: `<p><strong>Buyer Beware Principle: </strong> Buyers must conduct 
        their own investigations even after reviewing the PDS, as a Seller's 
        knowledge may be limited. They should seek additional information from the 
        Seller, local authorities, or professionals like inspectors. Sellers are 
        legally responsible for providing accurate and complete information, while 
        Buyers remain responsible for verifying details. Those assisting with the 
        PDS must ensure the Seller fully understands and answers each question, and 
        translation help should be used if needed to prevent misunderstandings.
        </p>`,
      },
    ],
  },
  {
    id: 1282,
    form: `PDS-res`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/PDS/PDS-res-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the statement.
        </p>`,
      },
      {
        x: `1%`,
        y: `10%`,
        data: `<p><strong>Date of Disclosure: </strong>Insert the date of 
        disclosure.
        </p>`,
      },
      {
        x: `1%`,
        y: `14.5%`,
        data: `<p><strong>Property Address: </strong>Insert the address of the 
        property that this disclosure applies to.
        </p>`,
      },
      {
        x: `1%`,
        y: `23%`,
        data: `<p><strong>Seller(s) Initials: </strong>Have all Sellers initial 
        the box corresponding to their answer for each question. Note that any 
        of the greyed out boxes are not an appropriate answer for that question.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Buyer/Seller Signatures: </strong> As with most other 
        pages within this form, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1283,
    form: `PDS-res`,
    page: `3`,
    imageURL: "../../images/BritishColumbia/forms/PDS/PDS-res-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Date of Disclosure/Pages: </strong>Insert the date of 
        disclosure as well as the total number of pages that make up the statement.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Buyer/Seller Signatures: </strong> As with most other 
        pages within this form, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1284,
    form: `PDS-res`,
    page: `4`,
    imageURL: "../../images/BritishColumbia/forms/PDS/PDS-res-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Date of Disclosure/Pages: </strong>Insert the date of 
        disclosure as well as the total number of pages that make up the statement.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Buyer/Seller Signatures: </strong> As with most other 
        pages within this form, have ALL of your clients initial in the box that 
        applies.</p>`,
      },
    ],
  },
  {
    id: 1285,
    form: `PDS-res`,
    page: `5`,
    imageURL: "../../images/BritishColumbia/forms/PDS/PDS-res-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Date of Disclosure/Pages: </strong>Insert the date of 
        disclosure as well as the total number of pages that make up the statement.
        </p>`,
      },
      {
        x: `1%`,
        y: `29%`,
        data: `<p><strong>Additional Comments: </strong> Add any additional comments 
        or details in this section. When providing additional information, Sellers 
        should reference the related question number to ensure clarity.
        </p>`,
      },
      {
        x: `1%`,
        y: `49%`,
        data: `<p>As per this statement, the Seller confirms that all information 
        is accurate to their current knowledge and agrees to disclose any 
        significant updates before closing. The Seller also acknowledges that the 
        PDS may be shared with potential buyers.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Seller Signatures: </strong> As per this section, have all 
        Sellers sign to complete their disclosure.
        </p>`,
      },
      {
        x: `1%`,
        y: `65%`,
        data: `<p><strong>Date/Buyer Signatures: </strong> As per this section, The 
        Buyer confirms they have received and understood the signed PDS. They are 
        encouraged to use it as a basis for their own investigation, inspect the 
        property (and hire a licensed inspector if desired), and acknowledge that 
        all measurements are approximate. Insert the date and have all Buyers sign 
        in the applicable section below.
        </p>`,
      },
    ],
  },
  {
    id: 1291,
    form: `fee-agreement-seller-pays`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-agreement-seller-pays-1.png",
    description: `<p>The Fee Agreement Seller Pays (Buyer Represented, Seller Not 
    Represented) form allows a Buyer's Brokerage to receive payment from an 
    Unrepresented Seller without creating an agency relationship. It's used when 
    the Buyer's Brokerage isn't being fully compensated by the Buyer and seeks 
    payment from the Seller instead. This form is typically used in For Sale by 
    Owner or mere posting situations and must be signed by the Buyer before being 
    presented to the Seller.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the agreement.
        </p>`,
      },
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Brokerage/Seller Name(s): </strong>Insert the full 
        Brokerage name and the Seller name(s).
        </p>`,
      },
      {
        x: `1%`,
        y: `30%`,
        data: `<p><strong>Property Address: </strong>Insert the full 
        civic address of the property that is being sold.
        </p>`,
      },
      {
        x: `1%`,
        y: `37%`,
        data: `<p><strong>Legal Description: </strong>Insert the full 
        legal description of the property that is being sold.
        </p>`,
      },
      {
        x: `1%`,
        y: `47%`,
        data: `<p><strong>Designated Agent(s): </strong>Insert the name(s) of the 
        designated agent(s) acting for the Buyer. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Buyer Name(s): </strong>Insert the full legal names of the 
        Buyer(s).
        </p>`,
      },
      {
        x: `1%`,
        y: `56%`,
        data: `<p><strong>Commission/Remuneration: </strong>Insert the full amount 
        of commission (excluding GST) as agreed upon between the Seller and the 
        Buyer's Brokerage.
        </p>`,
      },
      {
        x: `1%`,
        y: `60%`,
        data: `<p><strong>Agreement Expiry Date: </strong>Insert the date that this 
        agreement will expire.
        </p>`,
      },
    ],
  },
  {
    id: 1292,
    form: `fee-agreement-seller-pays`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-agreement-seller-pays-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the agreement.
        </p>`,
      },
    ],
  },
  {
    id: 1293,
    form: `fee-agreement-seller-pays`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-agreement-seller-pays-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the agreement.
        </p>`,
      },
      {
        x: `1%`,
        y: `9.5%`,
        data: `<p><strong>Signed, Sealed and Delivered: </strong>The date recorded is the 
        day the last party signs the agreement. For example, if one party signs on 
        September 9th and the other on September 14th, the official date is 
        September 14th. The date must only be inserted once the final signature is 
        made (including Managing Broker signature), and a copy of the fully executed 
        agreement must be given to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `25%`,
        data: `<p><strong>Signatures/Printed Names: </strong>Complete this section 
        by having all parties sign the agreement and insert their printed names in 
        the applicable areas. This will finalize the agreement and show that all 
        parties have agreed to the terms of the agreement.
        </p>`,
      },
    ],
  },
  {
    id: 1301,
    form: `fee-agreement-landlord-pays`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-agreement-landlord-pays-1.png",
    description: `<p>The Landlord's Fee Agreement (Tenant Represented, Landlord Not 
    Represented) form allows a Tenants Brokerage to receive payment from an 
    Unrepresented Landlord without creating an agency relationship. It's used when 
    the landlord isn't offering sufficient or any compensation to the Tenant's 
    Brokerage. The Tenant authorizes their REALTOR® to seek payment from the 
    Landlord, and the Landlord must be informed that paying this fee does not 
    establish an agency or fiduciary relationship.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the agreement.
        </p>`,
      },
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Brokerage/Landlord Name(s): </strong>Insert the full 
        Brokerage name and the Landlord name(s).
        </p>`,
      },
      {
        x: `1%`,
        y: `32%`,
        data: `<p><strong>Property Address: </strong>Insert the full 
        civic address of the property that is being leased.
        </p>`,
      },
      {
        x: `1%`,
        y: `37%`,
        data: `<p><strong>Legal Description: </strong>Insert the full 
        legal description of the property that is being leased.
        </p>`,
      },
      {
        x: `1%`,
        y: `47%`,
        data: `<p><strong>Designated Agent(s): </strong>Insert the name(s) of the 
        designated agent(s) acting for the Tenant. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Tenant Name(s): </strong>Insert the full legal names of the 
        Tenant(s).
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Commission/Remuneration: </strong>Insert the full amount 
        of commission (excluding GST) as agreed upon between the Landlord and the 
        Tenant's Brokerage.
        </p>`,
      },
      {
        x: `1%`,
        y: `90%`,
        data: `<p><strong>Initials: </strong>Have the Tenant and Landlord initial 
        in the applicable areas.
        </p>`,
      },
    ],
  },
  {
    id: 1292,
    form: `fee-agreement-landlord-pays`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Additional/fee-agreement-landlord-pays-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the agreement.
        </p>`,
      },
      {
        x: `1%`,
        y: `51%`,
        data: `<p><strong>Signed, Sealed and Delivered: </strong>The date recorded is the 
        day the last party signs the agreement. For example, if one party signs on 
        September 9th and the other on September 14th, the official date is 
        September 14th. The date must only be inserted once the final signature is 
        made (including Managing Broker signature), and a copy of the fully executed 
        agreement must be given to all parties.
        </p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Residency: </strong>The Landlord must confirm 
        their residency and citizenship status, since this affects tax obligations; 
        professional advice from a lawyer or accountant is recommended for accurate 
        handling.</p>`,
      },
      {
        x: `1%`,
        y: `62%`,
        data: `<p><strong>Signatures/Printed Names: </strong>Complete this section 
        by having all parties sign the agreement and insert their printed names in 
        the applicable areas. This will finalize the agreement and show that all 
        parties have agreed to the terms of the agreement.
        </p>`,
      },
    ],
  },
  {
    id: 1301,
    form: `tenant-agency-contract`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-1.png",
    description: `<p>The Tenant Agency Contract form is used to establish an agency 
    relationship between a Tenant and their REALTOR®. It's used when the Tenant 
    authorizes their REALTOR® to seek payment from the Landlord on their behalf.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13%`,
        data: `<p><strong>Information Page: </strong>This section provides guidance to 
        help parties understand, but it is **not part of the contract**. It explains 
        that the Tenant's Agency Exclusive Contract becomes legally binding once signed 
        and should be read carefully with all terms in writing. It highlights the 
        value of having the Tenant-Brokerage relationship in writing to clarify rights 
        and responsibilities, similar to a Landlord's listing contract. It also stresses 
        the importance of discussing brokerage compensation in detail. REALTORS® offer 
        professional assistance throughout the Leasing process—from identifying 
        properties and preparing offers to negotiating terms and arranging inspections.
        </p>`,
      },
    ],
  },
  {
    id: 1302,
    form: `tenant-agency-contract`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13.5%`,
        data: `<p><strong>Tenant Information: </strong>Insert the full legal names 
        of all Tenant(s). Double check your clients IDs to ensure accuracy. Insert the 
        address where they currently live.
        <br/><br/>
        <strong>Brokerage Information: </strong>Insert the full Brokerage 
        name as well as the other information requested in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Commencement Date: </strong>Insert the date that this contract 
        starts. Typically it is the same date as when it is signed/delivered. If all 
        parties agree that the date is to be a future date, insert that date. It cannot 
        be a date that is before the contract is signed/delivered.<br/><br/>
        <strong>Expiry Date: </strong>Insert the date that this contract expires. It's 
        important to note that this date is negotiable. Discuss the current market 
        conditions and Tenant's needs to help determine a reasonable expiry date.
        </p>`,
      },
      {
        x: `1%`,
        y: `52%`,
        data: `<p><strong>Market Area: </strong>Insert the market area(s) that the 
        Tenant is interested in. It can be more than one, depending on the Tenant's 
        needs.
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Designated Agent: </strong>Insert the name(s) of the 
        designated agent(s) acting for the Tenant. If a team, all team members must be 
        listed individually. If a PREC, then the REALTOR®'s name followed by 
        "Personal Real Estate Corporation" or "PREC" should be inserted.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1303,
    form: `tenant-agency-contract`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `24%`,
        data: `<p><strong>The Designated Agent's Duties: </strong>This section 
        outlines the Designated Agent's duties, including helping the Tenant find 
        suitable properties, notifying Landlords that they represent the Tenant, 
        and maintaining confidentiality. If the Tenant pursues an unlisted property, 
        the Agent may arrange a fee agreement with the Landlord without creating an 
        agency relationship. The Agent must also treat all brokerage clients fairly 
        and impartially.
        </p>`,
      },
      {
        x: `1%`,
        y: `46%`,
        data: `<p><strong>The Tenant's Responsibilities: </strong>This section 
        outlines the Tenant's responsibilities, including working exclusively with 
        the Designated Agent, sharing relevant property interests and financial 
        details, negotiating in good faith, and allowing their identity to be disclosed 
        unless otherwise directed. It also confirms that the Agent and 
        Brokerage are hired only for real estate services—not legal, financial, or 
        other professional advice. The Tenant acknowledges the Agent may 
        have limited property information and should conduct their own investigations, 
        while the Agent must still exercise reasonable care and skill.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1304,
    form: `tenant-agency-contract`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `7.5%`,
        data: `<p><strong>Remuneration: </strong>This section explains that before 
        making a lease offer, the Agent must inform the Tenant of any payment the 
        Landlord or Listing Brokerage will provide to the Tenant's Brokerage and 
        whether the Tenant owes any additional amount. The Brokerage's fee is payable 
        when the lease is registered, the Tenant takes possession, or occupies the 
        property, whichever comes first. The Brokerage must also disclose any other 
        remuneration it expects to receive related to the transaction.
        </p>`,
      },
      {
        x: `1%`,
        y: `15%`,
        data: `<p><strong>Remuneration Amount: </strong>Insert the remuneration amount agreed 
        upon between the Tenant and their Brokerage, usually based on monthly rent or a 
        flat fee and must be clearly stated. The Tenant should understand how and when 
        this payment is made and their responsibilities regarding it.
        </p>`,
      },
      {
        x: `1%`,
        y: `57%`,
        data: `<p><strong>Tenant Acknowledges: </strong>This section confirms that the 
        Designated Agent, not the Brokerage, is responsible for acting with reasonable 
        care and skill toward the Tenant. It also permits the Agent and Brokerage to 
        represent other clients, provided this doesn't create a prohibited dual agency. 
        If conflicts arise between clients, the Agent may need to stop representing 
        the Tenant. Additionally, the Agent and Brokerage are not required to share 
        confidential information obtained from other clients.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1305,
    form: `tenant-agency-contract`,
    page: `5`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `7%`,
        data: `<p><strong>Conflicts of Interest: </strong>This section explains that 
        if the Designated Agent represents both the Tenant and another party (such as a 
        Landlord or another Tenant) interested in the same property, they can 
        continue acting for only one party—with consent from both. If the Agent 
        continues representing the Tenant, specific procedures apply. If the Agent 
        stops representing the Tenant, the Brokerage may assign another REALTOR® or 
        refer the Tenant elsewhere, though the Tenant is not required to accept the 
        referral.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1306,
    form: `tenant-agency-contract`,
    page: `6`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `13.5%`,
        data: `<p><strong>Collect of Information: </strong>This section explains that 
        to fulfill their duties, REALTORS® must collect, use, and disclose certain personal 
        information, and the Tenant must give consent for this under privacy laws. By 
        signing the contract, the Tenant provides written consent for these actions. The 
        Privacy Notice and Consent form, reviewed at the start of the relationship, further 
        explains how personal information is handled and serves as additional acknowledgment 
        and consent from the Tenant.
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Miscellaneous Provisions: </strong>This section defines key 
        terms and provides important legal clarifications. It specifies definitions 
        such as the contract period, expiration date, offer to lease, and property. 
        It states that the contract is governed by British Columbia law, represents the 
        entire agreement between the parties, and is binding on their successors and 
        assigns. The contract also ends if the Tenant's Brokerage loses its license.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1307,
    form: `tenant-agency-contract`,
    page: `7`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `7.5%`,
        data: `<p><strong>Agreement: </strong>This section confirms that all parties 
        have read and understood the contract and agree to its terms. It remains 
        legally binding even if signed in separate copies, which together form one 
        agreement. If there are multiple Tenant(s), they are jointly and severally 
        liable, meaning each is fully responsible for the obligations under the 
        contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `29%`,
        data: `<p><strong>Contract Signed, Sealed, and Delivered Date: </strong>Insert 
         the date that the contract was signed, sealed, and delivered.  The date must 
         not be inserted until the last party signs. This date must be on or before 
         the commencement (start) date of the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `36%`,
        data: `<p><strong>Tenant Signature: </strong>Complete this 
        section by having all Tenant(s) sign the contract.  You may only act as a 
        witness for the Tenant(s) signature if you are present and watch them sign. 
        </p>`,
      },
      {
        x: `1%`,
        y: `49%`,
        data: `<p><strong>Managing Broker/Designated Agent Signatures: </strong> 
        Complete this section by having the Managing Broker/Designated Agent sign the 
        contract. Additionally, insert the full Brokerage name and the printed name of 
        the designated agent in their respective locations.
        </p>`,
      },
    ],
  },
  {
    id: 1308,
    form: `tenant-agency-contract`,
    page: `8`,
    imageURL:
      "../../images/BritishColumbia/forms/Tenant/tenant-agency-contract-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `19%`,
        data: `<p><strong>List of Services Provided to the Tenant: </strong>This Schedule is where 
        you  must outline the services you will provide to the Client. It should be 
        treated as a living document, evolving as you expand your list of 
        services.
        </p>`,
      },
      {
        x: `1%`,
        y: `86.5%`,
        data: `<p><strong>Tenant Initials: </strong>Have ALL of the Tenant(s) initial 
        in the box. 
        </p>`,
      },
    ],
  },
  {
    id: 1311,
    form: `assign-new-dev`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-1.png",
    description: `<p>This Contract is used 
    to transfer the rights and interests in a Presale Contract (the "Original Contract") 
    to a new Buyer (the "Assignee"). This Assignment allows the Assignee to assume all 
    the rights and obligations of the Original Contract, including the deposit, 
    the purchase price, and the terms and conditions of the contract. 
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `14%`,
        data: `<p><strong>Brokerage Information: </strong>Insert the Brokerage Name, 
        Brokerage Address & Brokerage Phone Number. Additionally, insert the name of 
        the Agent writing the contract and the MLS Number (if applicable).
        </p>`,
      },
      {
        x: `1%`,
        y: `24%`,
        data: `<p><strong>Assignor/Assignee Information: </strong>Insert the full legal 
        names of the Assignor (Seller of the Contract/Original Buyer of the Property) 
        and the Assignee (Buyer of the Contract/New Buyer of the Property).
        </p>`,
      },
      {
        x: `1%`,
        y: `42%`,
        data: `<p><strong>Developer Information: </strong>Complete this section by 
        filling in all of the Developer's information. The majority of this information 
        can be found on Page 1 of the Presale Contract.
        </p>`,
      },
      {
        x: `1%`,
        y: `50%`,
        data: `<p><strong>Disclosure Statement: </strong>Check the boxes that apply to the 
        Developer's Disclosure Statement. Insert the date of the Disclosure Statement. If 
        you check "No" to the disclosure statement being provided, ensure you insert a 
        subject into this Contract. If there are any amendments to the Disclosure Statement,
        check "Yes" and insert the date of the amendments.
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Deposit Protection: </strong>Check the Disclosure Statement 
        and check the box that applies with respect to the Deposit Protection.
        </p>`,
      },
      {
        x: `1%`,
        y: `61%`,
        data: `<p><strong>Contract of Purchase and Sale Details: </strong>Insert the 
        details of the Contract of Purchase and Sale that is being assigned. Some 
        important items to note are:
        <ol>
          <li>Amendments: Ask the Listing Agent if there are any</li>
          <li>Upgrades: Insert the amount. There should be an addendum for this</li>
          <li>Deposits Held By: This is usually a Lawyer and typically found on the 
          deposit page of the Presale Contract</li>
          <li>Deposit Secured by Bond?: Check the Disclosure Statement for this information 
          and check the box that applies</li>
          <li>Interest on Deposit Accrues to: Complete the box that applies based on who 
          is to receive the interest on the deposit</li>
          <li>Assignment Consent: It is commmon that consent is required. Insert 
          when consent is to be obtained by (typically X days after subject removal)</li>
          <li>Developer Fee: Indicate whether the fee is a percentage of the total price 
          (or just the lift) or a set fee. Complete the box that applies based on the 
          percentage or set amount</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1312,
    form: `assign-new-dev`,
    page: `2`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `8%`,
        data: `<p><strong>Property Details/Legal Description: </strong>Insert the full 
        address of the property being assigned, as well as the legal description.
        </p>`,
      },
      {
        x: `1%`,
        y: `25%`,
        data: `<p><strong>Terms: </strong>As per this statement, the person assigning 
        the Contract (the Assignor) is giving all of their rights and interests in 
        the Contract to the other person (the Assignee) starting on the Effective Date. 
        This transfer follows the terms and conditions listed below.
        </p>`,
      },
      {
        x: `1%`,
        y: `31%`,
        data: `<p><strong>Assignment Amount: </strong>Insert the amount of the 
        assignment. This amount should equal C (A + B) from the chart below.<br/><br/>
        The chart should be as follows:
        <ol class="letter-ol">
          <li> This amount is the Original Deposit paid under the Presale Contract</li>
          <li> This amount is the Profit (Lift) being paid to the Assignor. Note that 
          GST is typically applicable to this amount</li>
          <li> This amount is equal to A + B</li>
          <li> The Total Purchase Price = Original Purchase Price + Profit/Lift (B)</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `49%`,
        data: `<p><strong>Deposit: </strong>Insert the deposit the Assignee must pay as 
        part of this Contract. Typically, this amount should equal 
        the amount shown in 5.1 C. If it does not equal 5.1 C, you will need to state 
        when the balance of the deposit is due in 5.4 (top of next page). Ideally the 
        deposit is due AFTER obtaining developer consent.
        </p>`,
      },
      {
        x: `1%`,
        y: `58%`,
        data: `<p><strong>Deposit Holder: </strong>Insert who will be holding the 
        deposit. In this case, it is typically the Assignee's Lawyer.
        </p>`,
      },
      {
        x: `1%`,
        y: `66%`,
        data: `<p><strong>Terms & Conditions: </strong>Insert any addtional terms and 
        conditions that will form part of this Contract. Assignments typically have 
        very similar terms and conditions as standard sales (example: financing, 
        inspections, etc.). Ensure you are using terms "Assignor" and "Assignee" in 
        place of "Seller" and "Buyer" respectively within your clauses. If you require 
        an addendum, be sure you use the assignment addendum.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1313,
    form: `assign-new-dev`,
    page: `3`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-3.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `7.5%`,
        data: `<p><strong>Assignment Amount: </strong>As previously noted, if the 
        deposit does not equal 5.1 C, you will need to state when the balance of the 
        deposit is due in this section.
        </p>`,
      },
      {
        x: `1%`,
        y: `55%`,
        data: `<p><strong>Option: </strong>Select which option as noted in the chart 
        below (as well as top of next page) applies to this assignment.<br/>
        ***For Option A,B,C: The Deposit must equal the Total Assignment Amount<br/><br/>
        <ol>
          <li>Option A: The Assignment Amount (5.1 C) is paid to the Assignor upon 
          completion and property transfer occurs. Commission is also paid at this time.</li>
          <li>Option B: Once all conditions are met (not developer consent), the Assignment 
          Amount (5.1 C) is paid to the Assignor, 
          and the Assignee takes on all risks under the Contract. The Assignee does not get the 
          Assignment Amount back if the Developer fails to complete the project, unless that 
          failure is caused by the Assignor's breach. For this option, the deposit in 5.2 
          must equal the Assignment Amount in Section 5.1.</li>
          <li>Option C: After conditions are met, the Assignor receives the portion of 
          the Assignment Amount equal to their original deposits. The rest is held in 
          trust and released to the Assignor when the property transfer is submitted 
          for registration. If the transfer isn’t submitted by the deadline, the 
          Assignee can choose to have the Assignment Amount returned and end the 
          Assignment Agreement. For this option, the deposit in 5.2 
          must equal the Assignment Amount in Section 5.1.</li>
          <li>Option D: For this section, refer to the Transaction Checklists Section 
          for a variety of clauses that can be inserted on an addendum which will 
          detail when the Original Deposit, Lift, and Commission are to be paid.</li>
        </ol>
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1314,
    form: `assign-new-dev`,
    page: `4`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-4.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1315,
    form: `assign-new-dev`,
    page: `5`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-5.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>GST: </strong>As per this statement, the assignment amount 
        is inclusive of GST and the Assignor shall remit any GST payable, if applicable. 
        The Assignor may have to pay GST on the Lift portion and as a result, should 
        seek independent accountant advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1316,
    form: `assign-new-dev`,
    page: `6`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-6.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `9%`,
        data: `<p><strong>Agency Disclosure: </strong>Confirms the Assignor's 
        and Assignee's agency relationships with their REALTORS®. All agents, co-listings, 
        or Personal Real Estate Corporations must be identified, with extra details added 
        in the contract or addendum if needed.<br/><br/>
        Have your clients initial the boxes that apply to the transaction as well as 
        insert the designated agent(s) and Brokerage involved.
        <ul >
        <li><strong>A:</strong> Assignor acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>B:</strong> Assignee acknowledges having received the DORT form and acknowledges the 
          agency relationship with their designated agent and Brokerage.</li>
          <li><strong>C:</strong> In limited situations where dual agency is allowed, complete this 
          section with the appropriate information.</li>
          <li><strong>D:</strong> To be completed if the Assignor has an agency 
          relationship with a REALTOR® and the Assignee does not. Assignee initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
          <li><strong>E:</strong> To be completed if the Assignee has an agency 
          relationship with a REALTOR® and the Assignor does not. Assignor initials this box 
          to acknowledge receiving the Disclosure of Risks to Unrepresented Parties.</li>
        </ul>
        </p>`,
      },
      {
        x: `1%`,
        y: `59%`,
        data: `<p><strong>Acceptance Irrevocable: </strong>By initialing this section, 
        both the Assignor and Assignee confirm the contract is made “under seal.” The 
        Assignor cannot revoke (back out of) an accepted conditional offer until the 
        Assignee's conditions are removed or any contract options expire.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1317,
    form: `assign-new-dev`,
    page: `7`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-7.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `23%`,
        data: `<p><strong>Offer: </strong>Fully complete this section by 
        inserting the time and date of when this offer will be open for acceptance. 
        The offer or counter-offer remains open until the specified date and time unless 
        withdrawn in writing first. Once accepted in writing and notice is given, it 
        becomes a binding contract. If the offer is being countered, "counter-offer" 
        should be circled to indicate that it is a counter-offer. If new times are 
        needed, they should be amended and initialed each time a counter-offer is made.
        </p>`,
      },
      {
        x: `1%`,
        y: `34%`,
        data: `<p><strong>Assignee Signature/Printed Name: </strong>Complete this 
        section by having all Assignees sign the offer along with their printed name. 
        You may only act as a witness for the Assignees signature if you are present 
        and watch them sign.
        </p>`,
      },
      {
        x: `1%`,
        y: `50%`,
        data: `<p><strong>Assignee Declaration: </strong>The Assignee must initial in the 
        Yes or No box to declare whether they are a Canadian citizen or permanent 
        resident. If the Assignee is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `64%`,
        data: `<p><strong>Acceptance: </strong>Insert the date of when acceptance 
        occurred. By signing, the Assignor accepts the offer 
        subject to any conditions. Once conditions are met or waived, the Assignor must 
        complete the sale. Signatures should be witnessed where possible, and authority 
        must be shown if signing for another.</p>`,
      },
      {
        x: `1%`,
        y: `70%`,
        data: `<p><strong>Assignor Declaration: </strong>The Assignor must initial in the 
        "Resident of Canada" or "Non-Resident of Canada" box to declare whether they 
        are a resident of Canada. If the Assignor is unsure of their residency status, they 
        should seek legal advice.
        </p>`,
      },
      {
        x: `1%`,
        y: `76%`,
        data: `<p><strong>Assignor Signature/Printed Name: </strong>Complete this 
        section by having all Assignors sign the offer along with their printed name. 
        You may only act as a witness for the Assignors signature if you are present 
        and watch them sign.
        </p>`,
      },
    ],
  },
  {
    id: 1318,
    form: `assign-new-dev`,
    page: `8`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-8.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `33%`,
        data: `<p><strong>Assignee Information (Developer Consent): </strong>The 
        Developer is legally required (under REDMA and the Property Transfer Tax Act) 
        to collect a copy of the Assignment Agreement and certain personal information 
        about both the Assignor and Assignee before approving the assignment. You are 
        required to complete this section by inserting the requested information 
        regarding the Assignee.
        </p>`,
      },
      {
        x: `1%`,
        y: `87%`,
        data: `<p><strong>Initials: </strong>Have your clients initial the box that 
        applies.
        </p>`,
      },
    ],
  },
  {
    id: 1319,
    form: `assign-new-dev`,
    page: `9`,
    imageURL:
      "../../images/BritishColumbia/forms/Assignment/assign-new-dev-9.png",
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Property Information: </strong>Insert the full address 
        of the property that is being assigned.
        </p>`,
      },
      {
        x: `1%`,
        y: `43%`,
        data: `<p><strong>Assignor/Assignee Signatures & Printed Names: </strong>Have 
        all Assignors and Assignees sign along with their printed names. Additionally, 
        notate the date when these signatures were obtained.
        </p>`,
      },
      {
        x: `1%`,
        y: `73%`,
        data: `<p><strong>Developer Consent/Signature: </strong>Have 
        the Developer(s) sign and insert their printed name. Additionally, notate the date 
        when this signature was obtained. As noted above, the developer is signing to 
        confirm their consent, acknowledging receipt of the Developer's Assignment Fee, 
        and acknowledges Clause 9 above.
        </p>`,
      },
    ],
  },
  {
    id: 1321,
    form: `PNDS`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/PDS/PNDS-1.png",
    description: `<p>The Property No-Disclosure Statement (PNDS) form is used to 
    indicate that the Seller does not wish make any representations about the property's 
    condition. The Seller is still obligated to disclose any known defects but in some 
    situations such as estate sales, foreclosures, or tenanted properties, the Seller may 
    not be able to make any representations about the property's condition.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `19%`,
        data: `<p><strong>Date/Property Address: </strong>Insert the date of when this 
        form is being completed. Additionally, insert the property address that this 
        form is being completed for.
        </p>`,
      },
      {
        x: `1%`,
        y: `29%`,
        data: `<p><strong>Obligation to Disclose: </strong>As per this statement, the 
        Seller is not making any representations/warranties about the property's condition. 
        Ensure you have informed them of their obligations to disclose any known defects.
        </p>`,
      },
      {
        x: `1%`,
        y: `38%`,
        data: `<p><strong>Signatures: </strong>Have all Sellers sign and print their 
        names on this form to finalize the statement.
        </p>`,
      },
    ],
  },
  {
    id: 1331,
    form: `lockbox-auth`,
    page: `1`,
    imageURL: "../../images/BritishColumbia/forms/Listing/lockbox-1.png",
    description: `<p>This form is used to authorize the use of a lockbox on a 
    property. REALTORS® are required to have written consent from the Seller to use 
    a lockbox on a property so that other REALTORS® or 3rd party providers can 
    access the property. This form helps to ensure that the Seller is fully aware 
    of the risks and benefits of using a lockbox and who may have access to the 
    property in a given situation. It is important that you discuss the full details 
    of this form so that the Seller can make an informed decision.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `14.5%`,
        data: `<p><strong>Property/Brokerage/Agent/Seller Information: </strong>Complete 
        this section by inserting the full details of the Property Address, Brokerage, 
        Agent, and all Seller(s).
        </p>`,
      },
    ],
  },
  {
    id: 1332,
    form: `lockbox-auth`,
    page: `2`,
    imageURL: "../../images/BritishColumbia/forms/Listing/lockbox-2.png",
    hotspots: [
      {
        x: `1%`,
        y: `4%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the form.
        </p>`,
      },
      {
        x: `1%`,
        y: `23%`,
        data: `<p><strong>Date of Acknowledgement: </strong>Insert the date of when 
        this acknowledgement is being signed by the Seller(s).
        </p>`,
      },
      {
        x: `1%`,
        y: `30%`,
        data: `<p><strong>Seller Signatures: </strong> Complete this section by 
        having the Seller(s) sign and insert their printed name. You may only 
        act as a witness for the signature if you are present and watch them sign.
        By signing, the Seller confirms their agreement to allow the use of a 
        lockbox on the property.</p>`,
      },
    ],
  },
];

export default FormPageData;

/*
{
    id: 1061,
    form: `CPS-nothird`,
    page: `1`,
    imageURL:
      "../../images/BritishColumbia/forms/CPS-nothird/CPS-nothird-13.png",
    description: `<p>The Contract of Purchase and Sale (CPS) Not Hiring Agent form 
    is used to indicate that the Buyer or Seller does not wish to hire an agent.
     </p>`,
    hotspots: [
      {
        x: `1%`,
        y: `3%`,
        data: `<p><strong>Pages: </strong>Insert the total number of pages that make 
        up the contract.
        </p>`,
      },
      
    ],
  },



*/
